<template>
  <section
    id="service-item"
    class="service-item"
  >
    <v-progress-circular
      v-if="$fetchState.pending"
      indeterminate
      color="primary"
    />
    <template v-if="promotion.PromotionDataList && promotion.PromotionDataList.length > 0">
      <p
        v-show="pageNow === 1"
        class="title"
      >
        優惠活動
      </p>
      <div
        v-show="pageNow === 1"
        class="toggle-mask"
        :class="{'open': isToggleMaskOpen}"
      >
        <div
          v-for="singlePromotion in promotion.PromotionDataList"
          ref="promotionSection"
          :key="singlePromotion.PromotionId"
          class="page page-promotion"
        >
          <section class="promotion-description">
            <p
              v-if="singlePromotion.PromotionName"
              class="promotion-description-title"
            >
              {{ singlePromotion.PromotionName }}
            </p>
            <p
              v-if="singlePromotion.PromotionDescription"
              class="promotion-description-content"
            >
              {{ singlePromotion.PromotionDescription }}
            </p>
            <p
              v-if="singlePromotion.StartTimeStr && singlePromotion.EndTimeStr"
              class="promotion-description-time"
            >
              活動期間：{{ $dayjs(singlePromotion.StartTimeStr).format('YYYY/MM/DD HH:mm') }}~{{ $dayjs(singlePromotion.EndTimeStr).format('YYYY/MM/DD HH:mm') }}
            </p>
            <p
              v-if="!singlePromotion.IsCombineDiscountTicket"
              class="promotion-description-note"
            >
              ※本活動不適用與優惠券合併使用。
            </p>
          </section>
          <section class="promotion-list">
            <div
              v-for="promotionObj in singlePromotion.DetailList"
              :key="promotionObj.Id"
              class="promotion-option"
            >
              <p class="tag">
                <span>滿{{ setPriceFormat(promotionObj.Quantity) }}件</span>
              </p>
              <span class="price">每件折{{ setPriceFormat(promotionObj.DiscountAmount) }}元</span>
            </div>
          </section>
        </div>
        <div
          class="toggle-btn"
          @click="handleToggleMask"
        >
          <span>{{ isToggleMaskOpen ? '收合' : '查看更多' }}</span>
          <i
            class="icon-chevron-up"
            :class="{'rotate': !isToggleMaskOpen}"
          />
        </div>
      </div>
    </template>
    <template v-if="service.MinimumSpendSetting && service.MinimumSpendSetting.Dollar">
      <p
        v-show="pageNow === 1"
        class="title"
      >
        訂購說明
      </p>
      <div
        v-show="pageNow === 1"
        ref="limitSection"
        class="page page-limit"
      >
        <section>
          <div class="rule-wrap">
            <div class="rule">
              <img
                src="~/assets/image/warning.svg"
                alt="warning"
              >
              <div>最低消費金額 <span>${{ service.MinimumSpendSetting.Dollar }}</span></div>
            </div>
          </div>
        </section>
      </div>
    </template>
    <p class="title">
      {{ service.IsProductMode ? '訂購項目' : '預約項目' }}
    </p>
    <div
      v-show="pageNow === 1"
      class="page page-1"
    >
      <section
        v-if="isTCatLogistic || isKTJLogistic"
        class="option"
        :class="{
          'is-error': selectedData.packageType.checkValidate
        }"
      >
        <p class="label section-item-title">
          <span>
            <span class="required"> 寄送包裹種類 </span>
            <span
              v-if="selectedData.packageType.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.packageType.checkValidate.errorMessage }}
            </span>
          </span>
        </p>
        <v-select
          v-model="selectedData.packageType"
          class="select"
          :items="packageTypeOptions"
          placeholder="請選擇包裹種類"
          item-text="Description"
          item-value="Code"
          outlined
          return-object
          hide-details
        />
      </section>
      <section
        v-for="option in optionPriceGroup"
        :key="option.category_id"
        class="option price"
        :class="{
          'is-error': selectedData.price.error[option.category_id]
        }"
      >
        <p
          class="label section-item-title"
        >
          <span>
            <span
              v-show="option.category_name"
              :class="{
                'required': option.required
              }"
            >
              {{ option.category_name }}
            </span>
            <span
              v-if="selectedData.price.error[option.category_id]"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.price.error[option.category_id] }}
            </span>
          </span>
        </p>
        <p
          v-show="option.category_desc"
          class="desc section-item-desc"
        >
          {{ option.category_desc }}
        </p>
        <div
          v-for="price in option.price_option"
          :key="price.price_id"
          class="item cursorPointer"
          @click="clickSelectProduct(option, price)"
        >
          <div
            class="content"
            :class="{
              'has-image': price.Images.length > 0
            }"
          >
            <client-only>
              <div
                v-if="price.Images.length > 0"
                class="image-carousel"
              >
                <vue-tiny-slider v-bind="silderOptions">
                  <div
                    v-for="(image, index) in price.Images"
                    :key="index"
                    class="carousel"
                  >
                    <v-img
                      :src="getImageUrl(image.ThrumbUri)"
                      :lazy-src="getImageUrl(image.ThrumbUri)"
                      :alt="`${price.price_name}-${index + 1}`"
                      aspect-ratio="1"
                      contain
                    />
                  </div>
                </vue-tiny-slider>
              </div>
            </client-only>
            <section>
              <p class="font-h6">
                {{ price.price_name }}
              </p>
              <p
                v-if="price.price_desc"
                class="desc summary"
              >
                {{ price.price_desc }}
              </p>
              <span
                v-if="price.promotion_list.length > 0"
                class="promotion"
              >活動商品</span>
              <p class="price">
                <span>${{ getProductPrice(price, null, true) }}</span>
                <span
                  v-if="price.promotion_list.length > 0"
                  v-show="
                    promotion.selectedOptionByPromotionId[price.promotion_list[0]] &&
                      promotion.selectedOptionByPromotionId[price.promotion_list[0]].discount"
                  class="price-origin"
                >
                  ${{ getProductPrice(price) }}
                </span>
              </p>
              <p
                v-show="price.price_count > 0"
                class="selected-num"
              >
                已選擇數量：{{ price.price_count }}
              </p>
              <footer>
                <v-btn
                  class="btn"
                  depressed
                  rounded
                  color="primary"
                  @click="clickSelectProduct(option, price)"
                >
                  <i class="icon icon-plus" />
                  選購品項
                </v-btn>
              </footer>
            </section>
          </div>
        </div>
      </section>
      <section
        v-if="!isCommunity"
        class="option region"
        :class="{
          'is-error': selectedData.region.checkValidate
        }"
      >
        <p class="label section-item-title">
          <span>
            服務地區
            <span
              v-if="selectedData.region.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.region.checkValidate.errorMessage }}
            </span>
          </span>
        </p>
        <div class="select-group">
          <v-select
            v-model="selectedData.region.city"
            class="select"
            :items="cityList"
            placeholder="請選擇縣市"
            item-text="MainName"
            item-value="MainID"
            outlined
            return-object
            hide-details
            @change="changeCity"
          />
          <v-select
            v-model="selectedData.region.area"
            class="select"
            :items="regionList"
            placeholder="請選擇行政區"
            item-text="ParentName"
            item-value="ParentID"
            outlined
            return-object
            hide-details
            @change="changeArea"
          />
        </div>
      </section>
      <section
        v-if="service && service.serviceTimeType.id !== 9"
        class="option datetime"
        :class="{
          'is-error': selectedData.datetime.checkValidate
        }"
      >
        <p class="label section-item-title">
          <span>
            期望服務{{ service.serviceTimeType.id === 10 ? '時段' : '日期與時段' }}
            <span
              v-if="selectedData.datetime.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.datetime.checkValidate.errorMessage }}
            </span>
          </span>
        </p>
        <v-menu
          v-if="service.serviceTimeType.id !== 10"
          v-model="selectedData.datetime.dateOpen"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template #activator="{ on: { click } }">
            <v-select
              class="select"
              :value="selectDataDateTimeShow"
              :items="[selectDataDateTimeShow]"
              outlined
              readonly
              hide-details
              @click.native="click"
            />
          </template>
          <v-date-picker
            v-model="selectedData.datetime.date"
            locale="zh"
            :first-day-of-week="1"
            :title-date-format="date => $dayjs(date).format('M月D日 (dd)')"
            :day-format="date => $dayjs(date).format('D')"
            :allowed-dates="allowedDates"
            show-current
            @input="changeDateTimeDate"
          />
        </v-menu>
        <template v-if="selectedData.datetime.date && service.serviceTimeType.id !== 2">
          <!-- serviceTimeType.id: 1 【預設(早、中、晚)】 -->
          <v-btn-toggle
            v-if="service.serviceTimeType.id === 1"
            v-model="selectedData.datetime.defaultTime"
            class="default-time-mode"
            :mandatory="true"
          >
            <v-btn
              v-for="btn in selectedData.datetime.defaultModeList"
              :key="btn.value"
              class="time-mode-btn"
              :value="btn.value"
            >
              {{ btn.label }}
            </v-btn>
          </v-btn-toggle>
          <!-- serviceTimeType.id: 2 【無時間設定】 -->
          <!-- serviceTimeType.id: 3 【時間(小時)】 -->
          <div
            v-if="service.serviceTimeType.id !== 1"
            class="time-start time-select"
          >
            <v-select
              v-model="selectedData.datetime.timeStartHour"
              class="select"
              placeholder="請選擇小時"
              outlined
              return-object
              hide-details
              :disabled="!selectedData.datetime.date"
              :items="selectedData.datetime.timeStartHourOptions"
              @change="getServiceTimeStartMinute"
            />
            <span>時</span>
            <v-select
              v-model="selectedData.datetime.timeStartMinute"
              class="select"
              placeholder="請選擇分鐘"
              outlined
              return-object
              hide-details
              :disabled="!selectedData.datetime.date"
              :items="selectedData.datetime.timeStartMinuteOptions"
              @change="getSetviceTimeEndHour"
            />
            <span>分</span>
          </div>
          <div
            v-if="[4, 6, 8].indexOf(service.serviceTimeType.id) > -1"
            class="time-end time-select"
          >
            <!-- 時間範圍 -->
            <p>至</p>
            <v-select
              v-model="selectedData.datetime.timeEndHour"
              class="select"
              placeholder="請選擇小時"
              outlined
              return-object
              hide-details
              :disabled="!selectedData.datetime.date"
              :items="selectedData.datetime.timeEndHourOptions"
              @change="getServiceTimeEndMinute"
            />
            <span>時</span>
            <v-select
              v-model="selectedData.datetime.timeEndMinute"
              class="select"
              placeholder="請選擇分鐘"
              outlined
              return-object
              hide-details
              :disabled="!selectedData.datetime.date"
              :items="selectedData.datetime.timeEndMinuteOptions"
            />
            <span>分</span>
          </div>
        </template>
        <template v-if="service.serviceTimeType.id === 10">
          <v-btn-toggle
            v-model="selectedData.datetime.weekdayReservation"
            class="default-time-mode"
            :mandatory="true"
          >
            <v-btn
              v-for="mode in selectedData.datetime.weekdayOrWeekendModeList"
              :key="mode.value"
              class="time-mode-btn"
              :value="mode.value"
            >
              {{ mode.label }}
            </v-btn>
          </v-btn-toggle>
          <v-btn-toggle
            v-model="selectedData.datetime.defaultTime"
            class="default-time-mode"
            :mandatory="true"
          >
            <v-btn
              v-for="btn in selectedData.datetime.defaultModeList"
              :key="btn.value"
              class="time-mode-btn"
              :value="btn.value"
            >
              {{ btn.label }}
            </v-btn>
          </v-btn-toggle>
        </template>
        <div
          v-if="service.working_note || service.warning_note"
          class="time-note"
        >
          <template v-if="service.working_note">
            <p
              v-for="(i, index) in changeBr(service.working_note)"
              :key="'working_note' + index"
            >
              {{ i }}
            </p>
          </template>
          <template v-if="service.warning_note">
            <p
              v-for="(i, index) in changeBr(service.warning_note)"
              :key="'warning_note' + index"
            >
              {{ i }}
            </p>
          </template>
        </div>
      </section>
    </div>
    <div
      v-show="pageNow === 2"
      class="page page-2"
    >
      <section
        v-for="option in optionGroup"
        :key="option.category_id"
        class="option"
        :class="{
          'radio': option.category_option === 2,
          'checkbox': option.category_option === 4,
          'answer': option.category_option === 5,
          'is-error': selectedData.option.error[option.category_id]
        }"
      >
        <span class="label subtitle">
          <span>
            <span
              :class="{
                'required': option.required
              }"
            >
              <template v-if="option.category_name">
                {{ option.category_name }}
              </template>
              <template v-if="option.subTitle">
                ({{ option.subTitle }})
              </template>
            </span>
            <span
              v-if="selectedData.option.error[option.category_id]"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.option.error[option.category_id] }}
            </span>
          </span>
        </span>
        <span
          v-show="option.category_desc"
          class="desc text"
        >
          {{ option.category_desc }}
        </span>
        <!-- 單選 -->
        <v-radio-group
          v-if="option.category_option === 2"
          v-model="selectedData.option[option.category_id]"
          column
          class="group-radio"
          :hide-details="true"
          @change="checkOptionValidate(option)"
        >
          <v-radio
            v-for="opt in option.option"
            :key="opt.option_id"
            class="item"
            :value="opt.option_id"
          >
            <div
              slot="label"
              class="content"
              :class="{
                'has-image': opt.Images.length > 0
              }"
            >
              <client-only>
                <div
                  v-if="opt.Images.length > 0"
                  class="image-carousel"
                >
                  <vue-tiny-slider v-bind="silderOptions">
                    <div
                      v-for="(image, index) in opt.Images"
                      :key="'radio-carousel' + index"
                      class="carousel"
                    >
                      <v-img
                        :src="getImageUrl(image.ThrumbUri)"
                        :lazy-src="getImageUrl(image.ThrumbUri)"
                        aspect-ratio="1"
                        contain
                      />
                    </div>
                  </vue-tiny-slider>
                </div>
              </client-only>
              <section>
                <span class="label">
                  {{ opt.option_name }}
                </span>
                <p
                  v-if="opt.option_desc"
                  class="desc"
                >
                  {{ opt.option_desc }}
                </p>
              </section>
            </div>
          </v-radio>
        </v-radio-group>
        <!-- 複選 -->
        <div
          v-if="option.category_option === 4"
          class="item"
        >
          <v-checkbox
            v-for="opt in option.option"
            :key="opt.option_id"
            v-model="selectedData.option[option.category_id]"
            :value="opt.option_id"
            hide-details="auto"
            @change="checkOptionValidate(option)"
          >
            <div
              slot="label"
              class="content"
              :class="{
                'has-image': opt.Images.length > 0
              }"
            >
              <client-only>
                <div
                  v-if="opt.Images.length > 0"
                  class="image-carousel"
                >
                  <vue-tiny-slider v-bind="silderOptions">
                    <div
                      v-for="(image, index) in opt.Images"
                      :key="'checkbox-carousel' + index"
                      class="carousel"
                    >
                      <v-img
                        :src="getImageUrl(image.ThrumbUri)"
                        :lazy-src="getImageUrl(image.ThrumbUri)"
                        aspect-ratio="1"
                        contain
                      />
                    </div>
                  </vue-tiny-slider>
                </div>
              </client-only>
              <section>
                <span class="label">
                  {{ opt.option_name }}
                </span>
                <p
                  v-if="opt.option_desc"
                  class="desc"
                >
                  {{ opt.option_desc }}
                </p>
              </section>
            </div>
          </v-checkbox>
        </div>
        <!-- 問答 -->
        <div
          v-if="option.category_option === 5"
          class="item"
        >
          <div class="content">
            <v-textarea
              v-model="selectedData.option[option.category_id]"
              outlined
              maxlength="100"
              :rows="3"
              :auto-grow="true"
              :placeholder="option.category_tips"
              hide-details="auto"
              @input="checkOptionValidate(option)"
            />
          </div>
        </div>
      </section>
    </div>
    <div
      v-if="pageNow > 2"
      v-show="pageNow === 3"
      class="page page-3"
    >
      <section
        class="option user-info has-item-half"
        :class="{
          'is-error': personalInfo.checkValidate
        }"
        data-cy="page-checkout-user-info"
      >
        <span class="label has-button subtitle">
          <span>
            訂購人資料
            <span
              v-if="personalInfo.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ personalInfo.checkValidate.errorMessage }}
            </span>
          </span>
          <v-btn
            v-if="!$auth.loggedIn && !isGuestAgent"
            class="btn btn-login"
            outlined
            rounded
            color="primary"
            @click="memberLogin"
          >
            立即登入
          </v-btn>
        </span>
        <span
          v-if="!$auth.loggedIn && !isGuestAgent"
          class="desc login-tips text"
        >
          若您已是智生活會員，可點擊右側按鈕立即登入
        </span>
        <div class="item">
          <div>
            <p class="label required">
              姓名
            </p>
          </div>
          <p v-if="isAgentOrder">
            {{ personalInfo.AName }}
          </p>
          <v-form
            v-else
            ref="personalName"
            @submit.prevent
          >
            <v-text-field
              id="member-name"
              v-model="personalInfo.AName"
              label="請輸入姓名"
              single-line
              outlined
              maxlength="20"
              :rules="rules.personalInfo.nameRules"
              :hide-details="true"
              type="text"
              @input="checkPersonalInfoValidate(['personalName', 'personalPhone'])"
            />
          </v-form>
        </div>
        <div class="item">
          <p
            class="label"
            :class="{
              'required': !personalInfo.phoneIsSaved
            }"
          >
            電話
          </p>
          <p v-if="personalInfo.phoneIsSaved">
            {{ personalInfo.APhone }}
          </p>
          <v-form
            v-else
            ref="personalPhone"
            @submit.prevent
          >
            <v-text-field
              id="member-phone"
              v-model="personalInfo.APhone"
              label="請輸入電話"
              single-line
              outlined
              maxlength="10"
              :rules="rules.personalInfo.phoneRules"
              :hide-details="'auto'"
              :error-messages="personalInfo.phoneErrorMessage"
              type="text"
              @keypress.enter.prevent="savePhone"
              @input="checkPersonalInfoValidate(['personalName', 'personalPhone'])"
            >
              <v-btn
                slot="append"
                :loading="personalInfo.phoneIsSaving"
                class="btn-save"
                @click="savePhone"
              >
                驗證
              </v-btn>
            </v-text-field>
          </v-form>
        </div>
      </section>
      <!-- 寄 / 收件模式：一對一交付 -->
      <section
        v-if="service.serviceMultipContact && service.serviceMultipContact.id === 2"
        class="option recipient region"
        :class="{
          'is-error': selectedData.recipient.checkValidate
        }"
      >
        <span class="label has-button subtitle">
          <span>
            配達資訊
            <span
              v-if="selectedData.recipient.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.recipient.checkValidate.errorMessage }}
            </span>
          </span>
          <v-btn
            v-if="$auth.loggedIn"
            class="btn btn-select-address"
            outlined
            rounded
            color="primary"
            @click="contactDialogOpen"
          >
            選擇常用收件人
          </v-btn>
        </span>
        <v-form
          ref="serviceRegionRecipient"
          @submit.prevent
        >
          <div class="input">
            <p class="recipient-title required">
              收件人姓名
            </p>
            <v-text-field
              id="recipient-name"
              v-model="selectedData.recipient.name"
              label="請填寫收件人全名(你要寄給誰)"
              single-line
              outlined
              maxlength="12"
              :rules="[rules.recipient.nameRule]"
              :hide-details="true"
              type="text"
              @input="checkInputValidate('recipient', ['serviceRegionRecipient'], 'checkValidate')"
            />
          </div>
          <div class="input">
            <p class="recipient-title required">
              收件人電話
            </p>
            <v-text-field
              id="recipient-phone"
              v-model="selectedData.recipient.phone"
              label="請輸入收件人手機或市話(如：0912345678)"
              single-line
              outlined
              maxlength="15"
              :rules="[rules.recipient.phoneRules]"
              type="tel"
              @input="checkInputValidate('recipient', ['serviceRegionRecipient'], 'checkValidate')"
            />
          </div>
          <div class="select-group">
            <p class="recipient-title required">
              收件人地址
            </p>
            <v-select
              v-model="selectedData.recipient.city"
              class="select"
              :items="allCityList"
              placeholder="請選擇縣市"
              item-text="region_name"
              item-value="region_id"
              outlined
              return-object
              :hide-details="true"
              @change="changeAllCity"
            />
            <v-select
              v-model="selectedData.recipient.area"
              class="select"
              :items="allAreaList"
              placeholder="請選擇行政區"
              item-text="region_name"
              item-value="region_id"
              outlined
              return-object
              :hide-details="true"
              @change="changeAllArea"
            />
            <div class="input">
              <v-text-field
                id="recipient-address"
                v-model="selectedData.recipient.address"
                label="請輸入鄉里名稱、路(街)名、巷弄號及樓層"
                single-line
                outlined
                maxlength="40"
                :rules="[rules.recipient.addressRule]"
                :hide-details="true"
                type="text"
                @input="checkInputValidate('recipient', ['serviceRegionRecipient'], 'checkValidate')"
              />
            </div>
            <v-btn
              v-if="false"
              class="btn-prev btn"
              depressed
              color="primary"
              @click="checkFar"
            >
              確認偏遠加價
            </v-btn>
          </div>
        </v-form>
        <p class="notice addressNotice">
          請填寫收件人的地址(寄達地點)，司機會直接前往社區取件。
        </p>
        <v-checkbox
          v-if="$auth.loggedIn"
          v-model="selectedData.recipient.remember"
          label="將此次收件人資訊加入常用收件人"
        />
      </section>
      <section
        v-if="isCommunity"
        class="option region-community"
        :class="{
          'is-error': selectedData.region.communityCheckValidate
        }"
      >
        <span class="label subtitle">
          <span>
            <span class="required">
              服務位置
            </span>
            <span
              v-if="selectedData.region.communityCheckValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.region.communityCheckValidate.errorMessage }}
            </span>
          </span>
        </span>
        <v-form
          ref="regionCommunity"
          @submit.prevent
        >
          <v-select
            v-if="isCommunity"
            id="region-community"
            v-model="selectedData.region.community"
            class="select"
            :rules="[rules.region.communityRule]"
            :items="communitySelectList"
            placeholder="請選擇社區"
            item-disabled="isDisabled"
            item-text="showName"
            item-value="TabletId"
            return-object
            :hide-details="true"
            outlined
            @change="checkInputValidate('region', ['regionCommunity'], 'communityCheckValidate')"
          />
          <v-select
            v-if="multiAddress.show"
            id="community-address"
            v-model="selectedData.region.communityAddress"
            class="select"
            :rules="[rules.region.addressRule]"
            :items="multiAddress.list"
            placeholder="請選擇地址"
            item-disabled="isDisabled"
            item-text="showName"
            item-value="Road"
            return-object
            :hide-details="true"
            outlined
            @change="checkInputValidate('region', ['regionCommunity'], 'communityCheckValidate')"
          />
        </v-form>
        <div
          v-if="selectedData.region.community.TabletId && !multiAddress.show"
          class="item"
        >
          <p class="label">
            地址
          </p>
          <p>{{ selectedData.region.community.PostalCode }} {{ selectedData.region.community.showAddress }}</p>
        </div>
        <div
          v-else-if="selectedData.region.communityAddress && multiAddress.show"
          class="item"
        >
          <p class="label">
            地址
          </p>
          <p>{{ selectedData.region.community.PostalCode }} {{ selectedData.region.communityAddress.showAddress }}</p>
        </div>
        <!-- 2/25 15:00後電聯取件開始收費 PayForContactFlag true -->
        <div v-if="isKTJLogistic && alreadySelectedCommunity && selectedData.region.community.PayForContactFlag">
          <template v-if="selectedData.region.community.HasContactFlag">
            <p class="notice">
              ※由於您的社區管理室無法寄放包裹，司機將在抵達社區後與您電話聯繫並約在社區門口碰面，而採用電聯服務物流商須加收服務費${{ contactServicePriceTotal }}，感謝配合
            </p>
          </template>
          <template v-else>
            <v-checkbox
              v-model="selectedContactService"
              class="checkbox"
              label="我不想要寄放包裹在管理室，請司機抵達社區後電話聯繫我，我們約在社區門口碰面"
              :hide-details="true"
            />
            <p class="notice checkbox-notice">
              ※若使用電聯服務物流商須加收服務費${{ contactServicePriceTotal }}
            </p>
          </template>
        </div>
        <!-- 2/25 15:00前電聯取件尚不收費 PayForContactFlag false -->
        <div v-if="isKTJLogistic && selectedData.region.community.HasContactFlag && !selectedData.region.community.PayForContactFlag">
          <p class="notice">
            ※當前社區管理室無法寄放包裹，請親自將包裹交給快遞，快遞將在抵達社區前與您電話聯繫
          </p>
        </div>
        <!-- 速洗樂電聯取件-->
        <!-- 服務是否開放電聯 && 已選擇社區  -->
        <div v-if="service.IsNeedCheckContactPickUpFee && alreadySelectedCommunity">
          <!-- >>> 強制電聯 -->
          <template v-if="selectedData.region.community.HasContactFlag">
            <!-- 電聯要收費 -->
            <p
              v-if="uWashContactServicePriceTotal > 0"
              class="notice"
            >
              ※由於您的社區管理室無法寄放，收件人員將與您電話聯繫並約在社區門口碰面收件，而使用電聯服務須加收服務費${{ uWashContactServicePriceTotal }}，感謝配合
            </p>
            <!-- 電聯不收費 -->
            <p
              v-else
              class="notice"
            >
              ※由於您的社區管理室無法寄放，收件人員將與您電話聯繫並約在社區門口碰面收件
            </p>
          </template>
          <!-- >>> 不強制電聯 -->
          <template v-else>
            <v-checkbox
              v-model="contactPickupChecked"
              class="checkbox"
              label="不寄放管理室，請收件人員與我聯繫並約在社區門口碰面收件"
              :hide-details="true"
            />
            <p
              v-if="uWashContactServicePriceTotal > 0"
              class="notice checkbox-notice"
            >
              ※若使用電聯服務須加收服務費${{ uWashContactServicePriceTotal }}
            </p>
          </template>
        </div>
      </section>
      <section
        v-else
        class="option region has-item-half"
        :class="{
          'is-error': selectedData.region.addressCheckValidate
        }"
        data-cy="page-checkout-service-info"
      >
        <span class="label has-button subtitle">
          <span>
            {{ service.IsProductMode ? '訂購資訊' : '服務資訊' }}
            <span
              v-if="selectedData.region.addressCheckValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.region.addressCheckValidate.errorMessage }}
            </span>
          </span>
          <v-btn
            v-if="$auth.loggedIn"
            class="btn btn-select-address"
            outlined
            rounded
            color="primary"
            @click="regionDialog.open = true;logInfoPageGaEvent('click_選擇常用地址')"
          >
            選擇常用地址
          </v-btn>
        </span>
        <div class="syncBuyerInfoCheckbox">
          <v-checkbox
            v-if="!isAgentOrder"
            v-model="syncBuyerInfo"
            class="checkbox"
            label="同訂購人資料"
            :hide-details="true"
            :disabled="!personalInfo.AName && !personalInfo.APhone"
          />
        </div>
        <div class="item-wrapper">
          <div class="item item-half item-half-start">
            <p class="label required">
              姓名
            </p>
            <v-form
              ref="serviceRegionPersonalName"
              @submit.prevent
            >
              <v-text-field
                id="service-region__name"
                v-model="selectedData.region.name"
                class="input"
                label="請輸入姓名"
                single-line
                outlined
                maxlength="20"
                :rules="[rules.region.nameRule]"
                :hide-details="true"
                type="text"
                @input="checkInputValidate('region', ['serviceRegionPersonalName', 'serviceRegionPersonalPhone', 'serviceRegionAddress'], 'addressCheckValidate')"
              />
            </v-form>
          </div>
          <div class="item item-half item-half-end">
            <p class="label required">
              電話
            </p>
            <v-form
              ref="serviceRegionPersonalPhone"
              @submit.prevent
            >
              <v-text-field
                id="service-region__phone"
                v-model="selectedData.region.phone"
                class="input"
                label="請輸入電話"
                single-line
                outlined
                maxlength="15"
                :rules="[rules.region.phoneRules]"
                type="tel"
                @input="checkInputValidate('region', ['serviceRegionPersonalName', 'serviceRegionPersonalPhone', 'serviceRegionAddress'], 'addressCheckValidate')"
              />
            </v-form>
          </div>
        </div>
        <div class="item">
          <p class="label required">
            {{ service.IsProductMode ? '收件地址' : '服務位置' }}
          </p>
          <div class="select-group">
            <v-select
              id="service-region__city"
              v-model="selectedData.region.city"
              class="select"
              :items="cityList"
              placeholder="請選擇縣市"
              item-text="MainName"
              item-value="MainID"
              outlined
              return-object
              :hide-details="true"
              @change="changeCity"
            />
            <v-select
              id="service-region__area"
              v-model="selectedData.region.area"
              class="select"
              :items="regionList"
              placeholder="請選擇行政區"
              item-text="ParentName"
              item-value="ParentID"
              outlined
              return-object
              :hide-details="true"
              @change="changeArea"
            />
            <v-form
              ref="serviceRegionAddress"
              class="input"
              @submit.prevent
            >
              <v-text-field
                id="service-region__address"
                v-model="selectedData.region.address"
                label="請輸入詳細地址"
                single-line
                outlined
                maxlength="70"
                :rules="[rules.region.addressRule]"
                :hide-details="true"
                type="text"
                @input="checkInputValidate('region', ['serviceRegionPersonal', 'receiptRegionPhone', 'serviceRegionAddress'], 'addressCheckValidate')"
              />
            </v-form>
          </div>
          <!-- 服務開放電聯 && 地址模式 -->
          <div v-if="service.IsNeedCheckContactPickUpFee && isAddressMode">
            <v-checkbox
              v-model="contactPickupChecked"
              class="checkbox"
              label="不寄放管理室，請收件人員與我聯繫並約在社區門口碰面收件"
              :hide-details="true"
            />
            <p
              v-if="uWashContactServicePriceTotal > 0"
              class="notice checkbox-notice"
            >
              ※若使用電聯服務須加收服務費${{ uWashContactServicePriceTotal }}
            </p>
          </div>
        </div>
      </section>
      <section
        class="option item-detail"
        data-cy="page-checkout-order-detail"
      >
        <span class="label subtitle">
          項目明細
        </span>
        <div class="item title">
          <p class="label">
            {{ service.service_title }}
          </p>
        </div>
        <!-- 訂購項目 -->
        <div class="item">
          <p class="label subLabel">
            訂購項目
          </p>
          <template v-if="getServiceSelectedPrice().length > 0">
            <div
              v-for="option in getServiceSelectedPrice()"
              :key="option.id"
              class="item price removePaddingTop"
            >
              <div class="content">
                <template v-for="price in option.options">
                  <template v-if="price.ProductInfo && (price.price_count > 0)">
                    <p
                      v-for="sku in price.ProductInfo.Skus.filter(v => (v.num > 0))"
                      :key="sku.SkuId"
                    >
                      <span>{{ price.price_name }}{{ getSelectedSkuNameJoin(price, sku).length > 0 ? '/' : '' }}{{ getSelectedSkuNameJoin(price, sku) }} x {{ sku.num }}</span>
                      <span class="price">$ {{ setPriceFormat(sku.Price * sku.num) }}</span>
                    </p>
                  </template>
                  <p
                    v-else-if="price.price_count > 0"
                    :key="price.price_id"
                  >
                    <span>{{ price.price_name }} X {{ price.price_count }}</span>
                    <span class="price">${{ setPriceFormat(price.price * price.price_count) }}</span>
                  </p>
                </template>
                <!-- 顯示物流電聯品項 -->
                <template v-if="contactFlagPriceOptionList.length > 0">
                  <p
                    v-for="priceInfo in contactFlagPriceOptionList"
                    :key="priceInfo.id"
                  >
                    <span>{{ priceInfo.PriceName }} X {{ priceInfo.PriceCount }}</span>
                    <span class="price">${{ setPriceFormat(priceInfo.Price * priceInfo.PriceCount) }}</span>
                  </p>
                </template>
                <!-- 顯示速喜樂電聯品項 -->
                <template v-if="showContactFeeInOptionList">
                  <p
                    v-for="priceInfo in uWashContactFlagPriceOptionList"
                    :key="priceInfo.id"
                  >
                    <span>{{ priceInfo.PriceName }} X {{ priceInfo.PriceCount }}</span>
                    <span class="price">${{ setPriceFormat(priceInfo.Price * priceInfo.PriceCount) }}</span>
                  </p>
                </template>
              </div>
            </div>
          </template>
        </div>
        <!-- /訂購項目 -->
        <!-- 優惠折抵 -->
        <div
          v-if="showDiscount"
          class="item price discountBlock"
        >
          <p class="label subLabel">
            優惠折抵
          </p>
          <!-- 優惠活動 -->
          <div
            v-if="Object.values(promotion.selectedOptionByPromotionId).length > 0 && Object.values(promotion.selectedOptionByPromotionId)[0].totalCount"
            class="content"
          >
            <p
              v-for="(singlePromotion, key) in promotion.selectedOptionByPromotionId"
              :key="key"
            >
              <template v-if="singlePromotion.discount">
                <span>滿{{ singlePromotion.discount.Quantity }}件以上每件折扣${{ setPriceFormat(singlePromotion.discount.DiscountAmount) }}</span>
                <span class="price">-${{ setPriceFormat(singlePromotion.totalCount * singlePromotion.discount.DiscountAmount) }}</span>
              </template>
            </p>
          </div>
          <!-- 折扣碼 -->
          <div
            v-if="selectedData.discount.code.isUse && selectedData.discount.code.detail && selectedData.discount.code.detail.DiscountAmount && selectedData.discount.code.detail.OrderActivityType === 2"
            class="content"
          >
            <p>
              <span v-if="selectedData.discount.code.detail.DiscountRule.DiscountAmount">滿 {{ selectedData.discount.code.detail.DiscountRule.MinimumConsumptionAmount }} 折扣 ${{ setPriceFormat(selectedData.discount.code.detail.DiscountRule.DiscountAmount) }}</span>
              <span v-if="selectedData.discount.code.detail.DiscountRule.DiscountPercent">滿 {{ selectedData.discount.code.detail.DiscountRule.MinimumConsumptionAmount }} 打 {{ selectedData.discount.code.detail.DiscountRule.DiscountPercent }} 折</span>
              <span class="price">-${{ setPriceFormat(selectedData.discount.code.detail.DiscountAmount) }}</span>
            </p>
          </div>
          <!-- 推薦優惠 -->
          <div
            v-if="selectedData.discount.code.isUse && selectedData.discount.code.detail.OrderActivityType === 1"
            class="content"
          >
            <p>
              <span v-if="selectedData.discount.code.detail.DiscountRule.DiscountAmount">滿 {{ selectedData.discount.code.detail.DiscountRule.MinimumConsumptionAmount }} 折扣 ${{ setPriceFormat(selectedData.discount.code.detail.DiscountRule.DiscountAmount) }}</span>
              <span v-if="selectedData.discount.code.detail.DiscountRule.DiscountPercent">滿 {{ selectedData.discount.code.detail.DiscountRule.MinimumConsumptionAmount }} 打 {{ selectedData.discount.code.detail.DiscountRule.DiscountPercent }} 折</span>
              <span class="price">-${{ setPriceFormat(selectedData.discount.code.detail.DiscountAmount) }}</span>
            </p>
          </div>
          <!-- 優惠券 -->
          <div
            v-if="ticketAmount > 0"
            class="content"
          >
            <p>
              <span>{{ selectedData.discount.ticket.detail.Name }}</span>
              <span class="price">-${{ setPriceFormat(ticketAmount) }}</span>
            </p>
          </div>
          <!-- 紅利點數 -->
          <div
            v-if="bonusAmount > 0"
            class="content"
          >
            <div class="info-wrap">
              <div class="info-wrap__bonus">
                <span>使用{{ bonusAmount }}點折抵${{ setPriceFormat(bonusAmount) }}</span>
                <span
                  v-if="enterpriseCoinDiscountAvailable"
                  class="info-wrap__bonus__enterprise"
                >(內含企業夥伴點數{{ selectedData.discount.bonus.point.CanUseEnterpriseAmount }}點)</span>
              </div>
              <span class="price">-${{ setPriceFormat(bonusAmount) }}</span>
            </div>
          </div>
        </div>
        <!-- /優惠折抵 -->
        <template v-if="selectedData.price.totalPrice > 0">
          <div class="item price total-price removeMarginBottom">
            <p class="label">
              總計：<span class="price total-price">${{ setPriceFormat(totalPrice) }}</span>
            </p>
          </div>
        </template>
        <template v-if="service.serviceTimeType.id !== 9">
          <div class="item price send-day">
            <p class="label">
              期望時間：<span class="price">{{ getServiceSelectedTime(service.serviceTimeType.id) }}</span>
            </p>
          </div>
        </template>
        <template v-if="false && far.SendDays > 0">
          <div class="item price send-day">
            <div class="content">
              <p>
                <span>預估配達天數：</span>
                <span class="price">{{ far.SendDays }}個工作天</span>
              </p>
            </div>
          </div>
        </template>
      </section>
      <card-code-discount
        v-if="!isQuotationMode"
        ref="codeDiscount"
        class="option code-discount"
        :can-use-enterprise-coin="service && service.DiscountCodeSetting && service.DiscountCodeSetting.IsCanUseEnterpriseCoin"
        :total-amount="selectedData.price.totalPrice"
        :can-use-bonus-amount="canUseBonusAmount"
        :bonus-amount="bonusAmount"
        :discount-data="selectedData.discount"
        :service-id="serviceId"
        :service-type-id="service.type_id"
        :has-promotion="service.has_promotion"
        :promotion="promotion"
        :promotion-discount-amount="getTotalPromotionDiscount ()"
        @memberLogin="memberLogin"
        @openSelectTicket="openDialogDiscount(true)"
        @updateDiscountDataHandler="updateDiscountDataHandler"
      />
      <section
        v-if="getServiceSelectedOption().length > 0"
        class="option order-option"
        data-cy="page-checkout-order-option"
      >
        <span class="label subtitle">
          其他選項
        </span>
        <div
          v-for="option in getServiceSelectedOption()"
          :key="option.category_id"
          class="item"
        >
          <p class="label">
            {{ option.title }}
          </p>
          <p
            v-for="(val, index) in option.value"
            :key="index"
          >
            {{ val.label }}
          </p>
        </div>
      </section>
      <section
        v-if="canUsePaymentListByPrice.length > 0"
        class="option payment"
        data-cy="page-checkout-payment-type"
      >
        <span class="label subtitle" :class="{ 'is-error': payment.checkValidate === false && selectedData.payment === 1 }">
          付款方式
          <p v-if="payment.checkValidate === false  && selectedData.payment === 1" class="error-message">
            <i class="icon-alert-circle"></i>
            {{ payment.errorMessage }}
          </p>
        </span>
        <span
          v-if="selectedData.payment === 2"
          class="desc text"
        >
          訂購後請於訂單詳情查詢轉帳資訊，並以網路ATM或至ATM櫃員機完成繳費。
        </span>
        <v-radio-group
          v-model="selectedData.payment"
          :hide-details="true"
        >
          <v-radio
            v-for="singlePayment in canUsePaymentListByPrice"
            :key="singlePayment.PaymentTypeId"
            :value="singlePayment.PaymentTypeId"
          >
            <div class="label d-flex align-center justify-space-between flex-grow-1" slot="label">
              <p
                v-if="singlePayment.PaymentTypeId !== 8 && singlePayment.PaymentTypeId !== 5"
                class="mb-0 flex-shrink-0"
              >
                {{ singlePayment.PaymentTypeName }}
              </p>
              <img
                v-if="singlePayment.PaymentTypeId === 5"
                src="@/assets/image/payment/plus-pay.svg"
                alt="plus-pay"
              >
              <img
                v-if="singlePayment.PaymentTypeId === 8"
                src="@/assets/image/payment/apple-pay.svg"
                alt="apple-pay"
              >
              <v-btn
                v-if="singlePayment.PaymentTypeId === 1 && selectedData.payment === 1 && creditCardSelectorDialog.cardList.length > 0"
                class="btn"
                depressed
                plain
                @click="creditCardSelectorDialog.open = true"
              >
                <p
                  v-if="creditCardSelectorDialog.selectedCard"
                  class="mb-0"
                >
                  {{ issueBankText }}
                  <span class="number">*{{ creditCardSelectorDialog.selectedCard.LastFour|| ''  }}</span>
                </p>
                <p
                  v-else
                  class="mb-0"
                >
                  其他
                </p>
                <i class="icon icon-chevron-right arrow" />
              </v-btn>
            </div>
          </v-radio>
        </v-radio-group>
      </section>
      <section
        v-if="service.InvoiceSetting.InvoiceResponsibilityId === 1"
        class="option receipt"
        :class="{
          'is-error': selectedData.receipt.checkValidate
        }"
        data-cy="page-checkout-invoice-type"
      >
        <span class="label subtitle">
          <span>
            發票資訊
            <span
              v-if="selectedData.receipt.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              {{ selectedData.receipt.checkValidate.errorMessage }}
            </span>
          </span>
        </span>
        <div>
          <p
            v-if="service && service.ServiceProcessMode && service.ServiceProcessMode.Mode === 'FamiLogistic'"
            class="desc"
          >
            提醒您，本服務發票將由供應商進行開立且隨商品附上，預設開立類型為個人電子發票。若您有需要開立企業發票請於備註標示統一編號，感謝配合。
          </p>
          <template v-else>
            <div class="item">
              <p class="label required">
                發票種類
              </p>
              <v-select
                id="receipt__type"
                v-model="selectedData.receipt.type"
                class="select"
                :items="selectedData.receipt.typeOptions"
                placeholder="請選擇發票類型"
                :hide-details="true"
                item-text="label"
                outlined
              />
            </div>
            <div
              v-show="selectedData.receipt.type === 1"
              class="item"
            >
              <p class="label required">
                E-mail
              </p>
              <v-form
                ref="receiptMail"
                @submit.prevent
              >
                <v-text-field
                  id="receipt__personal-email"
                  v-model="selectedData.receipt.mail"
                  class="input"
                  label="請輸入E-mail"
                  single-line
                  outlined
                  maxlength="40"
                  :rules="[rules.receipt.mailRule]"
                  :hide-details="true"
                  type="email"
                  @input="checkInputValidate('receipt', ['receiptMail'])"
                />
              </v-form>
            </div>
            <div
              v-show="selectedData.receipt.type === 1"
              class="item address"
            />
            <div
              v-show="selectedData.receipt.type === 2"
              class="item"
            >
              <p class="label required">
                E-mail
              </p>
              <v-form
                ref="receiptCompanyMail"
                @submit.prevent
              >
                <v-text-field
                  id="receipt__company-mail"
                  v-model="selectedData.receipt.companyMail"
                  class="input"
                  label="請輸入E-mail"
                  single-line
                  outlined
                  maxlength="40"
                  :rules="[rules.receipt.companyMailRule]"
                  :hide-details="true"
                  type="email"
                  @input="checkInputValidate('receipt', ['receiptCompanyMail', 'receiptIdNumber'])"
                />
              </v-form>
            </div>
            <div
              v-show="selectedData.receipt.type === 2"
              class="item"
            >
              <p class="label required">
                公司統一編號
              </p>
              <v-form
                ref="receiptIdNumber"
                @submit.prevent
              >
                <v-text-field
                  id="receipt__IdNumber"
                  v-model="selectedData.receipt.idNumber"
                  class="input"
                  label="請輸入公司統一編號"
                  single-line
                  outlined
                  maxlength="8"
                  :rules="[rules.receipt.idNumberRequired, rules.receipt.idNumberFormat, rules.receipt.idNumberValidate]"
                  :hide-details="true"
                  type="tel"
                  @input="checkInputValidate('receipt', ['receiptCompanyMail', 'receiptIdNumber'])"
                />
              </v-form>
            </div>
            <div
              v-show="selectedData.receipt.type === 3"
              class="item"
            >
              <p class="label">
                捐贈單位
              </p>
              <v-select
                id="receipt__donate"
                v-model="selectedData.receipt.donate"
                class="select"
                :items="selectedData.receipt.donateOptions"
                placeholder="請選擇捐贈單位"
                item-text="unitName"
                item-value="NPOBAN"
                :hide-details="true"
                outlined
              />
            </div>
            <div
              v-show="selectedData.receipt.type === 4"
              class="item"
            >
              <p class="label required">
                手機條碼
              </p>
              <v-form
                ref="receiptBarcode"
                @submit.prevent
              >
                <v-text-field
                  id="receipt__barcode"
                  class="input"
                  label="請輸入手機條碼載具"
                  single-line
                  outlined
                  maxlength="8"
                  :rules="[rules.receipt.barcodeRule]"
                  :value="selectedData.receipt.barcode"
                  :hide-details="true"
                  :type="isMobile ? 'text' : 'tel'"
                  @input="checkInputValidate('receipt', ['receiptBarcode'])"
                  @input.native="inputBarcode"
                />
              </v-form>
            </div>
            <p
              v-if="selectedData.receipt.type === 1"
              class="desc"
            >
              系統將自動發送發票資訊及中獎通知至您提供的E-mail。提醒您，個人電子發票一但開立，不得任意更改或改開公司發票。
            </p>
            <p
              v-if="selectedData.receipt.type === 2"
              class="desc"
            >
              系統將自動發送發票資訊至您提供的E-mail。提醒您，公司電子發票一旦開立，不得任意更改或改開個人發票。
            </p>
            <p
              v-if="selectedData.receipt.type === 3"
              class="desc"
            >
              發票將捐贈給<span>{{ getDonateOptionsName() }}</span>，捐贈後無法變更成開立或索取紙本發票。
            </p>
            <p
              v-if="selectedData.receipt.type === 4"
              class="desc"
            >
              載具歸戶後提供自動兌獎服務，透過電子郵件寄送中獎訊息。若尚無條碼載具，可至財政部電子發票整合平台申辦手機載具條碼。
            </p>
          </template>
        </div>
      </section>
      <section
        class="option other has-item-half"
        :class="{
          'is-error': !selectedData.photoValidate || selectedData.channelType.checkValidate
        }"
        data-cy="page-checkout-other"
      >
        <span class="label subtitle">
          <span>
            其他
            <span
              v-if="!selectedData.photoValidate || selectedData.channelType.checkValidate"
              class="error-message"
            >
              <i class="icon-alert-circle" />
              必填
            </span>
          </span>
        </span>
        <div
          v-if="service.CanUploadImage"
          class="item"
        >
          <p
            class="label"
            :class="{
              'required': service.ImageIsRequired
            }"
          >
            上傳照片<span v-if="!service.ImageIsRequired">(非必填)</span>
          </p>
          <span class="desc text">
            {{ service.UploadNote }}
          </span>
          <div class="photo-list">
            <div
              v-for="(photo, photoIndex) in selectedData.photoList"
              :key="photoIndex"
              class="photo"
              :style="`background-image: url(${getImageUrl(photo)})`"
              @click="clickPhoto(selectedData.photoList, photoIndex)"
            >
              <v-progress-circular
                v-show="!checkImageIsUploaded(photo)"
                class="load-circle"
                indeterminate
                color="primary"
              />
              <i
                v-show="checkImageIsUploaded(photo)"
                class="remove icon-close"
                @click.stop="removeImage(selectedData.photoList, photoIndex)"
              />
            </div>
            <div
              v-show="selectedData.photoList.length < 6"
              class="photo add"
              :class="{ 'is-error': !selectedData.photoValidate }"
              @click="clickUpload"
            >
              <span>+</span>
              <input
                ref="upload"
                class="hidden"
                type="file"
                accept="image/*"
                @change="inputFile"
              >
            </div>
          </div>
        </div>
        <div
          class="item"
          :class="{'item-half item-half-start': showSource}"
        >
          <p class="label required">
            如何得知本服務
          </p>
          <v-form
            ref="channelType"
            @submit.prevent
          >
            <v-select
              id="channel-type"
              v-model="selectedData.channelType.id"
              class="select"
              :rules="[rules.channelType.typeRules]"
              :items="channelTypeList"
              placeholder="請選擇"
              item-text="name"
              item-value="channel_type_id"
              outlined
              :filled="lockSource"
              :hide-details="true"
              :disabled="lockSource"
              @change="checkInputValidate('channelType', ['channelType'], 'checkValidate')"
            />
            <v-text-field
              v-if="selectedData.channelType.id === 99"
              v-model="selectedData.channelType.other"
              class="input"
              label="請簡單描述"
              single-line
              outlined
              maxlength="12"
              :rules="[rules.channelType.otherRules]"
              :hide-details="true"
              type="text"
              @input="checkInputValidate('channelType', ['channelType'], 'checkValidate')"
            />
          </v-form>
        </div>
        <div
          v-if="showSource"
          class="item item-half item-half-end"
        >
          <p class="label">
            推薦人
          </p>
          <v-text-field
            id="referrer-name"
            v-model="selectedData.referrer.name"
            class="input"
            label="請輸入推薦人"
            single-line
            outlined
            maxlength="20"
            :hide-details="true"
            :filled="lockSource"
            :disabled="lockSource"
            type="text"
          />
        </div>
        <div class="item">
          <p class="label">
            備註
          </p>
          <v-textarea
            id="note"
            v-model="selectedData.note.data"
            outlined
            placeholder="如有特殊需求或疑問，請填寫在此。"
            maxlength="255"
            :rows="3"
            :auto-grow="true"
            hide-details="auto"
          />
        </div>
      </section>
    </div>
    <!-- 付款詳情 -->
    <section
      v-if="pageNow > 2 && selectedOptionPriceArr.length > 0"
      class="option-subtotal"
    >
      <div class="price-subtotal">
        <div class="subtotal-title">
          付款詳情
        </div>
        <div>
          <span>小計：</span>
          <span class="price-origin">$ {{ setPriceFormat(selectedData.price.totalPrice + getTotalPromotionDiscount()) }}</span>
        </div>
        <div>
          <!-- 多台優惠 + 折扣碼 + 優惠券 -->
          <span>優惠折抵：</span>
          <span class="price">- $ {{ setPriceFormat(getTotalPromotionDiscount() + discountAmount + ticketAmount) }}</span>
        </div>
        <div>
          <span>紅利：</span>
          <span class="price">- $ {{ setPriceFormat(bonusAmount) }}</span>
        </div>
      </div>
    </section>
    <section
      class="option total"
      data-cy="page-checkout-order-total-price"
    >
      <p
        v-show="Object.entries(selectedData.price.option).length > 0"
        class="price-total"
      >
        <img
          class="price-tag"
          src="~/assets/image/price_tag.svg"
          alt="訂單總額"
        >
        <span>訂單總額
          <span class="price">
            ${{ setPriceFormat(totalPrice) }}
          </span>
        </span>
      </p>
      <div
        v-if="pageNow === 1"
        class="check-term"
        @click.stop="term.dialogOpen = true"
      >
        <v-checkbox
          v-model="term.isRead"
          readonly
          label="點擊閱讀並同意服務條款"
          :hide-details="true"
        />
      </div>
      <div class="btn-group">
        <v-btn
          v-if="pageNow > 1"
          class="btn-prev btn"
          :class="`step-to-${pageNow - 1}`"
          depressed
          color="primary"
          @click="clickPricePrevStep"
        >
          上一步
        </v-btn>
        <v-btn
          v-if="pageNow < 3"
          class="btn-next btn"
          :class="`step-to-${pageNow + 1}`"
          depressed
          color="primary"
          :loading="btn.isNextStepLoading"
          @click="clickPriceNextStep"
        >
          下一步
        </v-btn>
        <v-btn
          v-if="pageNow === 3"
          class="btn-next btn step-to-setorder"
          depressed
          color="primary"
          :disabled="btn.isDisabled"
          :loading="btn.isSetOrder || btn.isSetOrderLoading"
          @click="clickSetOrder"
        >
          <span v-if="service.order_mode_id === 3">確認諮詢</span>
          <span v-else>確認訂購</span>
        </v-btn>
      </div>
    </section>
    <!-- ========== 彈窗 ========== -->
    <v-dialog
      v-model="alertDialog.open"
      :persistent="alertDialog.persistent"
      width="500"
    >
      <v-card :class="{ 'alertDialogStyle' : alertDialog.type === 'setOrderSuccess' }">
        <img
          v-if="alertDialog.type === 'setOrderSuccess'"
          :src="require(`@/assets/image/quokka/${alertDialog.image}.png`)"
          alt="智寶"
        >
        <div
          v-show="alertDialog.title"
          class="headline"
        >
          {{ alertDialog.title }}
        </div>
        <div
          v-show="alertDialog.message"
          class="message"
        >
          {{ alertDialog.message }}
        </div>
        <v-card-actions>
          <v-spacer />
          <template v-if="alertDialog.btn.length > 0">
            <v-btn
              v-for="(btn, index) in alertDialog.btn"
              :key="index"
              :ref="'alertDialogBtn-' + index"
              class="alert-dialog__btn"
              :color="btn.btnColor"
              @click="btn.btnClick"
            >
              {{ btn.btnText }}
            </v-btn>
          </template>
          <v-btn
            v-else
            color="primary"
            @click="alertDialogClose"
          >
            {{ alertDialog.btnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="matchResult.searchDialogOpen"
      :persistent="matchResult.searchDialogPersistent"
      width="500"
    >
      <v-card class="alertDialogStyle">
        <lottie-animation
          ref="lottieAnimation"
          :animation-data="require('@/assets/animation/loading_epllisis.json')"
          :loop="true"
          :auto-play="true"
          class="loading-animation"
        />
        <div class="headline">
          正在搜尋適合的服務人員
        </div>
        <div class="message">
          請稍候一下，不要離開此頁面
        </div>
      </v-card>
    </v-dialog>
    <div
      class="login-register dialog"
      :class="{
        'is-open': loginDailog.open
      }"
    >
      <div class="content">
        <group-login-register
          :prop-step="loginDailog.propStep"
          :phone="personalInfo.APhone"
          :open="loginDailog.open"
          @updatePhone="updatePhone"
          @isLogin="isLogin"
          @close="loginClose"
        />
      </div>
    </div>
    <v-dialog
      v-model="term.dialogOpen"
      class="terms dialog"
      persistent
      :width="isMobile ? 'auto' : '530'"
      :fullscreen="isMobile"
    >
      <v-card
        id="dialog-terms"
        class="dialog-content"
      >
        <v-card-title class="dialog-header">
          服務條款
          <i
            class="close icon-close"
            @click="termClose"
          />
        </v-card-title>
        <v-card-text class="dialog-content">
          <main v-html="service.terms_content" />
        </v-card-text>
        <v-card-actions class="dialog-footer">
          <v-spacer />
          <v-btn
            class="btn"
            btn-title="服務條款"
            depressed
            color="primary"
            @click="termSubmit"
          >
            同意
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="regionDialog.open"
      class="region-select dialog"
      scrollable
      :width="isMobile ? 'auto' : '530'"
      :fullscreen="isMobile"
    >
      <v-card
        id="dialog-region-select"
        class="dialog-region-select"
      >
        <i
          class="close icon-close"
          @click="regionDialog.open = false"
        />
        <v-card-title class="dialog-title">
          選擇常用地址
        </v-card-title>
        <v-card-subtitle class="dialog-subtitle">
          部分服務有區域限制，如地址屬於非服務區域內，則無法選擇。
        </v-card-subtitle>
        <v-card-text class="dialog-content">
          <v-btn
            class="btn btn-select-address"
            outlined
            rounded
            color="primary"
            @click="regionDialog.createDialogOpen = true"
          >
            新增常用地址
          </v-btn>
          <v-radio-group
            v-model="regionDialog.selectedIndex"
            class="radio-group"
            :mandatory="false"
          >
            <v-radio
              v-for="(region, index) in regionDialog.regionList"
              :key="region.AddressId"
              class="radio"
              :value="index"
              :disabled="region.isDisabled"
            >
              <div
                slot="label"
                class="item"
              >
                <p>
                  <!-- <span class="label">聯絡人</span> -->
                  <span>{{ region.Name }}</span>
                </p>
                <p>
                  <!-- <span class="label">電話號碼</span> -->
                  <span>{{ region.Phone }}</span>
                </p>
                <p>
                  <!-- <span class="label">聯絡地址</span> -->
                  <span>{{ region.City }}{{ region.Area }}{{ region.Address }}</span>
                </p>
              </div>
            </v-radio>
          </v-radio-group>
          <div class="item" />
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-btn
            color="primary"
            class="btn"
            depressed
            :disabled="regionDialog.selectedIndex === null"
            @click="regionDialogSubmit"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="contactDialog.open"
      class="region-select dialog"
      scrollable
      :width="isMobile ? 'auto' : '530'"
      :fullscreen="isMobile"
      @click:outside="contactDialogClose"
    >
      <package-contact
        :open="contactDialog.open"
        :loading="contactDialog.loading"
        :contact-list="contactDialog.contactList"
        :delete-open="contactDialog.deleteOpen"
        :delete-loading="contactDialog.deleteLoading"
        @close="contactDialogClose"
        @submit="contactDialogSubmit"
        @openDelete="contactDialog.deleteOpen = true"
        @closeDelete="contactDialog.deleteOpen = false"
        @delete="deleteContact"
        @search="searchContact"
      />
    </v-dialog>
    <v-dialog
      v-model="btn.isSetOrder"
      class="loading-dialog"
      persistent
      width="350"
    >
      <v-card id="setorder-loading-dialog">
        <v-card-title class="dialog-header">
          訂單成立中，請勿關閉視窗
        </v-card-title>
        <v-card-text class="dialog-content">
          <!-- <p>訂單成立中，請勿關閉視窗</p> -->
          <v-progress-circular
            class="loading-circle"
            indeterminate
            color="primary"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="btn.isMobilePay"
      class="loading-dialog"
      persistent
      width="350"
    >
      <v-card id="setorder-loading-dialog">
        <v-card-title class="dialog-header">
          付款中，請勿關閉視窗
        </v-card-title>
        <v-card-text class="dialog-content">
          <!-- <p>訂單成立中，請勿關閉視窗</p> -->
          <v-progress-circular
            class="loading-circle"
            indeterminate
            color="primary"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="discount.dialog.open"
      class="discount-dialog"
      :width="isMobile ? 'auto' : '530'"
      :fullscreen="isMobile"
      :scrollable="isMobile"
    >
      <v-card class="dialog-discount dialog-card">
        <v-card-title class="dialog-header">
          使用優惠券
          <i
            class="close icon-close"
            @click="discount.dialog.open = false"
          />
        </v-card-title>
        <v-card-text class="dialog-content">
          <div class="item">
            <img
              src="~/assets/image/ticket.svg"
              alt="優惠券"
            >
            <div class="content">
              <p class="label">
                使用優惠券
                <span class="desc">每筆訂單限用一張</span>
              </p>
              <p
                class="desc"
                :class="{'hidden': !discount.ticket.got}"
              >
                <template v-if="discount.ticket.index === '' && discount.ticket.list.length > 0">
                  選擇一張優惠券折抵
                </template>
                <template v-else-if="discount.ticket.index !== null">
                  使用優惠券折抵<span
                    v-if="discount.ticket.list[discount.ticket.index]"
                    class="price"
                  >＄{{ setPriceFormat(discount.ticket.list[discount.ticket.index].OrderDiscount) }}</span>
                </template>
                <template v-else>
                  無符合折抵條件的優惠券
                </template>
              </p>
            </div>
          </div>
          <div class="ticket-list">
            <div
              v-if="!discount.ticket.got"
              class="loading"
            >
              <v-progress-circular
                class="loading-circle"
                indeterminate
                color="primary"
              />
            </div>
            <div class="radio-group">
              <v-checkbox
                v-for="(ticket, index) in discount.ticket.list"
                :key="ticket.TicketInstanceId"
                class="radio-item"
                :value="discount.ticket.index === index"
                :class="{'radio-loading': !discount.ticket.got}"
                :hide-details="true"
                readonly
                @click.stop="clickTicketCheckbox(index)"
              >
                <div
                  slot="label"
                  class="content"
                >
                  <p class="name">
                    {{ ticket.Name }}
                  </p>
                  <p class="date">
                    使用期限 {{ ticket.ValidDue }}
                  </p>
                </div>
              </v-checkbox>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-footer d-flex">
          <v-btn
            class="btn"
            btn-title="確認"
            depressed
            color="primary"
            @click="discountSubmit"
          >
            確認
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="far.dialogOpen"
      class="far-dialog"
      :width="isMobile ? 'auto' : '530'"
      :fullscreen="isMobile"
      :scrollable="isMobile"
      persistent
    >
      <v-card
        id="dialog-far"
        class="dialog-card dialog-region-select"
      >
        <v-card-title class="dialog-header">
          請確認您的訂單明細
          <i
            class="close icon-close"
            @click="farDialogClose"
          />
        </v-card-title>
        <v-card-text class="dialog-content">
          <h4>項目明細</h4>
          <div class="item">
            <p class="label">
              {{ service.service_title }}
            </p>
          </div>
          <div
            v-for="option in getServiceSelectedPrice()"
            :key="option.id"
            class="item price"
          >
            <p class="label">
              {{ option.title }}
            </p>
            <div class="content">
              <template v-for="price in option.options">
                <template v-if="price.ProductInfo && (price.price_count > 0)">
                  <p
                    v-for="sku in price.ProductInfo.Skus.filter(v => (v.num > 0))"
                    :key="sku.SkuId"
                  >
                    <span>{{ price.price_name }}{{ getSelectedSkuNameJoin(price, sku).length > 0 ? '/' : '' }}{{ getSelectedSkuNameJoin(price, sku) }} x {{ sku.num }}</span>
                    <span class="price">$ {{ setPriceFormat(sku.Price * sku.num) }}</span>
                  </p>
                </template>
                <p
                  v-else-if="price.price_count > 0"
                  :key="price.price_id"
                >
                  <span>{{ price.price_name }} X {{ price.price_count }}</span>
                  <span class="price">${{ setPriceFormat(price.price * price.price_count) }}</span>
                </p>
              </template>
            </div>
          </div>
          <div
            v-for="option in far.optionPriceGroupFar"
            :key="option.id"
            class="item price"
          >
            <p class="label">
              {{ option.title }}
            </p>
            <div class="content">
              <p
                v-for="price in option.options"
                :key="price.price_id"
              >
                <span>{{ price.price_name }} X {{ price.price_count }}</span>
                <span class="price">${{ setPriceFormat(price.price * price.price_count) }}</span>
              </p>
            </div>
          </div>
          <template v-if="contactFlagPriceOptionList.length > 0">
            <div
              v-for="priceInfo in contactFlagPriceOptionList"
              :key="priceInfo.id"
              class="item price"
            >
              <p class="label">
                {{ priceInfo.CategoryName }}
              </p>
              <div class="content">
                <p>
                  <span>{{ priceInfo.PriceName }} X {{ priceInfo.PriceCount }}</span>
                  <span class="price">${{ setPriceFormat(priceInfo.Price * priceInfo.PriceCount) }}</span>
                </p>
              </div>
            </div>
          </template>
          <template v-if="showContactFeeInOptionList">
            <div
              v-for="priceInfo in uWashContactFlagPriceOptionList"
              :key="priceInfo.id"
              class="item price"
            >
              <p class="label">
                {{ priceInfo.CategoryName }}
              </p>
              <div class="content">
                <p>
                  <span>{{ priceInfo.PriceName }} X {{ priceInfo.PriceCount }}</span>
                  <span class="price">${{ setPriceFormat(priceInfo.Price * priceInfo.PriceCount) }}</span>
                </p>
              </div>
            </div>
          </template>
          <template
            v-if="Object.values(promotion.selectedOptionByPromotionId).length > 0 &&
              Object.values(promotion.selectedOptionByPromotionId)[0].totalCount"
          >
            <div class="item price">
              <p class="label">
                優惠活動
              </p>
              <div class="content">
                <p
                  v-for="(singlePromotion, key) in promotion.selectedOptionByPromotionId"
                  :key="key"
                >
                  <template v-if="singlePromotion.discount">
                    <span>滿{{ singlePromotion.discount.Quantity }}件以上每件折扣${{ setPriceFormat(singlePromotion.discount.DiscountAmount) }}</span>
                    <span class="price">-${{ setPriceFormat(singlePromotion.totalCount * singlePromotion.discount.DiscountAmount) }}</span>
                  </template>
                </p>
              </div>
            </div>
          </template>
          <template v-if="bonusAmount > 0">
            <div class="item price">
              <p class="label">
                紅利點數
              </p>
              <div class="content">
                <p>
                  <span>使用{{ bonusAmount }}點折扣{{ setPriceFormat(bonusAmount) }}元</span>
                  <span class="price">-${{ setPriceFormat(bonusAmount) }}</span>
                </p>
              </div>
            </div>
          </template>
          <template v-if="selectedData.discount.ticket.discount > 0">
            <div class="item price">
              <p class="label">
                優惠券
              </p>
              <div class="content">
                <p>
                  <span>{{ selectedData.discount.ticket.list[selectedData.discount.ticket.index].Name }}</span>
                  <span class="price">-${{ selectedData.discount.ticket.discount }}</span>
                </p>
              </div>
            </div>
          </template>
          <div class="item price total-price">
            <div class="content">
              <p>
                <span class="label">總計</span>
                <span class="price total-price">${{ setPriceFormat(selectedData.price.totalPrice - discountAmount - ticketAmount - bonusAmount) }}</span>
              </p>
              <p v-if="far.SendDays > 0">
                <span class="label">預估配達天數</span>
                <span class="price">{{ far.SendDays }}個工作天</span>
              </p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-footer">
          <v-spacer />
          <v-btn
            class="btn"
            color="primary"
            Block
            :loading="btn.isSetOrder || btn.isSetOrderLoading"
            @click="clickSetOrder"
          >
            前往付款
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 選購項目彈窗 -->
    <v-dialog
      v-model="selectProductDialog.open"
      class="select-product-dialog"
      :width="setDialogWidth"
      :fullscreen="isMobile"
      :scrollable="isMobile"
    >
      <v-card
        id="dialog-selecet-product"
        class="dialog-selecet-product dialog-card"
      >
        <v-card-title class="dialog-header">
          <i
            class="close icon-close"
            @click="selectProductDialog.open = false"
          />
        </v-card-title>
        <v-card-text
          v-if="selectProductDialog.selectedPrice"
          class="dialog-content"
        >
          <div
            class="content"
            :class="{'productWithImage has-image': selectProductDialog.selectedPrice.Images.length > 0}"
          >
            <!-- 商品圖片 -->
            <client-only>
              <div
                v-if="selectProductDialog.selectedPrice.Images.length > 0 && selectProductDialog.open"
                class="image-carousel"
              >
                <vue-tiny-slider v-bind="silderOptions">
                  <div
                    v-for="image in selectProductDialog.selectedPrice.Images"
                    :key="image.ImageUri"
                    class="carousel"
                  >
                    <v-img
                      :src="getImageUrl(image.ImageUri)"
                      :lazy-src="getImageUrl(image.ImageUri)"
                      aspect-ratio="1"
                      contain
                    />
                  </div>
                </vue-tiny-slider>
              </div>
            </client-only>
            <!-- 商品資訊 -->
            <section class="product-info-wrap">
              <span class="name">{{ selectProductDialog.selectedPrice.price_name }}</span>
              <span
                v-if="selectProductDialog.selectedPrice.promotion_list.length > 0"
                class="promotion"
              >活動商品</span>
              <p class="price">
                <span class="dialogPriceColor">${{ getProductPrice(selectProductDialog.selectedPrice, null, true, true) }}</span>
                <span
                  v-if="selectProductDialog.selectedPrice.promotion_list.length > 0"
                  v-show="
                    promotion.selectingOptionByPromotionId[selectProductDialog.selectedPrice.promotion_list[0]] &&
                      promotion.selectingOptionByPromotionId[selectProductDialog.selectedPrice.promotion_list[0]].discount"
                  class="price-origin"
                >
                  ${{ getProductPrice(selectProductDialog.selectedPrice) }}
                </span>
              </p>
              <p
                v-if="selectProductDialog.selectedPrice.price_desc && !isMobile"
                class="desc"
              >
                {{ selectProductDialog.selectedPrice.price_desc }}
              </p>
            </section>
            <!-- 手機版樣式 -->
            <section class="mobile-desc">
              <p
                v-if="selectProductDialog.selectedPrice.price_desc && isMobile"
                class="desc"
              >
                {{ selectProductDialog.selectedPrice.price_desc }}
              </p>
            </section>
            <!-- 規格與數量 -->
            <section class="sku-info-wrap">
              <div class="sku-wrap">
                <template v-if="selectProductDialog.selectedPrice && selectProductDialog.selectedPrice.ProductInfo && selectProductDialog.selectedPrice.ProductInfo.VariantCount >= 1">
                  <div
                    v-for="variant in selectProductDialog.selectedPrice.ProductInfo.Variants"
                    :key="variant.ProductVariantId"
                    class="variant-item"
                  >
                    <div class="variant-title">
                      {{ variant.Name }}
                    </div>
                    <div class="variant-content">
                      <div
                        v-for="sku in variant.AssortionOptions"
                        :key="sku.ProductVariantOptionId"
                        class="sku-item"
                        :class="{'active': sku.selected}"
                        @click="clickSelectVariant(variant, sku)"
                      >
                        {{ sku.Name }}
                        <i
                          v-show="sku.selected"
                          class="icon icon-check-triangle"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="getSkuNote()"
                    class="note-block"
                  >
                    <div class="note-title">
                      規格說明
                    </div>
                    <div class="note-content">
                      {{ getSkuNote() }}
                    </div>
                  </div>
                </template>
                <div
                  v-if="!isMobile"
                  class="variant-item"
                >
                  <div class="variant-title">
                    數量
                  </div>
                  <div class="variant-content">
                    <group-input-number
                      v-if="selectProductDialog.open"
                      v-model="selectProductDialog.selectedPrice.price_count"
                      class="price-controls"
                      min="1"
                      :max="selectProductDialog.selectedPrice.max_limit > 0 ? selectProductDialog.selectedPrice.max_limit : 100"
                      @input="changeCount(selectProductDialog.selectedPrice, true)"
                    />
                  </div>
                </div>
              </div>
            </section>
            <!-- Web版樣式 -->
            <section
              v-if="!isMobile"
              class="btnAddToCart-wrap"
            >
              <v-btn
                class="btn webAddToCartBtn"
                btn-title="新增至購物清單"
                depressed
                color="primary"
                :disabled="!isSkuSelected"
                @click="confirmSelectProduct(shoppingCartDialog.open)"
              >
                {{ shoppingCartDialog.open ? '更新至購物清單' : '新增至購物清單' }}
                <template v-if="isSkuSelected">
                  (${{ getSelectedProductTotalPrice() }})
                </template>
              </v-btn>
            </section>
          </div>
        </v-card-text>
        <!-- 手機版樣式 -->
        <div
          v-if="isMobile"
          class="mobileVersionCount"
        >
          <div class="mobileVersionCount__title">
            數量
          </div>
          <div class="mobileVersionCount__content">
            <group-input-number
              v-if="selectProductDialog.open"
              v-model="selectProductDialog.selectedPrice.price_count"
              class="price-controls"
              min="1"
              :max="selectProductDialog.selectedPrice.max_limit > 0 ? selectProductDialog.selectedPrice.max_limit : 100"
              @input="changeCount(selectProductDialog.selectedPrice, true)"
            />
          </div>
        </div>
        <v-card-actions
          v-if="isMobile"
          class="dialog-footer d-flex"
        >
          <v-btn
            class="btn"
            btn-title="新增至購物清單"
            depressed
            color="primary"
            :disabled="!isSkuSelected"
            @click="confirmSelectProduct(shoppingCartDialog.open)"
          >
            {{ shoppingCartDialog.open ? '更新至購物清單' : '新增至購物清單' }}
            <template v-if="isSkuSelected">
              (${{ getSelectedProductTotalPrice() }})
            </template>
          </v-btn>
        </v-card-actions>
        <!-- /手機版樣式 -->
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="shoppingCartDialog.open"
      class="shopping-cart-dialog"
      :width="isMobile ? 'auto' : '600'"
      :fullscreen="isMobile"
      :scrollable="isMobile"
    >
      <v-card
        id="dialog-shopping-cart"
        class="dialog-shopping-cart dialog-card"
      >
        <v-card-title class="dialog-header">
          購物清單
          <i
            class="close icon-close"
            @click="shoppingCartDialog.open = false"
          />
        </v-card-title>
        <v-card-text class="dialog-content">
          <div v-if="selectedOptionPriceArr.length > 0">
            <section
              v-for="option in selectedOptionPriceArr"
              :key="`cat_${option.category_id}`"
            >
              <template v-for="price in option.price_option.filter(v=>(v.price_count > 0))">
                <template>
                  <!-- >>> 商品(both有規格和無規格) -->
                  <template v-if="price.ProductInfo">
                    <div
                      v-for="sku in price.ProductInfo.Skus.filter(v=>(v.num > 0))"
                      :key="`sku_${sku.SkuId}`"
                      class="price-option-detail"
                    >
                      <div
                        class="itemWrap cursorPointer"
                        @click="clickSelectProduct(option, price, sku)"
                      >
                        <span class="price-name">{{ price.price_name }}</span>
                        <p
                          v-if="price.ProductInfo.VariantCount > 0"
                          class="desc"
                        >
                          {{ getSelectedSkuNameJoin(price, sku, ' , ') }}
                        </p>
                        <p class="price">
                          <span>${{ getProductPrice(price, sku, true) }}</span>
                          <span
                            v-if="price.promotion_list.length > 0"
                            v-show="
                              promotion.selectedOptionByPromotionId[price.promotion_list[0]] &&
                                promotion.selectedOptionByPromotionId[price.promotion_list[0]].discount"
                            class="price-origin"
                          >
                            ${{ getProductPrice(price, sku) }}
                          </span>
                        </p>
                      </div>
                      <div
                        class="itemWrap2"
                        :class="{ 'itemWrap2Mobile': isMobile}"
                      >
                        <group-input-number
                          v-if="shoppingCartDialog.open"
                          v-model="sku.num"
                          class="price-controls"
                          min="0"
                          :max="price.max_limit > 0 ? price.max_limit : 100"
                          :is-shopping-cart-mode="true"
                          @input="changeCount(price);updateSkuPriceCount(price);logPriceOptionGaEvent($event, { sku, price })"
                        />
                        <div
                          class="underlineText"
                          @click="removeItemFromCart(price, sku)"
                        >
                          刪除
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- >>> 非商品無規格 -->
                  <div
                    v-else
                    :key="`price_${price.price_id}`"
                    class="price-option-detail"
                  >
                    <div
                      class="itemWrap cursorPointer"
                      @click="clickSelectProduct(option, price)"
                    >
                      <span class="price-name">{{ price.price_name }}</span>
                      <p class="price">
                        <span>${{ getProductPrice(price, null, true) }}</span>
                        <span
                          v-if="price.promotion_list.length > 0"
                          v-show="
                            promotion.selectedOptionByPromotionId[price.promotion_list[0]] &&
                              promotion.selectedOptionByPromotionId[price.promotion_list[0]].discount"
                          class="price-origin"
                        >
                          ${{ getProductPrice(price) }}
                        </span>
                      </p>
                    </div>
                    <div
                      class="itemWrap2"
                      :class="{ 'itemWrap2Mobile': isMobile}"
                    >
                      <group-input-number
                        v-if="shoppingCartDialog.open"
                        :key="`price_input_${price.price_id}`"
                        v-model="price.price_count"
                        class="price-controls"
                        min="0"
                        :max="price.max_limit > 0 ? price.max_limit : 100"
                        :is-shopping-cart-mode="true"
                        @input="changeCount(price);logPriceOptionGaEvent($event, { price })"
                      />
                      <div
                        class="underlineText"
                        @click="removeItemFromCart(price)"
                      >
                        刪除
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </section>
          </div>
          <div
            v-else
            class="empty-wrap"
          >
            <h3>目前沒有任何品項</h3>
            <img
              src="@/assets/image/shopping-cart-empty.png"
              alt="目前沒有任何品項"
            >
          </div>
        </v-card-text>
        <v-card-actions class="dialog-footer d-flex">
          <section
            v-if="selectedOptionPriceArr.length > 0"
            class="price-option-subtotal"
          >
            <div class="price-subtotal">
              <div
                class="subtotal-title"
                :class="{ 'borderBottom': isMobile }"
              >
                付款詳情
              </div>
              <div>
                <span>小計：</span>
                <span
                  v-if="showContactFeeInOptionList"
                  class="price-origin"
                >$ {{ setPriceFormat(selectedData.price.totalPrice + getTotalPromotionDiscount() - uWashContactServicePriceTotal ) }}</span>
                <span
                  v-else
                  class="price-origin"
                >$ {{ setPriceFormat(selectedData.price.totalPrice + getTotalPromotionDiscount()) }}</span>
              </div>
              <div>
                <span>優惠折抵：</span>
                <span class="price">- $ {{ setPriceFormat(getTotalPromotionDiscount()) }}</span>
              </div>
            </div>
            <div class="price-total">
              <div class="total-title">
                訂單總額
              </div>
              <div
                v-if="showContactFeeInOptionList"
                class="price"
              >
                ${{ setPriceFormat(selectedData.price.totalPrice - uWashContactServicePriceTotal ) }}
              </div>
              <div
                v-else
                class="price"
              >
                ${{ setPriceFormat(selectedData.price.totalPrice) }}
              </div>
            </div>
          </section>
          <v-btn
            v-if="selectedOptionPriceArr.length === 0"
            class="btn-next btn step-to-2"
            depressed
            color="primary"
            :loading="btn.isNextStepLoading"
            @click="shoppingCartDialog.open = false"
          >
            關閉
          </v-btn>
          <v-btn
            v-else
            class="btn-next btn step-to-2"
            depressed
            color="primary"
            :loading="btn.isNextStepLoading"
            @click="clickPriceNextStep"
          >
            下一步
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <group-dialog-create-address
      v-if="!isCommunity"
      :open="regionDialog.createDialogOpen"
      :address-list="regionDialog.regionList"
      type="create"
      @close="regionDialog.createDialogOpen = false"
      @create="regionCreate"
    />
    <group-dialog-receive-coupon
      :open="openDialogCoupon"
      @close="closeDialogCoupon"
    />
    <v-fab-transition>
      <v-btn
        v-show="pageNow === 1 && optionPriceGroup.length > 0"
        btn-title="購物清單"
        rounded
        large
        class="shopping-cart-btn"
        @click="clickShoppingCart"
      >
        <i class="icon icon-shopping-list" />
        <span
          v-show="!isMobile"
          class="text-wrap"
        >
          <span class="btn-title">購物清單</span><br>
          <span class="btn-desc">已選擇數量：{{ priceCountTotal }}</span>
        </span>
        <span
          v-show="isMobile"
          class="btn-desc"
        >{{ priceCountTotal }}</span>
        <i class="icon icon-chevron-right arrow" />
      </v-btn>
    </v-fab-transition>
    <!-- 信用卡選擇 -->
    <client-only>
      <credit-card-selector
        v-if="$auth.loggedIn && !isGuestAgent && !isAgentOrder"
        ref="creditCardSelectorDialog"
        :open="creditCardSelectorDialog.open"
        :import-selected-card="creditCardSelectorDialog.selectedCard"
        @close="creditCardSelectorDialog.open = false"
        @updateSelectedCard="setSelectedCard"
        @updateCardList="setCardList"
        @creditCardSubmit="submitCreditCardSelectorDialog"
      />
    </client-only>
    <v-dialog
      v-model="warningDialog.open"
      width="500"
    >
      <v-card>
        <v-card-title
          v-show="warningDialog.title"
          class="headline"
        >
          {{ warningDialog.title }}
        </v-card-title>
        <v-card-text v-show="warningDialog.message">
          {{ warningDialog.message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="btn"
            depressed
            @click="warningDialog.open = false"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import GroupInputNumber from '@/components/GroupInputNumber.vue'
import GroupLoginRegister from '@/components/GroupLoginRegister.vue'
import GroupDialogCreateAddress from '@/components/GroupDialogCreateAddress.vue'
import GroupDialogReceiveCoupon from '@/components/GroupDialogReceiveCoupon.vue'
import CardCodeDiscount from '@/components/ServiceCheckout/CardCodeDiscount.vue'
import PackageContact from '@/components/PageComponent/ServicePackage/DialogPackageContact.vue'
import CreditCardSelector from '@/components/CreditCardSelector.vue'
import DonateList from '@/plugins/DonateList.js'
import loadImage from '@/assets/load-image/index.js'
import serviceCommon from '@/mixin/serviceCommon.js'
import { mapGetters, mapState } from 'vuex'
import guestPurchaseMixin from '@/mixin/guestPurchase.js'
import { firebaseSmartlife } from '~/plugins/firebase'
import { validateTaxId } from '@/utils/validate.js'
import { ImageProcess } from '@/utils/imageProcess'
import LottieAnimation from 'lottie-web-vue'
export default {
  components: {
    GroupInputNumber,
    GroupLoginRegister,
    GroupDialogCreateAddress,
    GroupDialogReceiveCoupon,
    PackageContact,
    CardCodeDiscount,
    CreditCardSelector,
    LottieAnimation
  },
  mixins: [serviceCommon, guestPurchaseMixin],
  props: [
    'serviceId',
    'isCommunity',
    'communityList'
  ],
  data () {
    return {
      pages: [
        '品項頁',
        '問答頁',
        '預約資訊頁'
      ],
      isMobile: null,
      lockSource: false,
      showSource: false,
      isCheckoutPageLogin: false, // 會員在預約資訊頁才登入
      syncBuyerInfo: false,
      silderOptions: {
        loop: true,
        fixedWidth: true,
        lazyload: true,
        autoplay: false,
        controls: false,
        navPosition: 'bottom',
        viewportMax: 5,
        mouseDrag: true,
        swipeAngle: false,
        autoplayButtonOutput: false,
        autoplayResetOnVisibility: false
      },
      promotion: { // 優惠活動
        PromotionDataList: [],
        selectedOptionByPromotionId: {},
        selectingOptionByPromotionId: {}
      },
      personalInfo: {
        phoneIsSaved: false,
        phoneIsSaving: false,
        phoneErrorMessage: '',
        AId: '',
        AName: '',
        APhone: '',
        AGender: '',
        ABirthday: '',
        ABirthdayShow: '',
        BirthdayMenu: false,
        checkValidate: null
      },
      selectedData: {
        price: {
          option: {},
          totalPrice: 0,
          error: {}
        },
        option: {
          error: {}
        },
        region: {
          city: {},
          area: {},
          name: '',
          phone: '',
          address: '',
          addressCheckValidate: null,
          selectTabletId: '',
          community: {},
          comunityAddress: '',
          communityCheckValidate: null,
          contactFlag: false
        },
        payment: 0,
        recipient: {
          postId: '',
          city: {},
          area: {},
          name: '',
          phone: '',
          address: '',
          addressCheckValidate: null,
          remember: false
        },
        datetime: {
          date: null,
          dateOpen: false,
          defaultTime: 1,
          timeStartHour: '00',
          timeStartMinute: '00',
          timeStartHourOptions: [],
          timeStartMinuteOptions: [],
          timeEndHour: '00',
          timeEndMinute: '00',
          timeEndHourOptions: [],
          timeEndMinuteOptions: [],
          defaultModeList: [],
          weekdayReservation: 1,
          weekdayOrWeekendModeList: []
        },
        receipt: {
          type: 1,
          mail: '',
          companyMail: '',
          city: '',
          area: '',
          address: '',
          idNumber: '',
          donate: 1,
          barcode: '',
          typeOptions: [
            {
              label: '個人電子發票',
              value: 1,
              InvoiceMark: 1,
              InvoiceCarrierType: 2
            },
            {
              label: '公司統一編號',
              value: 2,
              InvoiceMark: 1,
              InvoiceCarrierType: 1
            },
            {
              label: '捐贈發票',
              value: 3,
              InvoiceMark: 2,
              InvoiceCarrierType: 1
            },
            {
              label: '手機條碼載具',
              value: 4,
              InvoiceMark: 1,
              InvoiceCarrierType: 3
            }
          ],
          donateOptions: [],
          checkboxCheck: false,
          tooltipOpen: false
        },
        photoList: [],
        photoValidate: true,
        channelType: {
          id: 0,
          other: '',
          checkValidate: null
        },
        referrer: {
          name: ''
        },
        note: {
          data: '',
          isError: false,
          errorMessage: ''
        },
        discount: {
          bonus: {
            state: 'empty', // 'disable', 'used', 'notuse', 'empty'
            point: {
              CanUseBonusAmount: 0,
              CanUseEnterpriseAmount: 0
            },
            isLoading: false,
            enterpriseCodes: [] // 訪客領取企業儲值金
          },
          ticket: {
            discount: 0,
            TicketInstanceId: null,
            index: null,
            detail: null,
            list: null
          },
          code: {
            discount: 0,
            detail: null,
            input: '',
            isUse: false,
            isSaving: false
          },
          tempInput: ''
        },
        packageType: {}
      },
      pageNow: 1,
      isNextStep: false,
      discount: { // 企業
        bonus: {
          status: '',
          total: 0,
          isUse: false,
          got: false,
          isLoading: false
        },
        enterprisePoint: 0,
        ticket: {
          tempList: [],
          list: [],
          value: {},
          index: null,
          got: false
        },
        dialog: {
          open: false
        }
      },
      payment: {
        paymentOptionList: [],
        checkValidate: null,
        errorMessage: ''
      },
      alertDialog: {
        open: false,
        title: '',
        message: '',
        type: '',
        btnText: '關閉',
        btn: [],
        persistent: false,
        successData: {},
        image: 'thank-quokka'
      },
      loginDailog: {
        open: false,
        propStep: ''
      },
      term: {
        isRead: false,
        dialogOpen: false
      },
      regionDialog: {
        open: false,
        selectedIndex: null,
        regionList: [],
        createDialogOpen: false
      },
      regionCreateDialog: {
        open: false
      },
      contactDialog: {
        open: false,
        deleteOpen: false,
        deleteIndex: null,
        deleteLoading: false,
        loading: true,
        selectedIndex: null,
        contactList: [],
        originContactList: []
      },
      creditCardSelectorDialog: {
        open: false,
        selectedCard: null,
        cardList: []
      },
      warningDialog: {
        open: false,
        title: '',
        message: ''
      },
      btn: {
        isDisabled: false,
        isNextStepLoading: false,
        isSetOrder: false,
        isSetOrderLoading: false,
        isMobilePay: false
      },
      regionList: [],
      channelTypeList: [],
      optionPriceGroup: [],
      far: {
        OutlyingIsland: false,
        FarSend: false,
        SendDays: 0,
        optionPriceGroupFar: [],
        dialogOpen: false
      },
      communitySelectList: [],
      openDialogCoupon: false,
      selectProductDialog: {
        open: false,
        selectedOption: null,
        selectedPrice: null
      },
      shoppingCartDialog: {
        open: false
      },
      selectedContactService: false,
      guestPurchaseErrorCount: 0,
      multiAddress: {
        show: false,
        list: []
      },
      isToggleMaskOpen: false,
      packageTypeOptions: [],
      FBTrackServices: [],
      FBTrackExcludeChannelType: [],
      contactPickupFeeList: [],
      contactPickupChecked: false,
      isPaying: false,
      isReviewDeep: false,
      stayTimer: null,
      matchResult: {
        matchStatus: null, // 媒合狀態 1: 媒合中, 2: 客戶選擇中, 3: 客戶未選擇, 4: 客戶已選擇, 5: 客戶拒絕, 6: 媒合失敗(沒有結果), 7: 媒合失敗(系統異常)
        matchType: null, // 媒合類型 1: 客戶期望選項, 2: 推薦選項
        canChangeDialog: false,
        searchDialogOpen: false,
        searchDialogPersistent: true
      }
    }
  },
  async fetch () {
    try {
      const setArea = () => {
        if (this.cityList.length > 0) {
          this.selectedData.region.city = this.cityList[0]
          this.setAreaList(this.cityList[0].MainID)
          this.selectedData.region.area = this.regionList[0]
        }
      }
      /**
       * serviceTimeType
       * [
       *  {"Id":1,"Name":"設定日期與時段"},
       *  {"Id":2,"Name":"僅設定日期"},
       *  {"Id":3,"Name":"設定日期與時間(小時制)"},
       *  {"Id":4,"Name":"設定日期與時間範圍(小時制)"},
       *  {"Id":5,"Name":"設定日期與時間(半小時制)"},
       *  {"Id":6,"Name":"設定日期與時間範圍(半小時制)"},
       *  {"Id":7,"Name":"設定日期與時間(五分制)"},
       *  {"Id":8,"Name":"設定日期與時間範圍(五分制)"},
       *  {"Id":9,"Name":"無日期與時間設定"}, -> 不會進來這裡
       *  {"Id":10,"Name":"設定平假日與時段"}
       * ]
       */
      const setServiceTimeDefaultMode = () => {
        if ([1, 10].includes(this.service.serviceTimeType.id)) {
          this.selectedData.datetime.defaultModeList = this.getServiceTimeDefaultMode()
        }
        if (this.service.serviceTimeType.id === 10) {
          this.selectedData.datetime.weekdayOrWeekendModeList = this.setWeekdayOrWeekendModeList()
        }
      }
      // 該服務開放電聯 -> 取得電聯費資訊
      if (this.service.IsNeedCheckContactPickUpFee) {
        await this.apiGetContactPickupFee()
      }

      await Promise.all([
        this.getPromotion(),
        this.getPriceOption(),
        setArea(),
        this.setPayment(),
        setServiceTimeDefaultMode(),
        this.getPackageType()
      ])
    } catch (error) {
      console.log('error', error)
    }
  },
  computed: {
    ...mapGetters(['isAgentOrder', 'isGuestAgent']),
    ...mapGetters('service', ['householdApplianceSupplier', 'householdApplianceServiceTypeId']),
    ...mapState(['agentOrder', 'guestPurchase', 'isFromFacebookAds']),
    ...mapState('order', ['firebaseMatchResult']),
    service () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    },
    isAddressMode () {
      return this.service?.serviceAddressMode?.id === 1
    },
    enterpriseCoinAvailable () {
      const enterpriseCoinAvailableServiceTypeId = this.$nuxt.context.env.ENTERPRISE_POINT_AVAILABLE_SERVICE_TYPE_ID
      return enterpriseCoinAvailableServiceTypeId.includes(this.service.type_id)
    },
    optionGroup () {
      return _.cloneDeep(this.$store.getters['service/optionGroup'](this.serviceId))
    },
    cityList () {
      return this.$store.getters['service/regionList'](this.serviceId)
    },
    allCityList () {
      return this.$store.state.allCityArea
    },
    allAreaList () {
      if (!this.selectedData.recipient.city.region_id) return []
      const theCity = _.find(this.$store.state.allCityArea, { region_id: this.selectedData.recipient.city.region_id })
      return theCity && theCity.areaList ? theCity.areaList : []
    },
    selectDataDateTimeShow () {
      return this.selectedData.datetime.date ? this.$dayjs(this.selectedData.datetime.date).format('YYYY年MM月DD日') : '請選擇期望日期'
    },
    serviceDate () {
      const serviceDate = this.$store.getters['service/serviceDate'](this.serviceId)
      // 可選日期不在當月，將預設日期帶成可選第一天，使月曆顯示可選日期的那月份
      if (serviceDate?.length && serviceDate[0].FeatureDate &&
        !this.selectedData.datetime.date &&
        this.selectedData.datetime.dateOpen) {
        const theDate = this.$dayjs(serviceDate[0].FeatureDate).format('YYYY-MM-DD')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$set(this.selectedData.datetime, 'date', theDate)
        this.changeDateTimeDate(theDate, true)
      }
      return serviceDate
    },
    serviceTimeDay () {
      if (!this.service || !this.service.ServiceTime) return []
      if (!this.selectedData.datetime.date) return []
      let dayNumber = this.$dayjs(new Date(this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' '))).day()
      dayNumber = dayNumber === 0 ? 7 : dayNumber
      return this.service.ServiceTime.filter(day => parseInt(day.Days) === parseInt(dayNumber)) || []
    },
    serviceTimeMinute () {
      const serviceTimeTypeId = this.service.serviceTimeType.id
      switch (serviceTimeTypeId) {
        case 3: // 時間(小時)
          break
        case 4: // 時間範圍(小時)
          break
        case 5: // 時間(半小時)
          break
        case 6: // 時間範圍(半小時)
          break
        case 7: // 時間(5分鐘)
          break
        case 8: // 時間範圍(5分鐘)
          break
        default:
          break
      }
      return serviceTimeTypeId
    },
    totalPrice () {
      console.log('this.selectedData.discount', this.selectedData.discount)
      return this.selectedData.price.totalPrice - this.usedDiscount
    },
    usedDiscount () { // 使用優惠
      return this.discountAmount + this.ticketAmount + this.bonusAmount
    },
    discountAmount () {
      return this.selectedData.discount.code.discount
    },
    ticketAmount () {
      return this.selectedData.discount.ticket.discount
    },
    enterpriseCoinDiscountAvailable () { // 是否能使用&是否有 企業點數折抵
      return this.enterpriseCoinAvailable && this.selectedData.discount.bonus.point?.CanUseEnterpriseAmount
    },
    canUseBonusAmount () {
      let bonusAmount = this.selectedData.discount.bonus.point.CanUseBonusAmount

      // 企業點數
      if (this.enterpriseCoinDiscountAvailable) {
        bonusAmount += (this.selectedData.discount.bonus.point.CanUseEnterpriseAmount)
      }
      return bonusAmount > 0 ? bonusAmount : 0
    },
    bonusAmount () {
      const useBonus = this.selectedData.discount.bonus.state === 'used'

      return useBonus && this.canUseBonusAmount > 0 ? this.canUseBonusAmount : 0
    },
    canUsePaymentListByPrice () {
      // await this.$store.dispatch('checkMobilePayment', { amount: this.totalPrice })
      return this.payment.paymentOptionList.filter(option => !option.MinimumOrderAmountOfEnablePaymentType || (this.totalPrice >= option.MinimumOrderAmountOfEnablePaymentType))
        .filter(option => {
          return (this.$store.state.payment.applePay.available || option.PaymentTypeId !== 8) && (this.$store.state.payment.googlePay.available || option.PaymentTypeId !== 7)
        })
    },
    paymentSelectedInfo () {
      console.log('paymentSelectedInfo:', this.canUsePaymentListByPrice)
      return this.canUsePaymentListByPrice.find(payment => payment.PaymentTypeId === this.selectedData.payment)
    },
    priceCountTotal () {
      return Object.values(this.selectedData.price.option).reduce((a, c) => a + c, 0)
    },
    selectedOptionPriceArr () {
      return this.optionPriceGroup.filter(v => v.optionCount)
    },
    isSkuSelected () {
      return (this.selectProductDialog && this.selectProductDialog.selectedPrice) && (!this.selectProductDialog.selectedPrice.ProductInfo || (this.selectProductDialog.selectedPrice.ProductInfo.VariantCount < 1) || this.selectProductDialog.selectedPrice.ProductInfo.Skus.some(v => v.selected))
    },
    contactServicePriceTotal () {
      if (!this.alreadySelectedCommunity || !this.isKTJLogistic) return 0
      let priceTotal = 0
      this.selectedData.region.community.ContactFlagPriceOptionList.forEach(priceInfo => {
        priceTotal += priceInfo.Price
      })
      return priceTotal
    },
    contactFlagPriceOptionList () {
      if (!this.alreadySelectedCommunity || !this.selectedContactService || !this.isKTJLogistic) return []
      return this.selectedData.region.community.ContactFlagPriceOptionList.map(priceInfo => {
        priceInfo.PriceCount = 1
        return priceInfo
      })
    },
    // 將取得的資料弄成陣列，才能顯示在品項
    uWashContactFlagPriceOptionList () {
      if (!this.service.IsNeedCheckContactPickUpFee || !this.contactPickupFeeList.length) return [] // 如未開放電聯，不加入品項
      return this.contactPickupFeeList.map(priceInfo => {
        priceInfo.PriceCount = 1
        return priceInfo
      })
    },
    // 電聯費總額
    uWashContactServicePriceTotal () {
      if (!this.service.IsNeedCheckContactPickUpFee || !this.uWashContactFlagPriceOptionList.length) return 0
      let priceTotal = 0
      this.uWashContactFlagPriceOptionList.forEach(priceInfo => {
        priceTotal += priceInfo.Price
      })
      return priceTotal
    },
    // 判斷是否顯示在品項中 和 是否將電聯費用加入總額
    showContactFeeInOptionList () {
      const hasContactPickupInfo = this.uWashContactFlagPriceOptionList.length > 0
      const forceContactPickup = this.selectedData?.region?.community?.HasContactFlag

      // 有電聯費用資訊，且強制電聯或有勾選電聯費用
      return hasContactPickupInfo && (forceContactPickup || this.contactPickupChecked)
    },
    alreadySelectedCommunity () { // 是否已選擇社區
      return Object.keys(this.selectedData.region.community).length !== 0
    },
    rules () {
      return {
        personalInfo: {
          nameRules: [v => !!v || '請輸入會員姓名'],
          phoneRules: [
            v => !!v || '請輸入會員手機',
            v => {
              const pattern = /^09[0-9]{8}$/
              return pattern.test(v) || '請輸入正確格式 0900123456'
            }
          ]
        },
        region: {
          nameRule: value => !!value || '請輸入客戶姓名',
          phoneRules: value => {
            const errorText = '聯絡電話格式錯誤'
            // 電話必為 9~15 碼，且為 0 開頭 (不能886)
            if (value?.length < 9 || value.slice(0, 1) !== '0') return errorText
            // 手機驗證：09 開頭，10 碼皆為數字
            if (value.slice(0, 2) === '09' && !(/^\d{10}$/).test(value)) return errorText
            // 市話驗證：非 09 開頭，允許數字、*、#
            if (value.slice(0, 2) !== '09' && !(/^[0-9*#]+$/).test(value)) return errorText
            return true
          },
          addressRule: value => !!value || '',
          communityRule: value => Object.entries(value).length > 0 || '請選擇服務位置'
        },
        recipient: {
          nameRule: value => !!value || '請輸入收件人姓名',
          phoneRules: value => {
            const errorText = '聯絡電話格式錯誤'
            // 電話必為 9~15 碼，且為 0 開頭 (不能886)
            if (value?.length < 9 || value.slice(0, 1) !== '0') return errorText
            // 手機驗證：09 開頭，10 碼皆為數字
            if (value.slice(0, 2) === '09' && !(/^\d{10}$/).test(value)) return errorText
            // 市話驗證：非 09 開頭，允許數字、*、#
            if (value.slice(0, 2) !== '09' && !(/^[0-9*#]+$/).test(value)) return errorText
            return true
          },
          addressRule: value => !!value || ''
        },
        receipt: {
          mailRule: value => {
            return this.$checkEmailFormat(value) || '請輸入E-mail'
          },
          companyMailRule: value => {
            return this.$checkEmailFormat(value) || '請輸入E-mail'
          },
          idNumberRequired: value => !!value || '請輸入公司統一編號',
          idNumberFormat: value => {
            const pattern = /^[0-9]{8}$/
            return pattern.test(value) || '統一編號格式錯誤'
          },
          idNumberValidate: value => {
            return validateTaxId(String(value)) || '統一編號格式錯誤'
          },
          barcodeRule: value => {
            const pattern = /^\/[A-Za-z0-9\s+.-]{7}$/
            return pattern.test(value) || '請輸入手機條碼'
          }
        },
        channelType: {
          typeRules: v => v > 0 || '請填寫「如何得知本服務」',
          otherRules: v => !!v || '請填寫描述'
        }
      }
    },
    isGuestPurchase () {
      return Boolean(this.guestPurchase.createGuestAccountData) && !this.$auth.loggedIn
    },
    serviceProcessMode () {
      return this.service?.ServiceProcessMode?.Mode
    },
    isKTJLogistic () {
      return this.service?.ServiceProcessMode?.Mode === 'KTJLogistic'
    },
    isTCatLogistic () {
      return this.service?.ServiceProcessMode?.Mode === 'TCatLogistic'
    },
    isQuotationMode () {
      return this.service?.NegotiateModeId === 2
    },
    isCheckPackageType () {
      return this.isKTJLogistic || this.isTCatLogistic
    },
    setDialogWidth () {
      if (this.isMobile) return 'auto'
      if (this.selectProductDialog?.selectedPrice?.Images.length > 0) return '750'
      return '530'
    },
    showDiscount () {
      return (Object.values(this.promotion.selectedOptionByPromotionId).length > 0 && Object.values(this.promotion.selectedOptionByPromotionId)[0].totalCount) || // 優惠活動
        (this.selectedData.discount.code.isUse && this.selectedData.discount.code.detail && this.selectedData.discount.code.detail.DiscountAmount && this.selectedData.discount.code.detail.OrderActivityType === 2) || // 折扣碼
        (this.selectedData.discount.code.isUse && this.selectedData.discount.code.detail.OrderActivityType === 1) || // 推薦優惠
        this.ticketAmount > 0 || // 優惠券
        this.bonusAmount > 0 // 紅利點數
    },
    issueBankText () { // 發卡機構文字(限制20字)
      if (!this.creditCardSelectorDialog.selectedCard) return ''
      return this.creditCardSelectorDialog.selectedCard.IssueBank.length > 20 ? this.creditCardSelectorDialog.selectedCard.IssueBank.substring(0, 20) : this.creditCardSelectorDialog.selectedCard.IssueBank
    },
    serviceResponseDays () {
      const responseTime = this.service?.ProcessTimes.filter(v => v.Type === 'SlowestResponse')
      if (responseTime.length && responseTime[0].Seconds) {
        const responseSeconds = responseTime[0].Seconds
        return Math.ceil(responseSeconds / 60 / 60 / 24)
      }
      return null
    }
  },
  watch: {
    async pageNow (val) {
      if (val === 3) {
        if (this.isCommunity) { // 社區模組
          this.setCommunityList()
            .then(() => {
              // 如果僅有一個可用社區，自動帶入
              const canSelectedCommunityList = this.communitySelectList.filter(community => !community.isDisabled)
              if (canSelectedCommunityList.length === 1) {
                this.$set(this.selectedData.region, 'community', canSelectedCommunityList[0])
              }
            })
        }
        this.setChannelTypeList()
          .then(() => {
            if (this.selectedData.channelType.id !== 0) return
            const checkHasDefault = () => {
              const defaultType = _.find(this.channelTypeList, { channel_type_id: 6 })
              if (defaultType) return defaultType
              const sameNameType = _.find(this.channelTypeList, { name: '智生活官方網站' })
              return sameNameType
            }
            const defaultType = checkHasDefault()
            if (defaultType) {
              this.selectedData.channelType.id = defaultType.channel_type_id
            }
          })
        this.setDefaultAddressInfo()
        if (this.service.serviceMultipContact && this.service.serviceMultipContact.id === 2) {
          // 寄 / 收件模式：一對一交付
          await this.$store.dispatch('getAllCity')
          this.$set(this.selectedData.recipient, 'city', this.allCityList[0])
          this.changeAllCity(this.allCityList[0])
        }
        if (this.$auth.loggedIn) this.setUserCommunity() // 取得會員(最新登入裝置)現居社區

        if (this.totalPrice > 0) {
          await this.$store.dispatch('checkMobilePayment', { amount: this.totalPrice })
        }
        this.FBConversionAPI('InitiateCheckout')
        this.$nextTick(async () => {
          await this.$refs?.codeDiscount?.discountSetHandler()
        })
      }
    },
    'personalInfo.BirthdayMenu' (val) {
      val && setTimeout(() => (this.$refs.personalBirthdayPicker.activePicker = 'YEAR'))
    },
    'selectedData.region.community' (val) {
      if (val.HasContactFlag && val.PayForContactFlag) {
        // 強制電聯社區預設開啟電聯收費項目
        this.selectedContactService = true
      } else {
        this.selectedContactService = false
      }
      if (val.CommunityAddressList && val.CommunityAddressList.length) {
        this.multiAddress.show = true
        this.multiAddress.list = val.CommunityAddressList
        this.$set(this.selectedData.region, 'communityAddress', this.multiAddress.list[0])
      } else {
        this.multiAddress.show = false
        this.multiAddress.list = []
        this.$set(this.selectedData.region, 'communityAddress', '')
      }
    },
    'selectedContactService' (val) {
      if (val) {
        this.selectedData.price.totalPrice += this.contactServicePriceTotal
      } else {
        this.selectedData.price.totalPrice -= this.contactServicePriceTotal
      }
    },
    // 強制電聯 || 非強制但勾選要電聯 -> 更改總額
    showContactFeeInOptionList (val) {
      if (val) {
        this.selectedData.price.totalPrice += this.uWashContactServicePriceTotal
      } else {
        this.selectedData.price.totalPrice -= this.uWashContactServicePriceTotal
      }
    },
    '$auth.loggedIn' (val) {
      if (!val) {
        this.personalInfo = {
          phoneIsSaved: false,
          phoneIsSaving: false,
          AId: '',
          AName: '',
          APhone: '',
          AGender: '',
          ABirthday: '',
          ABirthdayShow: '',
          BirthdayMenu: false,
          checkValidate: null
        }
        this.regionDialog.regionList = []
        this.selectedData.recipient = {
          postId: '',
          city: {},
          area: {},
          name: '',
          phone: '',
          address: '',
          addressCheckValidate: null,
          remember: false
        }
        this.selectedData.region = {
          ...this.selectedData.region,
          name: '',
          phone: '',
          address: '',
          addressCheckValidate: null,
          selectTabletId: '',
          community: {},
          communityCheckValidate: null,
          contactFlag: false,
          syncBuyerInfo: false
        }
        if (this.selectedData.receipt.donateOptions.length === 0) {
          this.selectedData.receipt.donateOptions = _.cloneDeep(DonateList)
        }
        this.selectedData.receipt = {
          ...this.selectedData.receipt,
          type: 1,
          mail: '',
          companyMail: '',
          city: '',
          area: '',
          address: '',
          idNumber: '',
          barcode: '',
          donate: this.selectedData.receipt.donateOptions[0].NPOBAN,
          checkboxCheck: false,
          tooltipOpen: false
        }
        this.selectedData.channelType = {
          id: 0,
          other: '',
          checkValidate: null
        }
        this.selectedData.referrer.name = ''
        this.selectedData.note.data = ''
        this.selectedData.channelType.other = ''
        this.selectedData.discount = {
          bonus: {
            state: 'empty', // 'disable', 'used', 'notuse', 'empty'
            point: {
              CanUseBonusAmount: 0,
              CanUseEnterpriseAmount: 0
            },
            isLoading: false,
            enterpriseCodes: []
          },
          ticket: {
            discount: 0,
            TicketInstanceId: null,
            index: null
          },
          code: {
            discount: 0,
            detail: null,
            input: '',
            isUse: false,
            isSaving: false,
            errorMessage: ''
          }
        }
        this.selectedData.photoList = []
        this.discount = {
          bonus: {
            status: '',
            total: 0,
            isUse: false,
            got: false
          },
          enterprisePoint: 0,
          ticket: {
            list: [],
            value: {},
            index: null,
            got: false
          },
          dialog: {
            open: false
          }
        }
        this.$store.commit('resetPersonalInfo')
        this.creditCardSelectorDialog.selectedCard = null
        this.creditCardSelectorDialog.cardList = []
      }
    },
    'selectedData.channelType.id' (val) {
      this.showSource = [3, 4, 5, 10, 13, 14].includes(val)
    },
    canUsePaymentListByPrice (val) {
      this.selectedData.payment = val?.[0]?.PaymentTypeId || 0 // 預設選擇第一項
    },
    'selectedData.datetime.dateOpen' (val) {
      if (val) {
        this.FBConversionAPI('點擊預約日期與時段')
      }
    },
    syncBuyerInfo (val) {
      if (val) {
        this.selectedData.region.name = this.personalInfo.AName
        this.selectedData.region.phone = this.personalInfo.APhone
      }
    },
    'personalInfo.AName' (val) {
      if (this.selectedData.region.name !== val) this.syncBuyerInfo = false
    },
    'selectedData.region.name' (val) {
      if (this.personalInfo.AName !== val) this.syncBuyerInfo = false
    },
    'selectedData.region.phone' (val) {
      if (this.personalInfo.APhone !== val) this.syncBuyerInfo = false
    },
    isReviewDeep (val) {
      if (val) {
        this.$infobipTrackEvent('pageReviewDeep', {
          serviceId: `${this.serviceId}`
        })
      }
    },
    'matchResult.canChangeDialog' (val) {
      if (val && ([2, 6, 7].includes(this.firebaseMatchResult.matchStatus) || this.matchResult.matchStatus === 7)) {
        this.changeAlertDialog(this.firebaseMatchResult.matchStatus || 7)
        this.matchResult.searchDialogOpen = false
        this.alertDialog.open = true
      }
    },
    'firebaseMatchResult.matchStatus' (val) {
      if (val && [2, 6, 7].includes(val) && this.matchResult.canChangeDialog) {
        this.changeAlertDialog(val)
        this.matchResult.searchDialogOpen = false
        this.alertDialog.open = true
      }
    }
  },
  async mounted () {
    this.isMobile = screen.width <= 768
    await this.getFBTrackSetting()
    await this.checkAgentOrder()
    this.setPersonalInfo()
    this.setOptionValue()
    this.setUrlParams()
    if (this.selectedData.receipt.donateOptions.length === 0) {
      this.selectedData.receipt.donateOptions = _.cloneDeep(DonateList)
      this.selectedData.receipt.donate = this.selectedData.receipt.donateOptions[0].NPOBAN
    }
    if (process.client && this.$auth.loggedIn) {
      await this.setReceipt(this.selectedData.receipt)
      if (!this.isCommunity) {
        await this.setAddress()
      }
    }
    if (sessionStorage.getItem('serviceData') && JSON.parse(sessionStorage.getItem('serviceData')).id === parseInt(this.serviceId)) {
      const { service } = JSON.parse(sessionStorage.getItem('serviceData'))
      const { toPage } = JSON.parse(sessionStorage.getItem('serviceData')) || 1
      const { termIsRead } = JSON.parse(sessionStorage.getItem('serviceData')) || false
      const { isLogined } = JSON.parse(sessionStorage.getItem('serviceData')) || false
      const { promotion } = JSON.parse(sessionStorage.getItem('serviceData')) || {}
      const { isCheckoutPageLogin } = JSON.parse(sessionStorage.getItem('serviceData')) || false
      if (isLogined) {
        await this.setPriceOptionSelectedValue(service.price.option)
        this.$set(this, 'selectedData', _.cloneDeep(service))
        setTimeout(async () => {
          if (!this.isCheckoutPageLogin) {
            this.$set(this.selectedData.region, 'city', _.cloneDeep(service.region.city))
            this.setAreaList(service.region.city.MainID)
            this.$set(this.selectedData.region, 'area', _.cloneDeep(service.region.area))
          } else {
            this.setGuestLoginAddressInfo()
            await this.setReceipt(this.selectedData.receipt)
            this.isCheckoutPageLogin = false // 已是登入狀態
          }
          if (this.pageNow === 3) {
            const headerHeight = document.querySelector('#header').offsetHeight + 20
            await this.$vuetify.goTo('#service-item', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
          }
        }, 500)
        this.pageNow = toPage
        this.promotion = promotion
        this.isCheckoutPageLogin = isCheckoutPageLogin
      }
      this.term.isRead = termIsRead
      sessionStorage.removeItem('serviceData')
    }
    if (process.client) {
      this.$auth.$storage.watchState('loggedIn', islogged => {
        if (!islogged) { // 登出
          if (this.pageNow > 1) { // 步驟大於1
            this.pageNow = 1
          }
        }
      })
    }

    const defaultScrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    const defaultOffsetHeight = window.innerHeight
    if (defaultScrollHeight && defaultScrollHeight === defaultOffsetHeight) {
      this.isReviewDeep = true
    }
    window.addEventListener('scroll', this.handleScroll)
    this.stayTimer = setTimeout(() => {
      this.$infobipTrackEvent('pageStayLong', {
        serviceId: `${this.serviceId}`
      })
    }, 60000)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.stayTimer)
    this.$store.commit('order/setFirebaseMatchResult', { matchStatus: null, matchType: null, isSchedule: false })
  },
  methods: {
    async apiGetContactPickupFee () {
      try {
        const { data } = await this.$axios.get(`/api/Main/${parseInt(this.serviceId)}/ContactPickupFee`)
        this.contactPickupFeeList = [data.Data]
      } catch (error) {
        return Promise.reject(error)
      }
    },
    logInfoPageGaEvent (text) {
      this.$gaLogEvent('預約資訊頁', `${text}_${this.service.service_title}_${this.serviceId}`)
    },
    logPriceOptionGaEvent (count, { sku = null, price = null }) {
      if (count > 0) return
      if (sku) {
        this.$gaLogEvent('品項選擇頁', `click_移除品項_${price.price_name + ' ' + this.getSelectedSkuNameJoin(price, sku, ',')}_${this.service.service_title}_${this.serviceId}`)
      } else {
        this.$gaLogEvent('品項選擇頁', `click_移除品項_${price.price_name}_${this.service.service_title}_${this.serviceId}`)
      }
    },
    FBConversionAPI (event_name, custom_data = {}) {
      const payload = {
        event_name,
        user_data: {
          first_name: this.$auth.loggedIn ? this.personalInfo.AName : 'guest',
          date_birth: this.personalInfo.ABirthday || '',
          gender: this.personalInfo.AGender || '',
          phone: this.personalInfo.APhone || '',
          email: this.$auth.user?.AEmail || ''
        },
        custom_data: {
          currency: 'TWD',
          service_id: this.service.service_id,
          content_name: this.service.service_title,
          from_fb_ads_link: this.isFromFacebookAds
        }
      }
      switch (event_name) {
        case 'AddToCart':
        case 'InitiateCheckout':
        case 'AddPaymentInfo':
        case 'Purchase':
          payload.custom_data = {
            ...payload.custom_data,
            value: this.selectedData.price.totalPrice,
            content_type: this.selectedData.price.option.length > 1 ? 'product_group' : 'product',
            content_ids: Object.keys(this.selectedData.price.option),
            contents: Object.entries(this.selectedData.price.option).map(([priceId, priceCount]) => {
              return { id: priceId, quantity: priceCount }
            }),
            ...custom_data
          }
          break
        default:
          payload.custom_data = {
            ...payload.custom_data,
            ...custom_data
          }
          break
      }
      this.$FBConversionAPI(payload)
    },
    async getFBTrackSetting () {
      const messageRef = firebaseSmartlife.database().ref('ecweb/FBTrackSetting')
      return new Promise((resolve, reject) => {
        try {
          messageRef.once('value', snapshot => {
            const { ExcludeChannelType = [], Services = [] } = snapshot.val()
            this.FBTrackServices = Services
            this.FBTrackExcludeChannelType = ExcludeChannelType
            return resolve()
          })
        } catch (error) {
          return resolve()
        }
      })
    },
    saveRouteAndSelectedData () {
      const toPage = this.isNextStep
        ? this.pageNow === 1 && this.optionGroup.length === 0 ? 3 : this.pageNow + 1
        : this.pageNow
      sessionStorage.setItem('serviceData', JSON.stringify({
        id: parseInt(this.serviceId),
        service: this.selectedData,
        toPage,
        termIsRead: this.term.isRead,
        promotion: this.promotion,
        isCheckoutPageLogin: !this.$auth.loggedIn
      }))
      // 若非點擊登入/註冊 則不儲存route資料
      const savedRouteName = this.$auth.$storage?.state?.toRoute?.name
      const currentRouteName = this.$nuxt.$route.name
      if (savedRouteName === currentRouteName || !savedRouteName) {
        this.$auth.$storage.setState('toRoute', {
          name: this.$nuxt.$route.name,
          params: this.$nuxt.$route.params
        })
      }
    },
    memberLogin () {
      this.logInfoPageGaEvent('click_立即登入')
      this.FBConversionAPI('點擊會員登入')
      this.$gtm.push({
        event: 'serviceLoginStart',
        serviceName: this.service.service_title,
        pageTitle: document.title,
        pageType: 'service',
        pageUrl: this.$nuxt.$route.path,
        routeName: this.$nuxt.$route.name
      })
      this.$nuxt.$router.push({ name: 'login' })
    },
    // 更新折扣使用
    updateDiscountDataHandler ({ type, data }) {
      if (type === 'code') {
        this.discount.ticket.got = false
      }
      this.selectedData.discount[type] = data
    },
    gtmFormErrorEvent (errorBlock, errorType) {
      const errorTypeString = errorType ? `_${errorType}` : ''
      this.$gaLogEvent('錯誤訊息', `${this.pages[this.pageNow - 1]}_${errorBlock}${errorTypeString}`)
      this.$gtm.push({
        event: 'validationError',
        errorPage: this.pageNow,
        errorBlock,
        errorType
      })
    },
    // 服務代訂
    async checkAgentOrder () {
      const query = { ...this.$route.query }
      if (!query.agentToken) return
      await this.$store.dispatch('setAgentOrder', query)
      if (this.isGuestAgent) {
        this.personalInfo.APhone = query.phone
        this.personalInfo.AName = query.name
      }
      this.$router.replace({ query: null })
    },
    updatePhone (phone) {
      this.personalInfo.APhone = phone
    },
    getImageUrl (imgUrl) {
      if (!imgUrl) return imgUrl
      if (imgUrl.substring(0, 5) === 'http:') {
        return 'https:' + imgUrl.substring(5)
      } else {
        return imgUrl
      }
    },
    checkImageIsUploaded (imgUrl) {
      return imgUrl.substring(0, 4) === 'http'
    },
    inputBarcode (val) {
      if (!val.target.value) return
      let value = val.target.value
      if (value.substring(0, 1) !== '/') {
        value = '/' + value
      }
      this.selectedData.receipt.barcode = value.toUpperCase()
    },
    setPriceFormat (price) {
      if (price === null || price === undefined) return null
      return price?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    removePriceFormat (price) {
      return price?.toString().replace(/,/g, '')
    },
    setPersonalInfo () {
      let personalInfo = this.personalInfo
      if (process.client) {
        personalInfo = {
          ...personalInfo,
          ...this.$auth.user
        }
      }
      if (personalInfo.ABirthday) {
        if (personalInfo.ABirthday.split('-')[0] === '0001' ||
          personalInfo.ABirthday.split('/')[0] === '0001') {
          // 預設日期
          personalInfo.ABirthday = null
        } else {
          personalInfo.ABirthday = this.$dayjs(new Date(personalInfo.ABirthday.replaceAll('-', '/').replaceAll('T', ' '))).format('YYYY-MM-DD')
          personalInfo.ABirthdayShow = this.$dayjs(new Date(personalInfo.ABirthday.replaceAll('-', '/').replaceAll('T', ' '))).format('YYYY年MM月DD日')
        }
      }
      if (personalInfo.AGender === 'male') { // 男性
        // personalInfo.AGender = '男'
      } else if (personalInfo.AGender === 'female') { // 女性
        // personalInfo.AGender = '女'
      }
      this.$set(this, 'personalInfo', {
        ...personalInfo,
        phoneIsSaved: !!personalInfo.APhone && !this.isGuestAgent,
        nameIsSaved: !!personalInfo.AName
      })
    },
    async setUserCommunity () {
      if (this.personalInfo.UserCommunity) return
      try {
        const { data } = await this.$axios.get('/api/KingnetAccount/GetUserCommunity')
        if (data.Data.length > 0 && data.Data[0].DefaultCommunity) {
          // 現居社區
          this.$set(this.personalInfo, 'UserCommunity', data.Data[0])
        }
      } catch (error) {
        return Promise.resolve()
      }
    },
    setUrlParams () {
      if (!process.client || !this.$auth.$storage.getCookie('routerSave')) return
      const routerSave = this.$auth.$storage.getCookie('routerSave')
      if (routerSave && (this.isAgentOrder || this.isGuestAgent)) {
        this.$auth.$storage.removeCookie('routerSave')
        return
      }
      this.lockSource = Boolean(['3', '10', '14'].includes(routerSave.channel) && routerSave.referrer)
      if (routerSave.referrer) {
        this.selectedData.referrer.name = routerSave.referrer
      }
      if (routerSave.channel) {
        this.selectedData.channelType.id = parseInt(routerSave.channel)
      }
      if (routerSave.discount) {
        this.selectedData.discount.code.input = routerSave.discount
      }
    },
    async getPromotion () { // 取得優惠活動資料
      if (!this.service?.has_promotion || this.isQuotationMode) return // 沒有優惠活動
      const { data } = await this.$axios.get('/api/Promotion/GetPromotionDataByServiceId', { params: { service_id: this.serviceId } })
        .catch(error => {
          return Promise.reject(error)
        })
      await this.$set(this.promotion, 'PromotionDataList', data.Data.PromotionDataList)
    },
    async getServiceOptionData () { // 取得服務選項資料
      const { data } = await this.$axios.get('/api/Main/GetGroupDetailByHasPromotionTag', { params: { id: this.serviceId } })
        .catch(error => {
          return Promise.reject(error)
        })
      return Promise.resolve(data.Data.service_detail[0])
    },
    async savePhone () {
      this.$gaLogEvent('發送驗證碼', '預約頁_click_驗證')
      this.personalInfo.phoneErrorMessage = ''
      if (this.personalInfo.phoneIsSaving) return
      if (!this.$refs.personalPhone.validate()) return
      if (!this.$auth.loggedIn) {
        try {
          this.personalInfo.phoneIsSaving = true
          const isAvaliablePhoneNumber = await this.checkIsAvaliablePhoneNumber(this.personalInfo.APhone)
          this.personalInfo.phoneIsSaving = false
          if (!isAvaliablePhoneNumber) return
        } catch (err) {
          this.personalInfo.phoneIsSaving = false
        }
        this.loginDailog.propStep = 'guestValidation'
      } else {
        this.loginDailog.propStep = 'phoneValidation'
      }
      this.loginDailog.open = true
    },
    changePayment () {
      this.discount.bonus.got = false
      this.discount.ticket.got = false
    },
    checkPriceCountValidate (option) {
      const checkValidate = {
        isError: false,
        errorMessage: ''
      }
      if (option.max_limit > 0 && option.optionCount > option.max_limit) {
        // 超過最大數量
        checkValidate.isError = true
        checkValidate.errorMessage = '超過品項最大數量'
      }
      if (option.checkValidate && option.checkValidate.isError) {
        checkValidate.isError = option.checkValidate.isError
        checkValidate.errorMessage = option.checkValidate.errorMessage
      }
      return checkValidate
    },
    getPriceOption () {
      const priceOptionGroup = (_.cloneDeep(this.$store.state.service.serviceData?.[this.serviceId]?.ServicePriceOptionGroup) || [])
        .map(option => {
          let optionCount = 0
          option.price_option.map(price => {
            price.price_count = price.price_count || 0
            optionCount += price.price_count
            if (this.isQuotationMode) {
              price.promotion_data = []
              price.promotion_list = []
            }
            return price
          })
          option.optionCount = optionCount
          option.required = option.lowest_limit > 0
          return option
        })
      this.$set(this, 'optionPriceGroup', priceOptionGroup)
    },
    async setPriceOptionSelectedValue (priceSelected) {
      this.optionPriceGroup.forEach(option => {
        let optionCount = 0
        option.price_option.forEach(price => {
          if (priceSelected[price.price_id]) {
            price.price_count = priceSelected[price.price_id]
            optionCount += price.price_count
          }
        })
        option.optionCount = optionCount
      })
    },
    setOptionValue () {
      const optionValue = { ...this.selectedData.option }
      this.optionGroup.forEach(option => {
        if (option.category_option === 2) {
          // 單選
          optionValue[option.category_id] = null
        }
        if (option.category_option === 4) {
          // 複選
          optionValue[option.category_id] = []
        }
        if (option.category_option === 5) {
          // 問答
          optionValue[option.category_id] = ''
        }
      })
      this.$set(this.selectedData, 'option', optionValue)
    },
    async setPayment () { // 設定付款方式
      await this.$set(this.payment, 'paymentOptionList', this.service.PaymentTypeWithPaymentTiming)
    },
    async setAddress () {
      try {
        const addressList = await this.$store.dispatch('getPersonalAddress')
        addressList.forEach(address => {
          let city = address.City
          address.isDisabled = false
          if (city.substring(0, 1) === '台') {
            city = '臺' + city.substring(1)
          }
          const theCity = _.find(this.cityList, { MainName: city })
          if (!theCity) {
            address.isDisabled = true
          } else {
            const theArea = _.find(theCity.AreaList, { ParentName: address.Area })
            if (!theArea) {
              address.isDisabled = true
            }
          }
        })
        this.$set(this.regionDialog, 'regionList', addressList)
      } catch (error) {
      }
      const defaultAddress = this.$store.getters.personalInfoDefaultAddress
      if (!defaultAddress) return
      let defaultCity = defaultAddress.City
      if (defaultCity.substring(0, 1) === '台') {
        defaultCity = '臺' + defaultCity.substring(1)
      }
      const selectedCity = _.find(this.cityList, { MainName: defaultCity })
      if (!selectedCity) return // 預設地址「縣市」不符合服務地區
      const selectedArea = _.find(selectedCity.AreaList, { ParentName: defaultAddress.Area })
      if (!selectedArea) return // 預設地址「區域」不符合服務地區
      this.selectedData.region.city = selectedCity
      this.setAreaList(selectedCity.MainID)
      this.selectedData.region.area = selectedArea
    },
    setDefaultAddressInfo () { // 設定&判斷預設地址
      if (this.selectedData.region.name && this.selectedData.region.phone && !_.isEmpty(this.selectedData.region.city) && !_.isEmpty(this.selectedData.region.area) && this.selectedData.region.address) {
        this.setAreaList(this.selectedData.region.city.MainID)
        return
      }
      const defaultAddress = this.$store.getters.personalInfoDefaultAddress
      if (!defaultAddress) return
      let defaultCity = defaultAddress.City
      if (defaultCity.substring(0, 1) === '台') {
        defaultCity = '臺' + defaultCity.substring(1)
      }
      if (defaultCity !== this.selectedData.region.city.MainName ||
        defaultAddress.Area !== this.selectedData.region.area.ParentName) {
        // 已選縣市區域與預設地址不符合
        // this.selectedData.region.name = ''
        // this.selectedData.region.phone = ''
        // this.selectedData.region.address = ''
        // if (this.$refs.serviceRegionAddress) {
        //   this.$refs.serviceRegionAddress.resetValidation()
        // }
        // if (this.$refs.serviceRegionPersonal) {
        //   this.$refs.serviceRegionPersonal.resetValidation()
        // }
        return
      }
      this.selectedData.region.name = defaultAddress.Name
      this.selectedData.region.phone = defaultAddress.Phone
      this.selectedData.region.address = defaultAddress.Address
      const theIndex = _.findIndex(this.regionDialog.regionList, { City: defaultAddress.City })
      this.regionDialog.selectedIndex = theIndex
    },
    setGuestLoginAddressInfo () {
      if (this.selectedData.region.name && this.selectedData.region.phone && !_.isEmpty(this.selectedData.region.city) && !_.isEmpty(this.selectedData.region.area) && this.selectedData.region.address) {
        this.setAreaList(this.selectedData.region.city.MainID)
        return
      }
      const defaultAddress = this.$store.getters.personalInfoDefaultAddress
      if (!defaultAddress) return
      let defaultCity = defaultAddress.City
      if (defaultCity.substring(0, 1) === '台') {
        defaultCity = '臺' + defaultCity.substring(1)
      }
      const selectedCity = _.find(this.cityList, { MainName: defaultCity })
      if (!selectedCity) return // 預設地址「縣市」不符合服務地區
      const selectedArea = _.find(selectedCity.AreaList, { ParentName: defaultAddress.Area })
      if (!selectedArea) return // 預設地址「區域」不符合服務地區
      this.selectedData.region.city = selectedCity
      this.setAreaList(selectedCity.MainID)
      this.selectedData.region.area = selectedArea
      this.selectedData.region.name = defaultAddress.Name
      this.selectedData.region.phone = defaultAddress.Phone
      this.selectedData.region.address = defaultAddress.Address
      const theIndex = _.findIndex(this.regionDialog.regionList, { City: defaultAddress.City })
      this.regionDialog.selectedIndex = theIndex
    },
    setAreaList (cityId) {
      const city = _.find(this.cityList, { MainID: cityId })
      if (!city) return
      this.regionList = _.cloneDeep(city.AreaList)
    },
    async setCommunityList () {
      if (!this.isCommunity) return
      if (this.communitySelectList.length > 0) return
      const communityList = _.cloneDeep(this.communityList)
      this.communitySelectList = communityList.map(community => {
        community.isDisabled = false
        community.showName = `${community.Community} ${community.TabletNote}`
        let city = community.City
        if (city.substring(0, 1) === '台') {
          city = '臺' + city.substring(1)
        }
        community.City = city
        const theCity = _.find(this.cityList, { MainName: city })
        if (!theCity) {
          community.isDisabled = true
        } else {
          const theArea = _.find(theCity.AreaList, { ParentName: community.Area })
          if (!theArea) {
            community.isDisabled = true
          }
        }
        let address = community.Address
        if (address.substring(0, 1) === '台') {
          address = '臺' + address.substring(1)
        }
        if (address.substring(0, city.length) === city) {
          address = address.replace(city, '')
        }
        if (address.substring(0, community.Area.length) === community.Area) {
          address = address.replace(community.Area, '')
        }
        community.showAddress = `${address} (${community.TabletNote})`
        if (community.CommunityAddressList && community.CommunityAddressList.length) {
          community.CommunityAddressList = community.CommunityAddressList.map(add => {
            add.City.replace('台', '臺')
            add.Area.replace('台', '臺')
            add.Road.replace('台', '臺')
            add.showName = add.City + add.Area + add.Road
            add.showAddress = `${add.Road} (${community.TabletNote})`
            return add
          })
        }
        return community
      })
    },
    async checkFar () {
      const getZipCode = async () => {
        const { data } = await this.$axios.get(`${this.$nuxt.context.env.OpenDataAPI}/find`, {
          params: {
            address: this.selectedData.recipient.city.region_name + this.selectedData.recipient.area.region_name + this.selectedData.recipient.address
          }
        })
          .catch(() => {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '取得五碼郵遞區號失敗，請稍後再試',
              type: 'error'
            })
            return Promise.reject(new Error('取得五碼郵遞區號失敗'))
          })
        return data.result
      }
      const getRegionFarSend = async zipCode => {
        const priceIdArr = Object.keys(this.selectedData.price.option)
        const { data } = await this.$axios.get('/api/Main/GetRegionFarSend', {
          params: {
            ServiceId: this.service.service_id,
            PostalCode: zipCode,
            PriceOptionIds: priceIdArr,
            ServiceProcessMode: this.serviceProcessMode
          }
        })
          .catch(() => {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '您輸入的地址不在配送範圍',
              type: 'error'
            })
            return Promise.reject(new Error('您輸入的地址不在配送範圍'))
          })
        return data.Data
      }

      // 初始
      this.far.OutlyingIsland = false
      this.far.FarSend = false
      this.far.SendDays = 0
      this.far.optionPriceGroupFar.length = 0
      let positionText = ''
      let addPrice = 0
      const zipCode = await getZipCode().catch(() => Promise.reject(new Error('取得五碼郵遞區號失敗')))
      if (zipCode.length > 3 && zipCode.length <= 5) {
        this.selectedData.recipient.postId = zipCode
      }
      const res = await getRegionFarSend(zipCode).catch(() => Promise.reject(new Error('您輸入的地址不在配送範圍')))
      // 不送
      if (res.NotSend) {
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '您輸入的地址不在配送範圍',
          type: 'error'
        })
        return Promise.reject(new Error('您輸入的地址不在配送範圍'))
      }
      this.far.OutlyingIsland = res.OutlyingIsland
      this.far.FarSend = Boolean(res.FarSendOption)
      this.far.SendDays = res.SendDays
      // 離島
      if (res.OutlyingIslandOption && res.OutlyingIslandOption.service_detail.length > 0) {
        positionText += '離島'
        res.OutlyingIslandOption.service_detail[0].category.forEach(option => {
          const addObj = {}
          addObj.title = '離島加價'
          addObj.options = option.price_option.map(price => {
            price.price_count = 0
            if (res.OutlyingIslandCorresponds && res.OutlyingIslandCorresponds.length > 0) {
              const theAddIdObj = _.find(res.OutlyingIslandCorresponds, { OutlyingIslandPriceId: price.price_id })
              if (theAddIdObj && this.selectedData.price.option[String(theAddIdObj.PriceId)]) {
                price.price_count = this.selectedData.price.option[String(theAddIdObj.PriceId)]
              }
            }
            addPrice += price.price_count * price.price
            return price
          })
          this.far.optionPriceGroupFar.push(addObj)
        })
      }
      // 偏遠
      if (res.FarSendOption && res.FarSendOption.service_detail.length > 0) {
        positionText += '偏遠'
        res.FarSendOption.service_detail[0].category.forEach(option => {
          const addObj = {}
          addObj.title = '偏遠地區加價'
          addObj.options = option.price_option.map(price => {
            price.price_count = 1
            addPrice += price.price_count * price.price
            return price
          })
          this.far.optionPriceGroupFar.push(addObj)
        })
      }
      if (this.far.optionPriceGroupFar.length > 0) {
        setTimeout(() => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: `您輸入的收件地址為${positionText}地區，費用需加收${addPrice}元。`,
            type: 'warning'
          })
        }, 200)
        this.changeData(true)
        // this.alertDialog.persistent = true
        // this.alertDialog.title = '加價提醒'
        // this.alertDialog.message = `您輸入的收件地址為${positionText}地區，費用需加收${addPrice}元。`
        // this.alertDialog.btn = [
        //   {
        //     btnText: '確定',
        //     btnColor: 'primary',
        //     depressed: true,
        //     btnIsLoading: false,
        //     btnClick: async () => {
        //       this.changeData(true)
        //       this.far.dialogOpen = true
        //       this.alertDialog.open = false
        //       this.alertDialog.btn.length = 0
        //     }
        //   },
        // ]
        // this.alertDialog.open = true
      }
      this.far.dialogOpen = true
    },
    farDialogClose () {
      this.changeData()
      this.far.dialogOpen = false
    },
    changePersonalBirthday (date) {
      this.personalInfo.ABirthdayShow = this.$dayjs(new Date(date.replaceAll('-', '/'))).format('YYYY年MM月DD日')
      this.$refs.personalBirthdayMenu.save(date)
    },
    async setChannelTypeList () {
      this.channelTypeList = await this.$store.dispatch('getChannelTypes')
    },
    async changeAllCity (city) {
      await this.$store.dispatch('getAllArea', city.region_id)
      this.selectedData.recipient.area = _.cloneDeep(this.allAreaList[0])
    },
    changeAllArea () {
    },
    changeCity (city) {
      this.setAreaList(city.MainID)
      this.selectedData.region.area = this.selectedData.region.city.AreaList[0]
    },
    changeArea (area) {
      if (!area) return
      if (this.selectedData.region.checkValidate) {
        delete this.selectedData.region.checkValidate
      }
    },
    allowedDates (date) {
      return _.find(this.serviceDate, { FeatureDate: this.$dayjs(date).format('YYYY/MM/DD') })
    },
    getServiceTimeDefaultMode () {
      const defaultMode = [
        { value: 1, label: '早上' },
        { value: 2, label: '下午' },
        { value: 4, label: '晚上' }
      ].filter(mode => this.service.reservation.indexOf(mode.value) > -1)
      if (defaultMode.length === 0) {
        this.selectedData.datetime.defaultTime = 7
        return [{ value: 7, label: '皆可' }]
      } else {
        this.selectedData.datetime.defaultTime = defaultMode[0].value
        return defaultMode.length > 1 ? [...defaultMode, { value: 7, label: '皆可' }] : defaultMode
      }
    },
    setWeekdayOrWeekendModeList () {
      return [
        {
          value: 1,
          label: '平日'
        },
        {
          value: 2,
          label: '假日'
        },
        {
          value: 3,
          label: '皆可'
        }
      ]
    },
    changeDateTimeDate (val, dateOpen = false) {
      this.selectedData.datetime.dateOpen = dateOpen
      if (this.service.serviceTimeType.id === 2) return // 無時間設定
      if (this.service.serviceTimeType.id !== 1) { // 預設(早、中、晚)
        // const day = this.$dayjs(new Date(val.replace(/-/g, '/').replace('T', ' '))).day() === 0 ? 7 : this.$dayjs(new Date(val.replace(/-/g, '/').replace('T', ' '))).day()
        // const dayArray = this.service.ServiceTime.filter(time => time.Days === day)
        this.selectedData.datetime.timeStartHour = null
        this.selectedData.datetime.timeStartMinute = null
        this.selectedData.datetime.timeEndHour = null
        this.selectedData.datetime.timeEndMinute = null
        this.getServiceTimeStartHour()
      }

      if (this.selectedData.datetime.checkValidate) {
        const { isError, errorMessage } = this.checkDateTime()
        if (isError) {
          this.$set(this.selectedData.datetime, 'checkValidate', { errorMessage })
        } else {
          delete this.selectedData.datetime.checkValidate
        }
      }
    },
    changeBr (data) {
      return data.split('\n')
    },
    checkPackageType () {
      if (!this.isCheckPackageType) return
      const checkValidate = {
        isError: false,
        errorMessage: ''
      }
      if (!this.selectedData.packageType.Code) {
        checkValidate.isError = true
        checkValidate.errorMessage = '必填'
      }
      return checkValidate
    },
    async checkPrice (option, count) {
      const optionCount = count || option.optionCount || 0
      const checkValidate = {
        isError: false,
        errorMessage: ''
      }
      if (option.lowest_limit > 0 && option.lowest_limit > optionCount) {
        // 總數量低於最小限制數量
        checkValidate.isError = true
        checkValidate.errorMessage = `低於最小數量 ${option.lowest_limit}`
      }
      if (option.max_limit > 0 && option.max_limit < optionCount) {
        // 總數量高於最大限制數量
        checkValidate.isError = true
        checkValidate.errorMessage = `高於最大數量 ${option.max_limit}`
      }
      option.price_option.forEach(price => {
        if (price.max_limit > 0 && price.price_count > price.max_limit) {
          // 單格數量高於單格最大數量限制
          checkValidate.isError = true
          checkValidate.errorMessage = `${price.price_name} 高於最大數量 ${price.max_limit}`
        }
      })
      return checkValidate
    },
    checkDateTime () {
      let check = false
      const serviceTimeTypeId = this.service.serviceTimeType.id
      const checkValidate = {
        isError: false,
        errorMessage: ''
      }
      if (!this.selectedData.datetime.timeStartHour ||
          !this.selectedData.datetime.timeStartMinute) {
        check = true
      }
      if ([4, 6, 8].indexOf(serviceTimeTypeId) > -1 &&
        (!this.selectedData.datetime.timeEndHour ||
          !this.selectedData.datetime.timeEndMinute)) {
        // 範圍
        check = true
      }
      if (![9, 10].includes(serviceTimeTypeId) && !this.selectedData.datetime.date) check = true
      checkValidate.isError = check
      if (check) {
        checkValidate.errorMessage = '必填'
      }
      return checkValidate
    },
    checkRadio (option) {
      const checkValidate = {
        isError: false
      }
      if (!this.selectedData.option[option.category_id]) {
        checkValidate.isError = true
        checkValidate.errorMessage = '必填'
      }
      return checkValidate
    },
    checkCheckbox (option) {
      const checkValidate = {
        isError: false
      }
      const checkBoxLength = this.selectedData.option[option.category_id].length
      const maxLimit = option.max_limit === 0 ? 100 : option.max_limit
      if (option.lowest_limit === 0) {
        // 無限制最低數量
        if (checkBoxLength > maxLimit) {
          // 大於最大數量
          checkValidate.isError = true
          checkValidate.errorMessage = `最多選擇 ${maxLimit} 項`
        }
        return checkValidate
      }
      // 有限制最低數量
      if (checkBoxLength >= option.lowest_limit &&
        checkBoxLength <= maxLimit) return checkValidate // 低於最大數量、大於最低數量，safe
      if (checkBoxLength < option.lowest_limit) {
        // 低於最低數量
        checkValidate.isError = true
        checkValidate.errorMessage = `最少需選擇 ${option.lowest_limit} 項`
      }
      if (checkBoxLength > maxLimit) {
        // 超出最大數量
        checkValidate.isError = true
        checkValidate.errorMessage = `最多選擇 ${maxLimit}項`
      }
      return checkValidate
    },
    checkAnswer (option) {
      const checkValidate = {
        isError: false
      }
      if (!option.is_required) return checkValidate // 非必填
      if (this.selectedData.option[option.category_id]) return checkValidate // 已有資料
      checkValidate.isError = true
      checkValidate.errorMessage = '必填'
      return checkValidate
    },
    async changeCount (priceOption, useTempMode) { // 更改價格品項數量 - 優惠活動折扣計算
      try {
        if (!priceOption.promotion_list || priceOption.promotion_list.length === 0) { // 非優惠活動
          this.changeData()
          return
        }
        const thePromotion = _.find(this.promotion.PromotionDataList, { PromotionId: priceOption.promotion_list[0] })
        if (!thePromotion) { // 找不到該優惠活動
          this.changeData()
          return
        }
        const optionPromotionId = useTempMode ? 'selectingOptionByPromotionId' : 'selectedOptionByPromotionId'
        if (!this.promotion[optionPromotionId][thePromotion.PromotionId]) { // 初始空物件
          await this.$set(this.promotion[optionPromotionId], thePromotion.PromotionId, {})
        }
        if (priceOption.ProductInfo && !useTempMode) { // 重新計算price_count(購物車+-的時候需要)
          priceOption.price_count = priceOption.ProductInfo.Skus.reduce((a, b) => a + (b.num || 0), 0)
        }
        await this.$set(this.promotion[optionPromotionId][thePromotion.PromotionId], priceOption.price_id, {
          price_id: priceOption.price_id,
          price_count: priceOption.price_count
        })
        // 計算
        let totalCount = 0
        for (const [key, promotion] of Object.entries(this.promotion[optionPromotionId][thePromotion.PromotionId])) {
          if (!isNaN(parseInt(key))) {
            totalCount += promotion.price_count
          }
        }
        if (useTempMode && this.promotion.selectedOptionByPromotionId[thePromotion.PromotionId]) {
          for (const [key, promotion] of Object.entries(this.promotion.selectedOptionByPromotionId[thePromotion.PromotionId])) {
            if (!isNaN(parseInt(key))) {
              totalCount += promotion.price_count
            }
          }
        }

        // 符合的優惠
        const theDiscount = _.find(_.cloneDeep(thePromotion.DetailList).reverse(), promotion => promotion.Quantity <= totalCount)
        if (!theDiscount) {
          // 選擇數量未達符合數量
          await this.$set(this.promotion[optionPromotionId][thePromotion.PromotionId], 'discount', theDiscount)
          await this.$set(this.promotion[optionPromotionId][thePromotion.PromotionId], 'totalCount', totalCount)
          await delete this.promotion[optionPromotionId][thePromotion.PromotionId].discount
          await delete this.promotion[optionPromotionId][thePromotion.PromotionId].totalCount
          this.changeData()
          return
        }
        await this.$set(this.promotion[optionPromotionId][thePromotion.PromotionId], 'discount', theDiscount)
        await this.$set(this.promotion[optionPromotionId][thePromotion.PromotionId], 'totalCount', totalCount)
        this.changeData()
      } catch (error) {
        console.log(error)
      }
    },
    updateSkuPriceCount (price) {
      const totalSinglePriceCount = price.ProductInfo.Skus.reduce((a, b) => { return (a + (b.num || 0)) }, 0)
      this.$set(price, 'price_count', totalSinglePriceCount)
    },
    getProductPrice (priceOption, sku = null, withPromotion = false, useTempMode = false) { // 取得原始價格
      let price = 0
      let discount = 0
      const optionPromotionId = useTempMode ? 'selectingOptionByPromotionId' : 'selectedOptionByPromotionId'
      if (withPromotion && this.promotion[optionPromotionId]?.[priceOption.promotion_list[0]]?.discount?.DiscountAmount) {
        discount = parseInt(this.promotion[optionPromotionId][priceOption.promotion_list[0]].discount.DiscountAmount) || 0
      }
      if (priceOption.ProductInfo) {
        const isSelected = priceOption.ProductInfo.Skus.some(v => v.selected)
        if (isSelected) {
          price = this.setPriceFormat(priceOption.ProductInfo.Skus.filter(v => v.selected)[0].Price - discount)
        } else if (sku) {
          price = this.setPriceFormat(sku.Price - discount)
        } else {
          const priceList = priceOption.ProductInfo.Skus.map(v => v.Price).sort((a, b) => a - b)
          const lowestPrice = priceList[0]
          const highestPrice = priceList[priceList.length - 1]
          price = this.setPriceFormat(lowestPrice - discount)
          if (lowestPrice !== highestPrice) {
            price += ` - $${this.setPriceFormat(highestPrice - discount)}`
          }
        }
      } else {
        price = this.setPriceFormat(priceOption.price - discount)
      }
      return price
    },
    getSelectedProductTotalPrice () {
      const price = this.removePriceFormat(this.getProductPrice(this.selectProductDialog.selectedPrice, null, true, true))
      const count = this.selectProductDialog.selectedPrice.price_count
      return this.setPriceFormat(price * count)
    },
    getTotalPromotionDiscount () { // 取得優惠總折扣
      let totalCount = 0
      for (const [, promotion] of Object.entries(this.promotion.selectedOptionByPromotionId)) {
        if (promotion.discount && promotion.discount.DiscountAmount) {
          totalCount += parseInt(promotion.totalCount) * parseInt(promotion.discount.DiscountAmount)
        }
      }
      return totalCount
    },
    changeData (includeFar = false) {
      let priceConut = 0
      this.optionPriceGroup.map(async (option, index) => {
        let optionCount = 0
        option.price_option.forEach(price => {
          if (price.ProductInfo) {
            this.$set(price, 'price_count', price.ProductInfo.Skus.reduce((a, c) => a + (c.num || 0), 0))
          }
          if (price.price_count > 0) {
            this.$set(this.selectedData.price.option, String(price.price_id), price.price_count)
            if (price.ProductInfo) {
              this.selectedData.price.ProductInfo = this.selectedData.price.ProductInfo || {}
              this.$set(this.selectedData.price.ProductInfo, String(price.price_id), price.ProductInfo)
            }
          } else if (this.selectedData.price.option[String(price.price_id)]) {
            this.$delete(this.selectedData.price.option, price.price_id)
            if (this.selectedData.price.ProductInfo) this.$delete(this.selectedData.price.ProductInfo, price.price_id)
          }
          if (price.ProductInfo) {
            price.ProductInfo.Skus.forEach(sku => {
              if (sku.num) {
                priceConut += (sku.num * sku.Price)
              }
            })
          } else {
            priceConut += price.price_count * price.price
          }
          optionCount += price.price_count
        })
        this.$set(option, 'optionCount', optionCount)
        const checkValidate = await this.checkPrice(option, optionCount)
        if (!checkValidate.isError && this.selectedData.price.error[option.category_id]) {
          const priceErrorObject = _.cloneDeep(this.selectedData.price.error)
          delete priceErrorObject[option.category_id]
          this.$set(this.selectedData.price, 'error', priceErrorObject)
        } else {
          this.$set(this.selectedData.price.error, option.category_id, checkValidate.errorMessage)
        }
        return option
      })
      if (includeFar) {
        // 偏遠/離島加價
        this.far.optionPriceGroupFar.forEach(category => {
          category.options.forEach(option => {
            priceConut += option.price * option.price_count
          })
        })
      }
      // 優惠活動
      if (this.promotion.PromotionDataList.length > 0 &&
          Object.keys(this.promotion.selectedOptionByPromotionId).length > 0) {
        priceConut -= this.getTotalPromotionDiscount()
      }
      // 電聯取件收費
      if (this.isKTJLogistic && this.contactServicePriceTotal > 0 && this.selectedContactService) {
        priceConut += this.contactServicePriceTotal
      }
      // uWash電聯取件費用
      if (this.showContactFeeInOptionList) {
        priceConut += this.uWashContactServicePriceTotal
      }
      this.selectedData.price.totalPrice = priceConut
    },
    async getTicket (orderAmount, useTemp = false) {
      if (this.discount.ticket.got) return
      const { data } = await this.$axios.post('/api/Ticket/TicketAvailableForService', {
        ServiceId: this.service.service_id,
        OrderAmount: orderAmount || this.selectedData.price.totalPrice - this.selectedData.discount.code.discount
      })
        .catch(error => {
          return Promise.reject(error)
        })
      const ticketList = []
      for await (const ticket of data.Data) {
        ticketList.push({
          TicketInstanceId: ticket.TicketInstanceId,
          Name: ticket.Name,
          ValidDue: ticket.ValidDue ? this.$dayjs(ticket.ValidDue).format('YYYY/MM/DD') : '',
          OrderDiscount: ticket.OrderDiscount
        })
      }
      this.selectedData.discount.ticket.list = data.Data
      if (useTemp) {
        this.$set(this.discount.ticket, 'tempList', ticketList)
      } else {
        this.$set(this.discount.ticket, 'list', ticketList)
        this.discount.ticket.got = true
      }
    },
    showGuestUseDiscountAlert () {
      this.$alert({
        title: '系統提示',
        message: '若需要使用優惠券請先進行登入',
        btn: [
          {
            btnText: '取消',
            btnClick: () => {
              this.$alert.close()
            }
          },
          {
            btnText: '立即登入',
            btnColor: 'primary',
            btnClick: () => {
              this.$alert.close()
              this.memberLogin()
            }
          }
        ],
        clickOutside: () => {
          this.$alert.close()
        }
      })
    },
    showGuestAgentUseDiscountAlert () {
      this.$alert({
        title: '系統提示',
        message: '非會員代訂無法使用優惠券或紅利點數',
        btn: [
          {
            btnText: '我知道了',
            btnColor: 'primary',
            btnClick: () => {
              this.$alert.close()
            }
          }
        ],
        clickOutside: () => {
          this.$alert.close()
        }
      })
    },
    /** 打開紅利點數/優惠券 */
    async openDialogDiscount (showGuestAlert = false) {
      if (showGuestAlert && !this.$auth.loggedIn) {
        if (this.isGuestAgent) {
          this.showGuestAgentUseDiscountAlert()
        } else {
          this.showGuestUseDiscountAlert()
        }
        return
      }
      this.logInfoPageGaEvent('click_使用優惠券/紅利點數')
      this.discount.dialog.open = true
      await this.getTicket()
        .catch(() => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '取得優惠券失敗，請稍後再試',
            type: 'error'
          })
          return Promise.reject(new Error('取得優惠券失敗'))
        })
      if (this.discount.ticket.list.length === 0) {
        this.discount.ticket.index = null
      } else if (this.selectedData.discount.ticket.index === null) {
        this.discount.ticket.index = 0
      } else if (this.discount.ticket.list[this.selectedData.discount.ticket.index]) {
        this.discount.ticket.index = this.selectedData.discount.ticket.index
      } else {
        this.discount.ticket.index = 0
        this.selectedData.discount.ticket.index = 0
      }
    },
    /** 優惠券按出確認 */
    discountSubmit () {
      if (this.discount.ticket.list.length > 0 && this.discount.ticket.index !== null && this.discount.ticket.index !== '') {
        this.selectedData.discount.ticket.index = this.discount.ticket.index
        this.selectedData.discount.ticket.discount = this.discount.ticket.list[this.discount.ticket.index].OrderDiscount
        this.selectedData.discount.ticket.detail = this.discount.ticket.list[this.discount.ticket.index]
        this.selectedData.discount.ticket.TicketInstanceId = this.discount.ticket.list[this.discount.ticket.index].TicketInstanceId
        this.updateCheckHandler('bonus')
      } else {
        this.selectedData.discount.ticket.index = this.discount.ticket.index === '' ? '' : null
        this.selectedData.discount.ticket.discount = 0
        this.selectedData.discount.ticket.detail = null
        this.selectedData.discount.ticket.TicketInstanceId = null
      }
      this.discount.dialog.open = false
    },
    async updateCheckHandler (data) {
      try {
        await this.$refs.codeDiscount.updateCheckHandler(data)
      } catch (error) {
        console.log(error)
      }
    },
    /** 點擊上一步 */
    clickPricePrevStep () {
      if (this.pageNow <= 1) return
      if (this.pageNow === 3 && this.optionGroup.length === 0) {
        this.$gaLogEvent('訂購流程', `click_上一步_前往品項頁_${this.service.service_title}_${this.serviceId}`)
        this.pageNow = 1
        this.$gtm.push({
          event: 'servicePrevStep',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name,
          stepTo: 1
        })
      } else {
        this.pageNow -= 1
        this.$gaLogEvent('訂購流程', `click_上一步_前往${this.pages[this.pageNow - 1]}_${this.service.service_title}_${this.serviceId}`)
        this.$gtm.push({
          event: 'servicePrevStep',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name,
          stepTo: this.pageNow
        })
      }
      if (this.discount.bonus.got) {
        this.discount.bonus.got = false
      }
      if (this.discount.ticket.got) {
        this.discount.ticket.got = false
      }
      const headerHeight = document.querySelector('#header').offsetHeight
      if (headerHeight) {
        this.$vuetify.goTo('#service-item', { duration: 300, offset: headerHeight + 20, easing: 'easeInOutQuad' })
      }
    },
    /** 點擊下一步 */
    async clickPriceNextStep () {
      this.shoppingCartDialog.open = false
      const headerHeight = document.querySelector('#header').offsetHeight + 20
      let hasError = false
      this.FBConversionAPI('商品頁點擊下一步', {
        pageNow: this.pageNow
      })
      const checkPrice = async () => {
        this.optionPriceGroup.forEach(async (option) => {
          const { isError, errorMessage } = await this.checkPrice(option)
          if (isError) {
            this.$set(this.selectedData.price.error, option.category_id, errorMessage)
            this.gtmFormErrorEvent(option.category_name, '')
            hasError = true
          } else if (this.selectedData.price.error[option.category_id]) {
            delete this.selectedData.price.error[option.category_id]
          }
        })
      }
      const checkRegion = () => {
        if (Object.values(this.selectedData.region.city).length > 0 &&
            Object.values(this.selectedData.region.area).length > 0) return
        hasError = true
        this.gtmFormErrorEvent('服務區域', '')
        this.$set(this.selectedData.region, 'checkValidate', { errorMessage: '必填' })
      }
      const checkDateTime = () => {
        if (this.service.serviceTimeType.id === 9) return // 9: 無日期與時間設定
        const { isError, errorMessage } = this.checkDateTime()
        if (isError) {
          const blockTitle = '預期服務日期' + (this.service.serviceTimeType.id === 2 ? '' : '與時段')
          this.gtmFormErrorEvent(blockTitle, '')
          hasError = true
          this.$set(this.selectedData.datetime, 'checkValidate', { errorMessage })
        } else {
          delete this.selectedData.datetime.checkValidate
        }
      }

      const checkPackageType = () => {
        if (!this.isCheckPackageType) return
        const { isError, errorMessage } = this.checkPackageType()
        if (isError) {
          this.gtmFormErrorEvent('寄送包裹種類', '')
          this.$set(this.selectedData.packageType, 'checkValidate', { errorMessage })
          hasError = true
        } else {
          delete this.selectedData.packageType.checkValidate
        }
      }

      if (this.isKTJLogistic || this.isTCatLogistic) {
        this.btn.isNextStepLoading = true
        let serviceTitle = ''
        if (this.isKTJLogistic) serviceTitle = '嘉里快遞'
        if (this.isTCatLogistic) serviceTitle = '黑貓宅急便'
        await this.checkLogisticHealthy(`${serviceTitle}正在進行系統維護，請您稍候再試`)
          .catch(() => {
            this.btn.isNextStepLoading = false
            return Promise.reject(new Error('系統維護'))
          })
        this.btn.isNextStepLoading = false
      }
      if (this.pageNow === 1) {
        const checkList = [
          checkPrice(),
          checkDateTime()
        ]
        if (!this.isCommunity) {
          checkList.push(checkRegion())
        }
        if (this.isCheckPackageType) {
          checkList.push(checkPackageType())
        }
        await Promise.all(checkList)
      }

      if (this.pageNow === 2) {
        const optionGroup = _.cloneDeep(this.optionGroup)
        optionGroup.reverse().forEach(option => {
          let checkValidate
          if (option.category_option === 2) checkValidate = this.checkRadio(option) // 單選
          if (option.category_option === 4) checkValidate = this.checkCheckbox(option) // 複選
          if (option.category_option === 5) checkValidate = this.checkAnswer(option) // 問答
          if (checkValidate.isError) {
            hasError = true
            const blockTitle = option.subTitle ? option.category_name + '(' + option.subTitle + ')' : option.category_name
            this.gtmFormErrorEvent(blockTitle, '')
            this.$set(this.selectedData.option.error, option.category_id, checkValidate.errorMessage)
          } else if (this.selectedData.option.error[option.category_id]) {
            delete this.selectedData.option.error[option.category_id]
          }
        })
      }

      if (hasError) {
        await this.$nextTick()
        return await this.goErrorPosition()
      }

      // 檢查最低消費金額
      if (this.service.MinimumSpendSetting?.Dollar && this.selectedData.price.totalPrice < this.service.MinimumSpendSetting.Dollar) {
        this.$store.dispatch('toast', {
          isOpen: true,
          text: `單筆訂單結帳金額須滿 $${this.service.MinimumSpendSetting.Dollar} 才能成立`,
          type: 'warning'
        })
        return
      }

      if (!this.term.isRead) {
        this.$set(this.term, 'next', this.clickPriceNextStep)
        this.term.dialogOpen = true
        this.$alert.close()
        return
      }

      this.changeData()
      if (!this.$auth.loggedIn && this.isCommunity) {
        // 未登入，登入彈窗
        // save selectedData to
        this.isNextStep = true
        this.$gtm.push({
          event: 'serviceLoginStart',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
        this.$nuxt.$router.push({ name: 'login' })
        return
      }
      await this.$vuetify.goTo('#service-item', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      if (this.pageNow === 1 && this.optionGroup.length === 0) {
        this.pageNow = 3
        this.$gaLogEvent('訂購流程', `click_下一步_前往預約資訊頁_${this.service.service_title}_${this.serviceId}`)
        this.$gtm.push({
          event: 'serviceNextStep',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name,
          stepTo: 3
        })
      } else {
        this.pageNow++
        this.$gaLogEvent('訂購流程', `click_下一步_前往${this.pages[this.pageNow - 1]}_${this.service.service_title}_${this.serviceId}`)
        this.$gtm.push({
          event: 'serviceNextStep',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name,
          stepTo: this.pageNow
        })
      }
    },
    async goErrorPosition () {
      const scrollEle = document.querySelectorAll('.option.is-error')[0]
      const errorInput = document.querySelectorAll('.v-application .error--text')[0]
      const errorInputParent = errorInput ? errorInput.closest('section.option') : null
      const headerHeight = document.querySelector('#header').offsetHeight + 20
      if (scrollEle && errorInput) {
        const scrollToDom = scrollEle.offsetTop > errorInput.offsetTop ? errorInputParent : scrollEle
        await this.$vuetify.goTo(scrollToDom, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      } else if (scrollEle) {
        await this.$vuetify.goTo(scrollEle, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      } else if (errorInput) {
        await this.$vuetify.goTo(errorInputParent, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      }
    },
    checkStep3 () {
      let isError = false
      const checkPersonal = () => {
        const checkName = () => {
          if (!this.$refs.personalName) return
          if (this.$refs.personalName.validate()) return
          isError = true
          this.gtmFormErrorEvent('會員資訊', '會員姓名')
          this.$set(this.personalInfo, 'checkValidate', { errorMessage: '必填' })
        }
        const checkPhone = () => {
          if (this.personalInfo.phoneIsSaved) {
            return
          } else {
            this.personalInfo.phoneErrorMessage = '請驗證手機號碼'
            isError = true
          }
          if (!this.$refs.personalPhone) return
          if (this.$refs.personalPhone.validate() && this.$auth.loggedIn) return
          if (this.$refs.personalPhone.validate()) return
          this.gtmFormErrorEvent('會員資訊', '會員手機')
          isError = true
          this.$set(this.personalInfo, 'checkValidate', { errorMessage: '必填' })
        }
        checkName()
        checkPhone()
      }
      const checkRecipient = () => {
        if (!this.service.serviceMultipContact || this.service.serviceMultipContact.id !== 2) return // 寄 / 收件模式：一對一交付
        if (this.$refs.serviceRegionRecipient?.validate()) return
        this.gtmFormErrorEvent('配達資訊', '收件人姓名')
        isError = true
        this.$set(this.selectedData.recipient, 'checkValidate', { errorMessage: '必填' })
      }
      const checkRegion = () => {
        if (this.isCommunity) {
          if (this.$refs.regionCommunity.validate()) return
          this.gtmFormErrorEvent('服務位置', '社區')
          this.$set(this.selectedData.region, 'communityCheckValidate', { errorMessage: '必填' })
        } else {
          const checkName = this.$refs.serviceRegionPersonalName.validate()
          const checkPhone = this.$refs.serviceRegionPersonalPhone.validate()
          const checkAddress = this.$refs.serviceRegionAddress.validate()
          if (checkName && checkPhone && checkAddress) return
          if (!checkName) this.gtmFormErrorEvent('服務資訊', '姓名')
          if (!checkPhone) this.gtmFormErrorEvent('服務資訊', '電話')
          if (!checkAddress) this.gtmFormErrorEvent('服務資訊', '服務位置')
          this.$set(this.selectedData.region, 'addressCheckValidate', { errorMessage: '必填' })
        }
        isError = true
      }
      const checkReceipt = () => {
        if (this.service.InvoiceSetting.InvoiceResponsibilityId === 2) return // 現金付款
        if (this.service.ServiceProcessMode.Mode === 'FamiLogistic') return // 全家外送-發票由廠商開立
        let checkReceipt = false
        switch (this.selectedData.receipt.type) {
          case 1: // 個人電子發票
            // E-mail
            if (!this.$refs.receiptMail.validate()) {
              this.gtmFormErrorEvent('發票資訊', 'E-mail')
              checkReceipt = true
            }
            break
          case 2: // 公司統一編號
            // E-mail、公司統一編號
            if (!this.$refs.receiptIdNumber.validate()) {
              if (String(this.selectedData.receipt.idNumber).length === 0) {
                this.gtmFormErrorEvent('發票資訊', '公司統一編號')
                checkReceipt = true
              } else {
                this.gtmFormErrorEvent('發票資訊', 'E-mail')
                checkReceipt = true
              }
            }
            if (!this.$refs.receiptCompanyMail.validate()) {
              checkReceipt = true
            }
            break
          case 3: // 捐贈發票
            break
          case 4: // 手機條碼載具
            if (this.$refs.receiptBarcode.validate()) return
            this.gtmFormErrorEvent('發票資訊', '手機條碼載具')
            checkReceipt = true
            break
        }
        if (checkReceipt) {
          isError = true
          this.$set(this.selectedData.receipt, 'checkValidate', { errorMessage: '必填' })
        }
      }
      const checkImageUpload = () => {
        // 上傳照片必填-檢查是否為空
        if (this.service.ImageIsRequired && !this.selectedData.photoList.length) {
          this.gtmFormErrorEvent('其他', '上傳照片')
          isError = true
          this.$set(this.selectedData, 'photoValidate', false)
        }
      }
      const checkChannelType = () => {
        if (this.$refs.channelType.validate()) return
        this.gtmFormErrorEvent('其他', '如何得知本服務')
        isError = true
        this.$set(this.selectedData.channelType, 'checkValidate', { errorMessage: '必填' })
      }

      checkPersonal()
      checkRecipient()
      checkRegion()
      checkReceipt()
      checkImageUpload()
      checkChannelType()

      return isError
    },
    async savePersonalInfo () {
      if (this.personalInfo.AName === this.$auth.user.AName &&
          this.personalInfo.AGender === this.$auth.user.AGender &&
          this.personalInfo.ABirthday === this.$auth.user.ABirthday) return
      // phone save ?
      try {
        await this.$axios.post('/api/KingnetAccount/AccountInfo', {
          AName: this.personalInfo.AName || '',
          AGender: this.personalInfo.AGender || '',
          ABirthday: this.personalInfo.ABirthday || '',
          APic: this.$auth.user.APic || ''
        })
        this.$auth.setUser({
          ...this.$auth.user,
          AName: this.personalInfo.AName,
          AGender: this.personalInfo.AGender,
          ABirthday: this.personalInfo.ABirthday
        })
      } catch (error) {
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '會員資料儲存失敗',
          type: 'error'
        })
        Promise.resolve()
      }
    },
    resetAlertDialog () {
      this.alertDialog.title = ''
      this.alertDialog.message = ''
      this.alertDialog.type = ''
      this.alertDialog.btnText = '關閉'
      this.alertDialog.btn.length = 0
      this.alertDialog.persistent = false
      this.$set(this.alertDialog, 'successData', false)
    },
    async alertDialogClose () {
      const scrollEle = document.querySelectorAll('.option.is-error')[0]
      const errorInput = document.querySelectorAll('.v-application .error--text')[0]
      const errorInputParent = errorInput ? errorInput.closest('section.option') : null
      const headerHeight = document.querySelector('#header').offsetHeight + 20
      if (scrollEle && errorInput) {
        const scrollToDom = scrollEle.offsetTop > errorInput.offsetTop ? errorInputParent : scrollEle
        await this.$vuetify.goTo(scrollToDom, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      } else if (scrollEle) {
        await this.$vuetify.goTo(scrollEle, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      } else if (errorInput) {
        await this.$vuetify.goTo(errorInputParent, { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      }
      if (this.alertDialog.type === 'setOrderSuccess') {
        // 訂單成立
        const orderId = this.alertDialog.successData ? this.alertDialog.successData.orderId : 0
        const orderSn = this.alertDialog.successData ? this.alertDialog.successData.orderSn : ''
        // 代訂成功，前往後台
        if (this.isAgentOrder || this.isGuestAgent) {
          // const httpHost = 'http://localhost:8080' // 開發使用
          const httpHost = this.$nuxt.context.env.EC_CMS_URL
          await this.$store.dispatch('logOut')
          if (this.agentOrder.source.includes('sales')) {
            window.location.href = `${httpHost}/siteadmin/#/sales/agent-order-info/${orderId}/`
          } else {
            window.location.href = `${httpHost}/siteadmin/#/order/edit/${orderId}/`
          }
          return
        }
        if (this.paymentSelectedInfo.PaymentTimingName === 'AfterOrderEstablished' && this.alertDialog.successData.HashCode) {
          // 前往付款
          const HashCode = this.alertDialog.successData ? this.alertDialog.successData.HashCode : ''
          const routerObj = {
            name: 'payment-idHashCodeSn',
            params: {
              idHashCodeSn: `${orderId}-${HashCode}-${orderSn}`
            }
          }
          if (this.selectedData.price.totalPrice <= 0) {
            routerObj.query = {
              status: 0
            }
          }
          this.$nuxt.$router.push(routerObj)
        } else {
          this.$nuxt.$router.push({
            name: 'member-order-idsn',
            params: {
              idsn: `${orderId}-${orderSn}`
            }
          })
        }
        this.alertDialog.type = ''
        this.alertDialog.btnText = '關閉'
      }
      this.resetAlertDialog()
      this.alertDialog.open = false
    },
    checkPersonalInfoValidate (validateRef) {
      if (!this.personalInfo.checkValidate) return
      let checkValidate = true
      validateRef.forEach(ele => {
        if (!this.$refs[ele]) return
        if (!this.$refs[ele].validate()) {
          checkValidate = false
        }
      })
      if (checkValidate && this.personalInfo.phoneIsSaved) {
        delete this.personalInfo.checkValidate
      }
      if (checkValidate && this.personalInfo.checkValidate) {
        delete this.personalInfo.checkValidate
      }
    },
    checkInputValidate (key, validateRef, validateKey = 'checkValidate') {
      if (!this.selectedData[key][validateKey]) return
      let checkValidate = true
      validateRef.forEach(ele => {
        if (!this.$refs[ele]) return
        if (!this.$refs[ele].validate()) {
          checkValidate = false
        }
      })
      if (checkValidate && this.selectedData[key][validateKey]) {
        delete this.selectedData[key][validateKey]
      }
    },
    clickContactFlag () {
      if (!this.selectedData.region.contactFlag) {
        // 要打勾
        this.alertDialog.title = '確定自行交件嗎？'
        this.alertDialog.message = '嘉里快遞到達社區前將【電話聯繫】您，並請在司機到達時，自行至管理室將包裹交給司機。'
        this.alertDialog.btn = [
          {
            btnText: '取消',
            btnColor: '',
            depressed: true,
            outlined: false,
            btnClick: () => {
              this.alertDialog.open = false
              this.alertDialog.btn.length = 0
            }
          },
          {
            btnText: '確定',
            btnColor: 'primary',
            depressed: true,
            btnIsLoading: false,
            btnClick: async () => {
              this.alertDialog.open = false
              this.alertDialog.btn.length = 0
              this.selectedData.region.contactFlag = true
            }
          }
        ]
        this.alertDialog.open = true
      } else {
        this.selectedData.region.contactFlag = false
        this.alertDialog.btn.length = 0
      }
    },
    async checkLogisticHealthy (message = '正在進行系統維護，請您稍候再試') {
      let apiPath = ''
      switch (this.serviceProcessMode) {
        case 'KTJLogistic':
          apiPath = 'KTJ/KTJHealthyCheck'
          break
        case 'TCatLogistic':
          apiPath = 'v2/KTJ/TCatHealthyCheck'
          break
        default:
          break
      }
      await this.$axios.post(`/api/${apiPath}`)
        .catch(() => {
          this.alertDialog.title = '連線異常'
          this.alertDialog.message = message
          this.alertDialog.btn = [
            {
              btnText: '確定',
              btnColor: 'primary',
              depressed: true,
              btnIsLoading: false,
              btnClick: async () => {
                this.alertDialog.open = false
                this.alertDialog.btn.length = 0
              }
            }
          ]
          this.alertDialog.open = true
          return Promise.reject(new Error('連線異常'))
        })
    },
    resetSelectedData () {
      this.$emit('refreshData')
      this.$store.commit('clearGeustPurchaseData')
      this.$store.commit('clearGeustPurchaseOrderStatus')
    },
    checkIsDuplicate (commonAddressList, newObj) {
      try {
        return commonAddressList.some(
          item =>
            item.Name === newObj.Name &&
            item.Phone === newObj.Phone &&
            item.PostNumber === newObj.PostNumber &&
            item.City === newObj.City &&
            item.Area === newObj.Area &&
            item.Address === newObj.Address
        )
      } catch (err) {
        console.log(err)
      }
    },
    /** 點擊 前往付款/確認預約 */
    async clickSetOrder () {
      if (this.isKTJLogistic || this.isTCatLogistic) {
        this.btn.isSetOrderLoading = true
        let serviceTitle = ''
        if (this.isKTJLogistic) serviceTitle = '嘉里快遞'
        if (this.isTCatLogistic) serviceTitle = '黑貓宅急便'
        await this.checkLogisticHealthy(`${serviceTitle}正在進行系統維護，您可以再試一次'`)
          .catch(() => {
            this.btn.isSetOrderLoading = false
            return Promise.reject(new Error('系統維護'))
          })
        this.btn.isSetOrderLoading = false
      }

      const checkStep3HasError = await this.checkStep3()
      if (checkStep3HasError) {
        await this.$nextTick()
        return await this.goErrorPosition()
      }

      // 嘉里快遞/黑貓 確認訂單明細彈窗未開 -> 未檢查是否偏遠/離島
      if ((this.isKTJLogistic || this.isTCatLogistic) && !this.far.dialogOpen) {
        this.checkFar()
        return
      }

      // check是否有折扣碼/好友推薦碼未確認
      console.log(this.$refs.codeDiscount && this.$refs.codeDiscount.getDiscountInputCode()?.length)
      if (this.$refs.codeDiscount && this.$refs.codeDiscount.getDiscountInputCode()?.length > 0 && !this.selectedData.discount.code.isUse) {
        const checkHasInputCode = () => {
          return new Promise((resolve, reject) => {
            this.btn.isSetOrderLoading = true
            this.alertDialog.title = '系統提示'
            this.alertDialog.message = '您有輸入折扣碼/好友推薦碼但尚未確認，若未確認將無法使用對應優惠內容，確定要直接成立訂單嗎？'
            this.alertDialog.btn = [
              {
                btnText: '取消',
                btnColor: '',
                depressed: true,
                outlined: false,
                btnClick: () => {
                  this.btn.isSetOrderLoading = false
                  this.alertDialog.open = false
                  this.alertDialog.btn.length = 0
                  const headerHeight = document.querySelector('#header').offsetHeight
                  this.$vuetify.goTo('#code-discount', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
                  this.btn.isSetOrderLoading = false
                  reject(new Error('取消'))
                }
              },
              {
                btnText: '確定',
                btnColor: 'primary',
                depressed: true,
                btnIsLoading: false,
                btnClick: async () => {
                  this.alertDialog.open = false
                  this.alertDialog.btn.length = 0
                  this.btn.isSetOrderLoading = false
                  resolve()
                }
              }
            ]
            this.alertDialog.open = true
          })
        }
        try {
          await checkHasInputCode()
        } catch (e) {
          console.log(e)
          return false
        }
      }

      // check是否有優惠券未有用
      if (!this.isGuestPurchase && this.$auth.loggedIn) {
        const checkTicketDone = await this.checkTicket()
        if (!checkTicketDone) {
          this.btn.isSetOrder = false
          return
        }
      }

      // 非代訂模式才可編輯會員資料
      if (!this.isAgentOrder && !this.isGuestPurchase && this.$auth.loggedIn && !this.isGuestAgent) {
        console.log('savePersonalInfo')
        await this.savePersonalInfo()
      }

      // 檢查是否為常用地址
      if (this.$auth.loggedIn && this.isAddressMode && !this.isAgentOrder && !this.isGuestAgent && !this.isGuestPurchase) { // 地址模式＋非後台會員代訂＋非後台訪客代訂＋官網新會員
        const orderReceiverInfo = { // 收件人資料
          IsDefault: this.regionDialog.regionList.length === 0 ? 1 : 0, // 是否為預設常用
          Name: this.selectedData.region.name,
          Phone: this.selectedData.region.phone,
          Address: this.selectedData.region.address,
          PostNumber: this.selectedData.region.area.ParentPostId,
          City: this.selectedData.region.city.MainName,
          Area: this.selectedData.region.area.ParentName
        }
        const sendData = JSON.parse(JSON.stringify(orderReceiverInfo))
        const isDuplicate = this.checkIsDuplicate(this.regionDialog.regionList, sendData) // 比較是否為重複地址資料
        if (!isDuplicate) { // 未重複就跳詢問彈窗
          const addCommonAddress = () => {
            return new Promise((resolve, reject) => {
              this.$alert({
                title: '是否加入常用地址',
                message: '是否將服務位置資訊加入常用地址？',
                btn: [
                  {
                    btnText: '否',
                    btnClick: () => {
                      this.$alert.close()
                      resolve()
                    }
                  },
                  {
                    btnText: '是',
                    btnColor: 'primary',
                    btnClick: async () => {
                      this.$alert.close()
                      // 新增地址
                      await this.$axios.post('/api/KingnetAccount/Address', orderReceiverInfo)
                        .catch(error => {
                          this.$store.dispatch('toast', {
                            isOpen: true,
                            text: '新增失敗',
                            type: 'error'
                          })
                          reject(error)
                        })
                      // 重新取得常用列表
                      this.regionDialog.regionList = await this.$store.dispatch('getPersonalAddress')
                      resolve()
                    }
                  }
                ]
              })
            })
          }

          try {
            await this.$awaitSetTimeout(400)
            await addCommonAddress()
          } catch (error) {
            console.log(error)
            return false
          }
        }
      }

      // 若有選擇信用卡，驗證卡片是否存在
      if (this.selectedData.payment === 1 && this.creditCardSelectorDialog.selectedCard && this.$refs.creditCardSelectorDialog) {
        this.btn.isSetOrderLoading = true
        const res = await this.$refs.creditCardSelectorDialog.initData() // 更新信用卡列表，用於檢查是否需開啟視窗或信用卡是否存在
        if (!res) {
          this.btn.isSetOrderLoading = false
          return
        }
        const isCreditCardExist = this.creditCardSelectorDialog.cardList.some(card => card.Guid === this.creditCardSelectorDialog.selectedCard.Guid)
        this.btn.isSetOrderLoading = false
        if (!isCreditCardExist) {
          // 關閉當前視窗
          this.alertDialog.open = false
          // 設定不存在卡片狀態
          this.payment.checkValidate = false
          this.payment.errorMessage = '重新選擇付款方式'
          this.warningDialog.title = '請重新選擇付款方式'
          this.warningDialog.message = '你選擇的信用卡不存在，請重新選擇付款方式'
          this.warningDialog.open = true
          this.btn.isSetOrder = false
          return
        }
      }

      this.$gtm.push({
        event: 'serviceSetOrder',
        serviceName: this.service.service_title,
        serviceId: this.serviceId,
        pageTitle: document.title,
        pageType: 'service',
        pageUrl: this.$nuxt.$route.path,
        routeName: this.$nuxt.$route.name,
        step: 'start'
      })
      this.btn.isSetOrder = true

      const getData = () => {
        const serviceSelectedPrice = this.getServiceSelectedPrice()
        const serviceSelectedOption = this.getServiceSelectedOption()
        const getReservation = () => { // 預約時間
          const selectedDate = this.selectedData.datetime.date ? new Date(this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' ')) : ''
          const reservation = {}
          reservation.reservation = [1, 10].includes(this.service.serviceTimeType.id) ? this.selectedData.datetime.defaultTime : 0
          reservation.reservation_datetime = selectedDate ? this.$dayjs(selectedDate).format('YYYY-MM-DD HH:mm:ss') : this.$dayjs().format('YYYY-MM-DD HH:mm:ss')
          if (this.service.serviceTimeType.id > 2 && this.service.serviceTimeType.id < 9) {
            reservation.order_reservation = {
              start_time: this.$dayjs(selectedDate).format('YYYY-MM-DD ') + this.selectedData.datetime.timeStartHour + ':' + this.selectedData.datetime.timeStartMinute + ':00'
            }
            if (parseInt(this.selectedData.datetime.timeStartHour) === 24) {
              reservation.order_reservation.start_time = this.$dayjs(selectedDate).format('YYYY-MM-DD ') + '23:59:59'
            }
          }
          if ([4, 6, 8].indexOf(this.service.serviceTimeType.id) > -1) {
            // 範圍
            reservation.order_reservation.due_time = this.$dayjs(selectedDate).format('YYYY-MM-DD ') + this.selectedData.datetime.timeEndHour + ':' + this.selectedData.datetime.timeEndMinute + ':00'
            if (parseInt(this.selectedData.datetime.timeEndHour) === 24) {
              reservation.order_reservation.due_time = this.$dayjs(selectedDate).format('YYYY-MM-DD ') + '23:59:59'
            }
          }
          if (this.service.serviceTimeType.id === 10) {
            reservation.ReservationWeekendId = this.selectedData.datetime.weekdayReservation
          }
          return reservation
        }
        const getPriceOptions = () => {
          const priceArray = []
          const formatContactFlagPriceOptionList = this.contactFlagPriceOptionList
            .map(v => (
              { options: [{ price_id: v.PriceId, price_count: v.PriceCount, ProductInfo: v.ProductInfo }] }
            ))
          // 建立訂單要帶入電聯費用品項
          let formatUwashContactFlagPriceOptionList = []
          if (this.showContactFeeInOptionList) {
            formatUwashContactFlagPriceOptionList = this.uWashContactFlagPriceOptionList
              .map(v => (
                { options: [{ price_id: v.PriceId, price_count: v.PriceCount, ProductInfo: v.ProductInfo }] }
              ))
          }
          serviceSelectedPrice
            .concat(this.far.optionPriceGroupFar)
            .concat(formatContactFlagPriceOptionList)
            .concat(formatUwashContactFlagPriceOptionList)
            .forEach(option => {
              option.options.forEach(price => {
                if (price.ProductInfo) {
                  const selectedSkuArr = price.ProductInfo.Skus.filter(v => v.num > 0 || (price.ProductInfo.VariantCount === 0 && price.price_count > 0)) // 避免偏遠離島optionPriceGroupFar num為空
                  selectedSkuArr.forEach(skuV => {
                    const detail = {}
                    detail.price_id = price.price_id
                    detail.price_name = price.price_name
                    detail.price_count = skuV.num || price.price_count // 避免偏遠離島optionPriceGroupFar num為空
                    detail.ProductInfo = {
                      ProductId: price.ProductInfo.ProductId,
                      Version: price.ProductInfo.Version,
                      Sku: {
                        Price: skuV.Price,
                        SkuId: skuV.SkuId,
                        Version: skuV.Version,
                        VariantsAndOptions: skuV.VariantsAndOptions
                      }
                    }
                    priceArray.push(detail)
                  })
                } else {
                  const detail = {}
                  detail.price_id = price.price_id
                  detail.price_name = price.price_name
                  detail.price_count = price.price_count
                  priceArray.push(detail)
                }
              })
            })
          return priceArray
        }
        const getOptions = () => {
          const optionArray = []
          serviceSelectedOption
            .filter(option => [2, 4].indexOf(option.category_option) > -1)
            .forEach(option => {
              option.value.forEach(o => {
                optionArray.push({
                  option_id: o.option_id,
                  option_name: o.label
                })
              })
            })
          return optionArray
        }
        const getQAList = () => {
          const optionArray = []
          serviceSelectedOption
            .filter(option => option.category_option === 5)
            .forEach(option => {
              option.value.forEach(o => {
                optionArray.push({
                  category_tips: o.category_tips,
                  category_id: option.id,
                  answer: o.label
                })
              })
            })
          return optionArray
        }
        const getInvoice = () => { // 發票類型
          if (this.service.InvoiceSetting.InvoiceResponsibilityId === 2) return {}
          if (this.service.ServiceProcessMode.Mode === 'FamiLogistic') {
            return {
              InvoiceMark: 4,
              InvoiceCarrierType: 1
            }
          }
          const invoice = _.find(this.selectedData.receipt.typeOptions, { value: this.selectedData.receipt.type })
          return {
            InvoiceMark: invoice.InvoiceMark,
            InvoiceCarrierType: invoice.InvoiceCarrierType
          }
        }
        const getReceipt = () => { // 發票資訊
          if (this.service.ServiceProcessMode.Mode === 'FamiLogistic') return {}
          let receiptObj = {}
          let mail = ''
          if (this.selectedData.receipt.type === 1) { // 個人電子發票
            receiptObj.OrderTax = {
              id_number: '',
              title: '',
              carrier_id: '',
              invoiceSelect: this.selectedData.receipt.type,
              personalMail: this.selectedData.receipt.mail,
              companyMail: '',
              npoban: '',
              city: '',
              area: '',
              post_id: ''
            }
            mail = this.selectedData.receipt.mail
          }
          if (this.selectedData.receipt.type === 2) { // 公司統一編號
            receiptObj.OrderTax = {
              id_number: String(this.selectedData.receipt.idNumber),
              title: '',
              address: '',
              carrier_id: '',
              invoiceSelect: this.selectedData.receipt.type,
              personalMail: '',
              companyMail: this.selectedData.receipt.companyMail,
              npoban: '',
              city: '',
              area: '',
              post_id: ''
            }
            mail = this.selectedData.receipt.companyMail
          }
          if (this.selectedData.receipt.type === 3) {
            // 捐贈發票
            receiptObj.npoban = this.selectedData.receipt.donate
          }
          if (this.selectedData.receipt.type === 4) {
            // 手機條碼載具
            receiptObj.carrier_id = this.selectedData.receipt.barcode.toUpperCase()
          }
          if (this.service.InvoiceSetting.InvoiceResponsibilityId === 2) {
            receiptObj = {}
          }
          return {
            ...receiptObj,
            mail
          }
        }
        const getAddress = () => { // 服務位置
          if (this.isCommunity) { // 社區模式
            return {
              post_id: this.selectedData.region.community.PostalCode,
              selectTabletId: this.selectedData.region.community.TabletId,
              city: this.selectedData.region.community.City,
              area: this.selectedData.region.community.Area,
              address: this.multiAddress.show ? this.selectedData.region.communityAddress.showAddress : this.selectedData.region.community.showAddress,
              name: this.$auth.user.AName,
              phone: this.$auth.user.APhone
            }
          } else {
            return {
              post_id: this.selectedData.region.area.ParentPostId,
              city: this.selectedData.region.city.MainName,
              area: this.selectedData.region.area.ParentName,
              address: this.selectedData.region.address,
              name: this.selectedData.region.name,
              phone: this.selectedData.region.phone
            }
          }
        }
        const getContacts = () => { // 收件人
          const removeCityArea = (addressInput) => {
            const city = this.selectedData.recipient.city.region_name
            const area = this.selectedData.recipient.area.region_name
            let processedAddress = addressInput.replace(/台/g, '臺')
            if (processedAddress.substring(0, city.length) === city) {
              processedAddress = processedAddress.replace(city, '')
            }
            if (processedAddress.substring(0, area.length) === area) {
              processedAddress = processedAddress.replace(area, '')
            }

            return processedAddress
          }

          if (!this.service.serviceMultipContact || this.service.serviceMultipContact.id !== 2) return []
          // 寄 / 收件模式：一對一交付
          const getTelOrPhone = (numbers) => {
            const patternPhone = /^09[0-9]{8}$/
            if (patternPhone.test(numbers)) {
              return {
                tel: '',
                phone: numbers
              }
            } else {
              return {
                tel: numbers,
                phone: ''
              }
            }
          }
          return {
            order_contacts: [
              {
                name: this.selectedData.recipient.name,
                post_id: this.selectedData.recipient.area.region_post,
                address: `${this.selectedData.recipient.city.region_name}${this.selectedData.recipient.area.region_name}${removeCityArea(this.selectedData.recipient.address)}`,
                ...getTelOrPhone(this.selectedData.recipient.phone)
              }
            ]
          }
        }
        const getContactFlag = () => { // 電聯取件 & 偏遠離島
          if (this.service.serviceMultipContact && this.service.serviceMultipContact.id !== 1) {
            return {
              OrderSend: {
                ContactFlag: this.selectedData.region.community.HasContactFlag || this.selectedContactService, // 非強制電聯社區以是否勾選電聯服務判斷
                OutlyingIsland: this.far.OutlyingIsland,
                FarSend: this.far.FarSend,
                SendDays: this.far.SendDays,
                ItemCode: this.selectedData.packageType.Code
              }
            }
          } else {
            return {}
          }
        }
        const getPromotion = () => { // 優惠活動
          return {
            promotion_id_list: this.promotion.PromotionDataList.map(promotion => {
              return promotion.PromotionId
            })
          }
        }
        const getDiscount = () => { // 優惠券/紅利點數/折扣碼/推薦優惠
          return {
            TicketInstanceId: this.selectedData.discount.ticket.TicketInstanceId,
            BonusUsed: this.selectedData.discount.bonus.state === 'used' ? this.selectedData.discount.bonus.point.CanUseBonusAmount : null,
            EnterpriseCoinUsed: this.selectedData.discount.bonus.state === 'used' && this.enterpriseCoinAvailable ? this.selectedData.discount.bonus.point.CanUseEnterpriseAmount : null,
            DiscountCode: this.selectedData.discount.code.isUse ? this.selectedData.discount.code.input : ''
          }
        }
        const getUserCommunity = () => { // 現居社區
          if (this.personalInfo.UserCommunity) {
            return {
              account_com_id: this.personalInfo.UserCommunity.Id
            }
          }
        }
        // 社區模式訂單擴增紀錄社區ID
        const getServiceCommunity = () => {
          if (this.isCommunity) {
            return {
              service_com_id: this.selectedData.region.community.ComId
            }
          }
        }
        const getPaymentSetting = () => { // 付款設定
          return {
            PaymentSetting: {
              KingnetInvoiceResponsibility: this.service.InvoiceSetting.InvoiceResponsibilityId === 1 && this.service.ServiceProcessMode.Mode !== 'FamiLogistic',
              OrderPaymentOptions: this.service.PaymentTypeWithPaymentTiming.map(v => {
                const { PaymentTypeId, PaymentTypeName, MinimumOrderAmountOfEnablePaymentType } = v
                const PaymentTiming = v.PaymentTimingName
                const CustomerChooseThisPaymentType = v.PaymentTypeId === this.paymentSelectedInfo.PaymentTypeId
                return { PaymentTypeId, PaymentTypeName, MinimumOrderAmountOfEnablePaymentType, PaymentTiming, CustomerChooseThisPaymentType }
              })
            }
          }
        }

        return {
          service_id: this.service.service_id,
          // name: this.$auth.user.AName, //
          // phone: this.$auth.user.APhone, //
          tel: '', //
          note: this.selectedData.note.data,
          details: getPriceOptions(),
          optionDetails: getOptions(),
          qaList: getQAList(),
          mail: this.selectedData.receipt.mail || this.$auth.user?.AEmail || '', //
          TicketInstanceId: null,
          channel: {
            channel_type_id: this.selectedData.channelType.id,
            other: this.selectedData.channelType.other
          },
          referrer: this.showSource ? this.selectedData.referrer.name : '',
          CreateOrderVersion: this.$nuxt.context.env.mainVersion,
          IsContactPickUp: this.showContactFeeInOptionList,
          ...getInvoice(), // 發票類型
          ...getReservation(), // 預約時間
          ...getReceipt(), // 發票資訊
          ...getAddress(), // 服務位置
          ...getContacts(), // 收件人
          ...getContactFlag(), // 電聯取件
          ...getDiscount(), // 優惠券/紅利點數/折扣碼/推薦優惠
          ...getPromotion(), // 優惠活動
          ...getUserCommunity(), // 現居社區
          ...getServiceCommunity(), // 服務位置
          ...getPaymentSetting() // 付款方式
        }
      }
      let postData = await getData()
      let axiosPath = ''
      let config = {}
      if (this.isAgentOrder) {
        axiosPath = 'SetOrderByAgent'
        postData.is_agent_order = true
        if (this.agentOrder.adminConsultationId) {
          postData.platform_consultation_id = this.agentOrder.adminConsultationId
        }
      } else if (this.isGuestPurchase) {
        axiosPath = 'SetOrderByGuestForWeb'
        if (this.isGuestAgent) {
          config = { headers: { Authorization: this.agentOrder.token } }
          axiosPath = 'SetOrderByGuestAgent'
        }
        postData = {
          CreateGuestAccount: {
            ...this.guestPurchase.createGuestAccountData,
            Name: this.personalInfo.AName,
            Gender: this.personalInfo.AGender,
            Birthday: this.personalInfo.ABirthday
          },
          Order: { ...postData },
          GuestDiscountInfo: {
            EnterpriseCodes: this.selectedData.discount.bonus.state === 'used' ? this.selectedData.discount.bonus.enterpriseCodes : []
          }
        }
      } else if (this.isTCatLogistic) {
        axiosPath = 'SetTCatSendOrder'
        const { order_contacts, promotion_id_list, details, qaList, ...rest } = getData()
        postData = {}
        postData = rest
        postData.OrderSend.MultiContact = false
        postData.OrderContactOrderDetails = [
          {
            VirtualId: 0,
            OrderContact: order_contacts[0],
            OrderContactSend: {
              OutlyingIsland: this.far.OutlyingIsland,
              FarSend: this.far.FarSend,
              SendDays: this.far.SendDays,
              ItemCode: this.selectedData.packageType.Code
            },
            OrderDetails: details
          }
        ]
      } else {
        axiosPath = 'SetOrder'
      }
      const { data } = await this.$axios.post(`/api/v2/Order/${axiosPath}`, postData, config)
        .catch(async error => {
          let errorText = ''
          const checkCommonErrorMsg = (error) => {
            if (error?.response?.data?.ErrorMessage?.Code === 401003) { // 無效手機條碼
              errorText = '此為無效的手機條碼，請重新輸入。'
              return true
            } else if (error?.response?.data?.ErrorMessage?.Code === 500004) { // 財政部系統異常
              let typeText = ''
              if (this.selectedData.receipt.type === 3) {
                typeText = '捐贈發票'
              } else if (this.selectedData.receipt.type === 4) {
                typeText = '手機條碼載具'
              }
              errorText = `目前財政部系統異常，使用${typeText}可能出現錯誤，建議更換發票開立方式。`
              return true
            } else if (error?.response?.data?.ErrorMessage?.Code === 500200) { // 品項異動
              this.discount.bonus.got = false
              this.discount.ticket.got = false
              this.discount.ticket.index = null
              this.alertDialog.title = '系統訊息'
              this.alertDialog.message = '很抱歉，您所選的品項內容可能發生變動，請回到上一頁重新確認訂購品項。'
              this.alertDialog.btn = [
                {
                  btnText: '確定',
                  btnColor: 'primary',
                  depressed: true,
                  btnIsLoading: false,
                  btnClick: async () => {
                    this.alertDialog.open = false
                    this.alertDialog.btn.length = 0
                    try {
                      const groupOption = await this.getServiceOptionData()
                      for (const priceOption of this.optionPriceGroup) {
                        for (const price of priceOption.price_option) {
                          if (this.selectedData.price.option[price.price_id.toString()] && price.ProductInfo) {
                            const selectedSkuArr = price.ProductInfo.Skus.filter(v => v.num)
                            const newOption = groupOption.category.filter(v => v.category_option === 1).map(v => v.price_option).flat().filter(v => v.price_id == price.price_id).flat()[0]
                            const newProductInfo = newOption.ProductInfo
                            newProductInfo.Skus = newProductInfo.Skus.map(newSkuV => {
                              selectedSkuArr.forEach(skuV => {
                                if (skuV.SkuId == newSkuV.SkuId) {
                                  newSkuV.num = skuV.num
                                }
                              })
                              return newSkuV
                            })
                            await this.$set(price, 'ProductInfo', newProductInfo)
                            await this.$set(price, 'price_count', this.selectedData.price.option[price.price_id.toString()])
                            this.changeCount(price)
                          }
                        }
                      }
                    } catch (e) {
                      console.log(e)
                    }
                  }
                }
              ]
              this.btn.isSetOrder = false
              this.alertDialog.open = true
              return true
            } else if ([404012, 404034].includes(error?.response?.data?.ErrorMessage?.Code)) { // 服務優惠已到期
              // 清除原有優惠活動資訊
              this.$set(this.promotion, 'PromotionDataList', [])
              this.$set(this.promotion, 'selectedOptionByPromotionId', {})
              this.getPromotion()
              this.$store.dispatch('service/getServiceOption', { id: this.service.service_id })
                .then(this.getPriceOption)
                .then(this.getPromotion)
                .then(async () => {
                  this.discount.bonus.got = false
                  this.discount.ticket.got = false
                  this.selectedData.discount.bonus = {
                    state: 'empty', // 'disable', 'used', 'notuse', 'empty'
                    point: {
                      CanUseBonusAmount: 0,
                      CanUseEnterpriseAmount: 0
                    },
                    isLoading: false,
                    enterpriseCodes: []
                  }
                  this.selectedData.discount.ticket.discount = 0
                  this.selectedData.discount.ticket.TicketInstanceId = null
                  this.selectedData.discount.ticket.index = null
                  this.selectedData.discount.ticket.detail = null
                  for (const priceOption of this.optionPriceGroup) {
                    for (const price of priceOption.price_option) {
                      if (this.selectedData.price.option[price.price_id.toString()]) {
                        // 找出原已選的品項
                        await this.$set(price, 'price_count', this.selectedData.price.option[price.price_id.toString()])
                        this.changeCount(price)
                      }
                    }
                  }
                })
              this.$alert({
                title: '服務優惠已到期',
                message: '很抱歉，由於您預約的服務優惠已到期，訂單金額可能發生變動，請重新確認預約品項',
                btnText: '確定',
                persistent: true,
                btnDonFun: () => {
                  this.btn.isSetOrder = false
                  this.$alert.close()
                }
              })
              return true
            }
            return false
          }
          const commonErrorMsg = checkCommonErrorMsg(error)
          if (this.isGuestPurchase && !commonErrorMsg) {
            this.guestPurchaseErrorCount++
            if (this.guestPurchaseErrorCount < 3) {
              this.$alert({
                title: '系統提示',
                message: `很抱歉，系統資料發送失敗，請您再試一次(${this.guestPurchaseErrorCount})`,
                btnText: '再試一次',
                persistent: true,
                btnDonFun: () => {
                  this.btn.isSetOrder = false
                  this.$alert.close()
                }
              })
            } else {
              let message = '很抱歉，系統目前繁忙中，請稍後再進行訂購'
              if (this.isGuestAgent) {
                message = '很抱歉，系統繁忙中，請您關閉當前頁面並回報技術人員'
              }
              this.$alert({
                title: '系統提示',
                message,
                persistent: true,
                btn: [
                  {
                    btnText: '我知道了',
                    btnColor: 'primary',
                    btnClick: () => {
                      this.$emit('refreshData')
                      this.$store.commit('clearGeustPurchaseData')
                      this.$store.commit('clearGeustPurchaseOrderStatus')
                      // this.pageNow = 1
                      this.$alert.close()
                    }
                  }
                ]
              })
            }
          } else if (!commonErrorMsg) {
            /**
             * 404009 無效優惠券，請重新選擇。 app._goPage('serviceCommodityCoupon', null, 'slide')
             * 404011 紅利點數不足，請重新選擇。 app._goPage('serviceCommodityCoupon', null, 'slide')
             * 404012 404034 很抱歉，由於您預約的服務優惠已到期，訂單金額可能發生變動，請重新確認預約品項
             * 500200 很抱歉，您所選的品項內容可能發生變動，請重新確認訂購品項。
             */
            errorText = '您的預約未成立，請您再試一次或與我們聯絡，謝謝！'
            const discountErrorList = [411066, 411067, 400002, 404015, 404016, 404021, 404022, 404030, 404031, 404032, 404033]
            const discountErrorTextEnum = {
              411066: '當前服務不適用此代碼',
              411067: '當前服務不適用此代碼',
              400002: '此服務無折扣碼活動',
              404015: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
              404016: '推薦碼已操作會員轉換',
              404021: '請勿輸入自己的推薦代碼',
              404022: '當前帳號不符合使用條件',
              404030: '當前服務不適用此代碼',
              404031: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
              404032: '當前帳號已超過使用次數',
              404033: '當前折扣碼已超過總使用次數'
            }
            if (this.isAgentOrder) {
              errorText = '代訂失敗，請您再試一次，謝謝！'
            }
            if (error.response && error.response.data && error.response.data.ErrorMessage && error.response.data.ErrorMessage.Code === 404009) {
              this.discount.bonus.got = false
              this.discount.ticket.got = false
              this.discount.ticket.index = null
              this.alertDialog.title = '系統提示'
              this.alertDialog.message = '無效優惠券，請重新選擇。'
              this.alertDialog.btn = [
                {
                  btnText: '重新選擇',
                  btnColor: 'primary',
                  depressed: true,
                  btnIsLoading: false,
                  btnClick: async () => {
                    this.alertDialog.open = false
                    this.alertDialog.btn.length = 0
                    this.openDialogDiscount()
                  }
                }
              ]
              this.btn.isSetOrder = false
              this.alertDialog.open = true
              return Promise.reject(new Error('error'))
            }
            if (error.response && error.response.data && error.response.data.ErrorMessage && error.response.data.ErrorMessage.Code === 404011) {
              this.discount.bonus.got = false
              this.discount.ticket.got = false
              this.discount.ticket.index = null
              this.alertDialog.title = '系統提示'
              this.alertDialog.message = '紅利點數不足，請重新選擇。'
              this.alertDialog.btn = [
                {
                  btnText: '重新選擇',
                  btnColor: 'primary',
                  depressed: true,
                  btnIsLoading: false,
                  btnClick: async () => {
                    this.alertDialog.open = false
                    this.alertDialog.btn.length = 0
                    this.openDialogDiscount()
                  }
                }
              ]
              this.btn.isSetOrder = false
              this.alertDialog.open = true
              return Promise.reject(new Error('error'))
            }
            if (error?.response?.data?.ErrorMessage?.Code === 500030) { // 派單失敗
              this.$alert.close()
              await this.$awaitSetTimeout(300)
              this.$alert({
                title: '系統提示',
                message: '很抱歉，系統目前繁忙中，請稍後再進行訂購',
                btnText: '我知道了',
                persistent: true,
                btnDonFun: () => {
                  this.$alert.close()
                  this.resetSelectedData()
                }
              })
              return Promise.reject(new Error('error'))
            }
            // 折扣碼/推薦優惠使用失敗
            if (discountErrorList.includes(error?.response?.data?.ErrorMessage?.Code)) {
              this.$alert.close()
              await this.$awaitSetTimeout(300)
              this.selectedData.discount.code.errorMessage = discountErrorTextEnum[error.response.data.ErrorMessage.Code]
              this.selectedData.discount.code.isUse = false
              this.alertDialog.title = '系統提示'
              this.alertDialog.message = '很抱歉，您不符合當前代碼的使用條件，確認是否要繼續成立訂單'
              this.alertDialog.btn = [
                {
                  btnText: '取消',
                  btnColor: '',
                  depressed: true,
                  outlined: false,
                  btnClick: () => {
                    this.alertDialog.open = false
                    this.alertDialog.btn.length = 0
                    const headerHeight = document.querySelector('#header').offsetHeight
                    this.$vuetify.goTo('#code-discount', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
                  }
                },
                {
                  btnText: '確定',
                  btnColor: 'primary',
                  depressed: true,
                  btnIsLoading: false,
                  btnClick: async () => {
                    this.alertDialog.open = false
                    this.alertDialog.btn.length = 0
                    this.clickSetOrder()
                  }
                }
              ]
              this.btn.isSetOrder = false
              this.alertDialog.open = true
              return Promise.reject(new Error('error'))
            }
            this.$gtm.push({
              event: 'serviceSetOrder',
              serviceName: this.service.service_title,
              pageTitle: document.title,
              pageContent: errorText,
              pageType: 'service',
              pageUrl: this.$nuxt.$route.path,
              routeName: this.$nuxt.$route.name,
              step: 'error'
            })
          }
          if (errorText) {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: errorText,
              type: 'error'
            })
          }
          this.btn.isSetOrder = false
          return Promise.reject(new Error('error'))
        })
      const totalPriceChanged = (this.contactServicePriceTotal > 0 && this.selectedContactService) || this.usedDiscount
      if (totalPriceChanged && [this.$store.state.payment.applePay.id, this.$store.state.payment.googlePay.id].indexOf(this.selectedData.payment) > -1) { // 總金額有異動，若選擇apple pay or google pay需重新set paymentRequest
        await this.$store.dispatch('resetPaymentRequest', { paymentId: this.selectedData.payment, amount: this.totalPrice })
      }
      this.$emit('setOrderIsComplete', true)
      if (this.isGuestPurchase) {
        const { GuestLoginForWeb, OrderCreation } = data.Data
        await this.$auth.setUserToken(GuestLoginForWeb.Token)
        data.Data = { ...OrderCreation }
        this.$store.commit('clearGeustPurchaseData')
        this.$store.commit('setGeustPurchaseOrderStatus', { status: true, serviceId: this.serviceId, orderId: data.Data.orders.order_id })
        this.$store.commit('setIsGuestMember', true)
      }
      if (this.selectedData.recipient.remember) { // 加入常用收件人
        const contactList = await this.$store.dispatch('getPersonalContacts')
        await this.$store.dispatch('setPersonalContacts', [
          ...contactList,
          {
            Name: this.selectedData.recipient.name,
            Phone: this.selectedData.recipient.phone,
            Address: this.selectedData.recipient.address,
            PostNumber: this.selectedData.recipient.postId || this.selectedData.recipient.area.region_post,
            City: this.selectedData.recipient.city.region_name,
            Area: this.selectedData.recipient.area.region_name
          }
        ]).catch(() => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '常用收件人加入失敗',
            type: 'error'
          })
        })
      }
      const orderId = data.Data.orders.order_id
      const orderSn = data.Data.orders.order_sn

      // 自動化派工媒合
      const isOrderSendJobMatch = this.householdApplianceSupplier.includes(data.Data.orders.supplier_id) && this.householdApplianceServiceTypeId.includes(data.Data.orders.ServiceTypeId) && this.service.serviceTimeType.id !== 9
      if (isOrderSendJobMatch) {
        this.matchResult.matchStatus = 1
        await this.matchOrderSendJob(data.Data.orders).catch(() => {
          this.matchResult.matchStatus = 7
          return Promise.resolve()
        })
        if (!this.firebaseMatchResult.matchStatus && this.matchResult.matchStatus !== 7) {
          this.$store.dispatch('order/getFirebaseMatchResult', orderId)
        }
      }

      if (this.selectedData.photoList.length > 0) {
        await this.$axios.post('/api/Order/UpdateOrderImg', { Order_id: orderId, Uris: this.selectedData.photoList })
          .catch(() => {
            this.$store.dispatch('toast', {
              isOpen: true,
              text: '照片上傳失敗',
              type: 'error'
            })
          })
      }
      const paymentSelectedName = this.paymentSelectedInfo ? this.paymentSelectedInfo.PaymentTypeName : ''
      this.alertDialog.title = this.service.order_mode_id === 3 ? '您的諮詢已成立！' : '您的訂單已成立！'
      this.alertDialog.message = '點擊前往訂單詳情查看。'
      this.alertDialog.btnText = '查看訂單'
      this.alertDialog.type = 'setOrderSuccess'
      this.alertDialog.persistent = true
      const successObj = {
        orderId,
        orderSn
      }
      // >>> 諮詢
      if (this.service.order_mode_id === 3) {
        this.alertDialog.message = '點擊前往查看聊天室。'
        this.alertDialog.btnText = '前往聊天室'
      }
      // >>>專人聯繫
      if (this.service.is_callback && this.serviceResponseDays) {
        this.alertDialog.message = `專人將於${this.serviceResponseDays}個工作天內(不含例假日)與您聯繫，請留意陌生號碼來電。`
      }
      // >>>洗衣串接
      if (['Laundry'].includes(this.service?.ServiceProcessMode?.Mode)) {
        this.alertDialog.message = '請於付款成功後，至訂單詳情通知廠商取件。'
      }
      // >>>寄件
      if (this.isKTJLogistic || this.isTCatLogistic) {
        this.alertDialog.message = '請於付款成功後，至訂單詳情通知物流取件。'
      }
      // >>>商品
      if (this.service.IsProductMode) {
        this.alertDialog.message = '出貨相關資訊請在付款成功後於訂單詳情中查看。'
      }
      if (this.paymentSelectedInfo.PaymentTimingName === 'AfterOrderEstablished') {
        this.FBConversionAPI('信用卡點擊前往付款', { order_id: orderId })
        this.alertDialog.btnText = '前往付款'
        try {
          if (this.selectedData.price.totalPrice > 0) {
            await this.paySend(orderId)
          }
          if (this.isAgentOrder || this.isGuestAgent) {
            // const httpHost = 'http://localhost:8080' // 開發使用
            const httpHost = this.$nuxt.context.env.EC_CMS_URL
            this.alertDialog.title = '代訂成功'
            this.alertDialog.message = '代訂成功！請於智樂家電商管理平台查看最新狀態與詳細資訊。'
            this.$set(this.alertDialog, 'btn', [
              {
                btnText: '查看訂單',
                btnColor: 'primary',
                btnClick: async () => {
                  await this.$store.dispatch('logOut')
                  if (this.agentOrder.source.includes('sales')) {
                    window.location.href = `${httpHost}/siteadmin/#/sales/agent-order-info/${orderId}/`
                  } else {
                    window.location.href = `${httpHost}/siteadmin/#/order/edit/${orderId}/`
                  }
                }
              }
            ])
          } else {
            const getOrderPaySend = await this.getOrderPaySend(orderId)
            const HashCode = getOrderPaySend ? getOrderPaySend.HashCode : null
            let locationHref = null
            if (!this.$device.isDesktop && (this.selectedData.payment === this.$store.state.globalVariable.PlusPayPaymentID)) {
              // 手機與平板選擇 plus pay，需導向至 QRcode 短網址
              try {
                const routeData = this.$nuxt.$router.resolve({
                  name: 'payment-pluspay-idHashCodeSn',
                  params: {
                    idHashCodeSn: `${orderId}-${HashCode}-${orderSn}`
                  },
                  query: {
                    serviceTitle: this.service.service_title,
                    serviceId: this.serviceId,
                    paymentSelectedName
                  }
                })
                const { data } = await this.$staticEcsApi.post('/api/Payment/FamilyMartPlusPay/CreateBankQrcode', {
                  HashCode,
                  OnlineTrading: 'Online',
                  StoreConfirmUrl: location.origin + routeData.resolved.fullPath // 付款結果頁
                })
                this.$gaLogEvent('訂購流程', `付款_全盈PAY_${this.service.service_title}_${this.serviceId}`)
                locationHref = data.Data.QRCode
              } catch (error) {
                // 若失敗，走顯示 QRcode 流程
              }
            }
            // 零元訂單
            if (this.totalPrice <= 0) {
              this.$set(this.alertDialog, 'btn', [
                {
                  btnText: '查看訂單',
                  btnColor: 'primary',
                  btnClick: () => {
                    const routerObj = {
                      name: 'member-order-idsn',
                      params: {
                        idsn: `${orderId}-${orderSn}`
                      }
                    }
                    this.$nuxt.$router.push(routerObj)
                  }
                }
              ])
            } else {
              if (isOrderSendJobMatch) {
                this.alertDialog.message = '請您付款後於訂單詳情挑選服務人員。'
              }
              this.$set(this.alertDialog, 'btn', [
                {
                  btnText: '前往付款',
                  btnColor: 'primary',
                  btnClick: async () => {
                    if (this.isPaying) return
                    this.FBConversionAPI('AddPaymentInfo')
                    const routerObj = {
                      query: {}
                    }
                    if (locationHref) { // 直接導向
                      this.$gaLogEvent('訂購流程', `付款_全盈PAY_${this.service.service_title}_${this.serviceId}`)
                      location.href = locationHref
                      return
                    }
                    if (this.selectedData.payment === this.$store.state.globalVariable.PlusPayPaymentID) {
                      // PlusPay
                      routerObj.name = 'payment-pluspay-idHashCodeSn'
                      routerObj.params = {
                        idHashCodeSn: `${orderId}-${HashCode}-${orderSn}`
                      }
                      this.$gaLogEvent('訂購流程', `付款_全盈PAY_${this.service.service_title}_${this.serviceId}`)
                    } else {
                      routerObj.name = 'payment-idHashCodeSn'
                      routerObj.params = {
                        idHashCodeSn: `${orderId}-${HashCode}-${orderSn}`
                      }
                      if (this.guestPurchase.orderSuccess.status) {
                        routerObj.query.isGuestPurchase = true
                      }
                    }
                    if (this.selectedData.payment === 1) {
                      if (this.creditCardSelectorDialog.selectedCard && this.creditCardSelectorDialog.cardList.length > 0) {
                        this.isPaying = true
                        const frontendRedirectUrlRouterObj = {
                          name: 'payment-idHashCodeSn',
                          params: {
                            idHashCodeSn: `${orderId}-${HashCode}-${orderSn}`
                          },
                          query: {
                            ...routerObj.query,
                            serviceId: this.serviceId,
                            paymentSelectedName
                          }
                        }
                        try {
                          const frontendRedirectUrl = location.origin + this.$nuxt.$router.resolve(frontendRedirectUrlRouterObj).resolved.fullPath
                          const postData = {
                            CardGuid: this.creditCardSelectorDialog.selectedCard.Guid,
                            HashCode,
                            FrontendRedirectUrl: frontendRedirectUrl
                          }
                          // 使用信用卡付款
                          const { data } = await this.$axios.post('/api/v2/Order/PaymentByCardToken', postData)
                          this.isPaying = false
                          if (data.Status === 1 && data.Data.PaymentUrl) {
                            window.location.href = data.Data.PaymentUrl
                          } else {
                            throw new Error('信用卡付款失敗')
                          }
                          return
                        } catch (error) {
                          this.isPaying = false
                          this.$store.dispatch('toast', {
                            isOpen: true,
                            text: '信用卡付款失敗',
                            type: 'error'
                          })
                          routerObj.query = {
                            ...routerObj.query,
                            serviceTitle: encodeURIComponent(this.service.service_title),
                            serviceId: this.serviceId,
                            paymentSelectedName
                          }
                          this.$nuxt.$router.push(routerObj)
                          return
                        }
                      }
                    }
                    if (this.selectedData.price.totalPrice <= 0) {
                      routerObj.query.status = 0
                    }
                    if ([this.$store.state.payment.applePay.id, this.$store.state.payment.googlePay.id].indexOf(this.selectedData.payment) > -1) { // Apple Pay || Google Pay
                      this.alertDialog.open = false
                      this.btn.isSetOrder = false
                      this.btn.isMobilePay = true
                      try {
                        const mobilePrime = await this.$store.dispatch('getPrime', { paymentId: this.selectedData.payment })
                          .catch(error => {
                            console.log('getPrime error', error)
                            throw new Error(error)
                          })
                        await this.$store.dispatch('checkIsOpenTappayAlert')
                        await this.$store.dispatch('mobilePay', { mobilePrime, HashCode })
                        console.log('mobilePrime', mobilePrime)
                      } catch (error) {
                        console.log(error)
                        this.$gaLogEvent('訂購流程', `付款失敗_${paymentSelectedName}_${this.service.service_title}_${this.serviceId}`)
                        this.$alert({
                          title: '付款失敗',
                          message: '付款失敗，請稍後再試!',
                          btnText: '關閉',
                          btnDonFun: async () => {
                            await this.$alert.close()
                            this.$nuxt.$router.push({
                              name: 'member-order-idsn',
                              params: {
                                idsn: `${orderId}-${orderSn}`
                              }
                            })
                          }
                        })
                        return
                      }
                      this.btn.isMobilePay = false
                    }
                    routerObj.query = {
                      ...routerObj.query,
                      serviceTitle: this.service.service_title,
                      serviceId: this.serviceId,
                      paymentSelectedName
                    }
                    console.log('routerObj:', routerObj)
                    this.$nuxt.$router.push(routerObj)
                  }
                }
              ])
            }
          }
        } catch (error) {
          console.log(error)
          this.$set(this.alertDialog, 'btn', [
            {
              btnText: '查看訂單',
              btnColor: 'primary',
              btnClick: () => {
                const routerObj = {
                  name: 'member-order-idsn',
                  params: {
                    idsn: `${orderId}-${orderSn}`
                  }
                }
                this.$nuxt.$router.push(routerObj)
              }
            }
          ])
        }
      } else if (this.isAgentOrder || this.isGuestAgent) {
        this.alertDialog.title = '代訂成功'
        this.alertDialog.message = '代訂成功！請於智樂家電商管理平台查看最新狀態與詳細資訊。'
        this.$set(this.alertDialog, 'btn', [
          {
            btnText: '查看訂單',
            btnColor: 'primary',
            btnClick: async () => {
              const httpHost = this.$nuxt.context.env.EC_CMS_URL
              await this.$store.dispatch('logOut')
              if (this.agentOrder.source.includes('sales')) {
                window.location.href = `${httpHost}/siteadmin/#/sales/agent-order-info/${orderId}/`
              } else {
                window.location.href = `${httpHost}/siteadmin/#/order/edit/${orderId}/`
              }
            }
          }
        ])
      } else {
        this.FBConversionAPI('現金付款點擊確認預約', { order_id: orderId })
        this.$set(this.alertDialog, 'btn', [
          {
            btnText: '查看訂單',
            btnColor: 'primary',
            btnClick: () => {
              const routerObj = {
                name: 'member-order-idsn',
                params: {
                  idsn: `${orderId}-${orderSn}`
                }
              }
              this.$nuxt.$router.push(routerObj)
            }
          }
        ])
      }
      // infobipTrackEvent
      if (this.paymentSelectedInfo.PaymentTimingName === 'None') {
        this.$gaLogEvent('訂單成立', `${this.service.service_title}_${this.serviceId}`)
        this.$infobipTrackEvent('setOrder', {
          serviceId: `${this.serviceId}`,
          serviceTitle: `${this.service.service_title}`,
          serviceMainType: `${this.service.type_parent}`,
          serviceSubType: `${this.service.type_id}`,
          ticketId: `${this.selectedData.discount.ticket && this.selectedData.discount.ticket.detail ? this.selectedData.discount.ticket.detail.Id : ''}`
        })
      } else {
        let paymentType = ''
        switch (this.selectedData.payment) {
          case 1:
            paymentType = '信用卡'
            if (this.creditCardSelectorDialog.selectedCard) {
              paymentType = '綁定信用卡'
            }
            break
          case 2: paymentType = 'ATM轉帳'
            break
          case 4: paymentType = '現金付款'
            break
          case 5: paymentType = '全盈+PAY'
            break
          case 7: paymentType = 'Google Pay'
            break
          case 8: paymentType = 'Apple Pay'
            break
          default:
            break
        }
        this.$gaLogEvent('訂單成立', `${paymentType}_${this.service.service_title}_${this.serviceId}`)
        this.$infobipTrackEvent('setOrder', {
          serviceId: `${this.serviceId}`,
          serviceTitle: `${this.service.service_title}`,
          serviceMainType: `${this.service.type_parent}`,
          serviceSubType: `${this.service.type_id}`,
          ticketId: `${this.selectedData.discount.ticket && this.selectedData.discount.ticket.detail ? this.selectedData.discount.ticket.detail.Id : ''}`
        })
      }
      if (this.isFromFacebookAds) {
        this.$gaLogEvent('FB廣告下單', orderSn)
      }
      this.$gtm.push({
        event: 'serviceSetOrder',
        serviceName: this.service.service_title,
        serviceId: this.serviceId,
        pageTitle: document.title,
        pageType: 'service',
        pageUrl: this.$nuxt.$route.path,
        routeName: this.$nuxt.$route.name,
        step: 'success'
      })
      const isFBTrackExcludeChannelType = this.FBTrackExcludeChannelType.includes(this.selectedData.channelType.id)
      const isFBTrackService = this.FBTrackServices.some(serviceId => parseInt(serviceId) === parseInt(this.serviceId))
      if (!isFBTrackExcludeChannelType && isFBTrackService) {
        this.FBConversionAPI('Purchase', { order_id: orderId })
      }
      this.$set(this.alertDialog, 'successData', successObj)
      if (isOrderSendJobMatch && (this.paymentSelectedInfo.PaymentTimingName === 'None' || this.totalPrice <= 0)) { // 現金付款 or 0元訂單
        this.matchResult.searchDialogOpen = true
        setTimeout(() => {
          this.matchResult.canChangeDialog = true
        }, 2000)
      } else {
        this.alertDialog.open = true
      }
    },
    /** 確認優惠券 */
    async checkTicket () {
      /**
       *  若有可使用優惠券但並未選擇，需出現 alert 提示使用者
       */
      if (this.isQuotationMode) return true
      if (this.selectedData.discount.ticket.TicketInstanceId) return true
      if (!this.discount.ticket.got) {
        this.btn.isSetOrder = true
        await this.getTicket()
      }
      if (this.discount.ticket.list.length > 0) {
        const ticketAlertContinue = await this.ticketCheckAlert()
        return !ticketAlertContinue
      }
      return true
    },
    ticketCheckAlert () {
      return new Promise((resolve) => {
        this.$alert({
          title: '優惠券未使用',
          message: '提醒您，您當前有優惠券尚未使用，是否要進行折抵？',
          persistent: true,
          btn: [
            {
              btnText: '暫時不用',
              btnClick: () => {
                this.$gaLogEvent('優惠券提示', `click_暫時不用_${this.service.service_title}_${this.serviceId}`)
                this.$alert.close()
                resolve(false)
              }
            },
            {
              btnText: '立即使用',
              btnColor: 'primary',
              btnClick: () => {
                this.$gaLogEvent('優惠券提示', `click_立即使用_${this.service.service_title}_${this.serviceId}`)
                this.openDialogDiscount()
                this.$alert.close()
                resolve(true)
              }
            }
          ]
        })
      })
    },
    async paySend (orderId) {
      const { data } = await this.$axios.post('/api/Order/PaySend', { OrderId: orderId })
        .catch(error => Promise.reject(error))
      return data.Data
    },
    async getOrderPaySend (orderId) {
      const { data } = await this.$axios.get('/api/Order/GetOrderPaySend', { params: { OrderId: orderId } })
        .catch(error => Promise.reject(error))
      return data.Data.length > 0 ? data.Data[0] : null
    },
    getServiceTimeHour (startDateTime, isStart = false) {
      if (!this.serviceTimeDay) this.selectedData.datetime.timeStartHourOptions = []
      const timeStartHourArray = []
      const serviceTimeTypeId = parseInt(this.service.serviceTimeType.id)
      const selectedDate = this.selectedData.datetime.date ? new Date(this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' ')) : ''
      this.serviceTimeDay.map(time => {
        let startTime = new Date(this.$dayjs(selectedDate).format('YYYY/MM/DD') + ' ' + time.StartTime)
        let dueTime = new Date(this.$dayjs(selectedDate).format('YYYY/MM/DD') + ' ' + time.DueTime)
        const minute = [5, 6].indexOf(serviceTimeTypeId) > -1 ? 30 : 5
        if (this.$dayjs(selectedDate).isSame(new Date(startDateTime), 'D') &&
            this.$dayjs(new Date(startDateTime)).isSameOrAfter(startTime)) {
          // startDateTime 時間後
          startTime = new Date(startDateTime)
        }
        if (time.DueTime === '24:00:00') {
          dueTime = new Date(this.$dayjs(selectedDate).endOf('day'))
        }
        if ([3, 4].indexOf(serviceTimeTypeId) > -1) {
          // 【小時制】時間(小時)、時間範圍(小時)
          let addHour = 1
          if (this.$dayjs(startTime).format('mm') === '00' && isStart) {
            addHour = 0
          }
          startTime = new Date(this.$dayjs(startTime).add(addHour, 'h').startOf('hour'))
          if (serviceTimeTypeId === 4 && isStart) {
            // 範圍&起始時間
            if (this.$dayjs(dueTime).format('mm') !== '00') {
              // 設定小時制，但是結尾不是整點
              dueTime = new Date(this.$dayjs(dueTime).add(-1, 'h').endOf('hour'))
            }
          }
        }
        if (this.$dayjs(dueTime).format('HH') === '00' && [3, 5, 7].indexOf(serviceTimeTypeId) > -1) {
          dueTime = new Date(this.$dayjs(dueTime).add(-1, 'm'))
        }
        if ([5, 6, 7, 8].indexOf(serviceTimeTypeId) > -1) {
          // [5, 6]【半小時制】時間(半小時)、時間範圍(半小時)
          // [7, 8]【5分鐘制】時間(5分鐘)、時間範圍(5分鐘)
          // !isStart => 時間範圍(迄) => [6, 8]
          if (!this.$dayjs(startTime).add(minute, 'm').isSame(this.$dayjs(startTime), 'hour')) {
            if (isStart &&
              this.$dayjs(startTime).add(minute, 'm').format('mm') !== '00') {
              startTime = new Date(this.$dayjs(startTime).add(minute, 'm').startOf('hour'))
            }
            if (isStart && [6, 8].indexOf(serviceTimeTypeId) > -1 &&
              this.$dayjs(dueTime).add(-minute, 'm').isSame(this.$dayjs(dueTime), 'hour')) {
              if (this.$dayjs(dueTime).add(-minute, 'm').add(1, 'hour').isSame(this.$dayjs(dueTime), 'day')) {
                dueTime = new Date(this.$dayjs(dueTime).add(-minute, 'm').add(1, 'hour').startOf('hour'))
              }
            }
            if (!isStart && this.$dayjs(startTime).add(minute, 'm').startOf('day').isSame(this.$dayjs(startTime).add(1, 'd').startOf('day'))) {
              // 換日
              startTime = new Date(this.$dayjs(startTime).endOf('day'))
            } else if (!isStart) {
              startTime = new Date(this.$dayjs(startTime).add(minute, 'm'))
            }
          }
        }
        let diff = this.$dayjs(dueTime).diff(this.$dayjs(startTime), 'h')
        if ([3, 5, 7].indexOf(serviceTimeTypeId) > -1 || !isStart) {
          // 非範圍，可選最後時刻
          diff += 1
        }
        if (isStart && [4, 6, 8].indexOf(serviceTimeTypeId) > -1 &&
            this.$dayjs(this.$dayjs(dueTime)).add(-minute, 'm').isSame(this.$dayjs(dueTime), 'hour') &&
            this.$dayjs(startTime).isBefore(this.$dayjs(dueTime).add(-minute, 'm'))) {
          // 時間範圍模式，若結束時間上一時段仍在同一小時且在開始時間之前，可選時段 +1
          diff += 1
        }
        if (!isStart) {
          // 選取範圍(迄)
          if (this.$dayjs(startTime).add(minute, 'm').startOf('day').isSame(this.$dayjs(startTime).add(1, 'd').startOf('day'))) {
            // 換日
            diff = 0
          }
          if (serviceTimeTypeId === 4 && this.$dayjs(new Date(startDateTime)).format('HH') === '23') {
            // 時間範圍(小時) && 起始時間為23
            diff = 0
          }
        }
        for (let i = 0; i < parseInt(diff); i++) {
          let hourNum = parseInt(this.$dayjs(startTime).format('H')) + i
          hourNum = hourNum < 10 ? '0' + hourNum : String(hourNum)
          timeStartHourArray.push(hourNum)
        }
        if (time.DueTime === '24:00:00' && diff > 0) { // 當天仍有時間可選，避免使用者在 23:59 時可選擇到任何時間
          let pushHour = '23'
          if ([3, 5, 7].indexOf(serviceTimeTypeId) > -1) {
            // 【非範圍】
            // 3: 時間(小時)
            // 5: 時間(半小時)
            // 7: 時間(5分鐘)
            pushHour = '24'
          }
          if ([4, 6, 8].indexOf(serviceTimeTypeId) > -1 && !isStart) {
            // 【範圍】& is endTime
            pushHour = '24'
          }
          timeStartHourArray.push(pushHour)
        }
        return time
      })
      return timeStartHourArray
    },
    getServiceTimeMinute (startDateTime, isStart = false) {
      const serviceTimeTypeId = parseInt(this.service.serviceTimeType.id)
      let minuteList = []
      let selectedHour = isStart ? parseInt(this.selectedData.datetime.timeStartHour) : parseInt(this.selectedData.datetime.timeEndHour)
      const selectedDate = this.selectedData.datetime.date ? new Date(this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' ')) : ''
      this.serviceTimeDay.forEach(time => {
        let StartTime = new Date(this.$dayjs(selectedDate).format('YYYY/MM/DD') + ' ' + time.StartTime)
        let DueTime = new Date(this.$dayjs(selectedDate).format('YYYY/MM/DD') + ' ' + time.DueTime)
        selectedHour = selectedHour < 10 ? '0' + selectedHour : selectedHour
        const selectedDateTime = new Date(this.$dayjs(selectedDate).format('YYYY/MM/DD') + ' ' + selectedHour + ':00:00')
        if (this.$dayjs(selectedDateTime).isAfter(this.$dayjs(DueTime), 'hour') ||
            this.$dayjs(selectedDateTime).isBefore(this.$dayjs(StartTime), 'hour')) return
        if ([3, 4].indexOf(serviceTimeTypeId) > -1) {
          // 【小時制】時間(小時)、時間範圍(小時)
          minuteList = ['00']
        }
        if (time.DueTime === '24:00:00') {
          DueTime = new Date(this.$dayjs(DueTime).add(-1, 'm'))
        }
        if ([5, 6, 7, 8].indexOf(serviceTimeTypeId) > -1) {
          // [5, 6]【半小時制】時間(半小時)、時間範圍(半小時)
          // [7, 8]【5分鐘制】時間(5分鐘)、時間範圍(5分鐘)
          const minute = [5, 6].indexOf(serviceTimeTypeId) > -1 ? 30 : 5
          let startMinute = 0
          let endMinute = 60
          if ([6, 8].indexOf(serviceTimeTypeId) > -1 && !isStart) {
            // 範圍
            const selectedStartTime = new Date(`${this.$dayjs(selectedDate).format('YYYY/MM/DD')} ${this.selectedData.datetime.timeStartHour}:${this.selectedData.datetime.timeStartMinute}`)
            // if (this.$dayjs(selectedStartTime).add(minute, 'm').isSame(this.$dayjs(selectedStartTime), 'hour')) {
            if (this.selectedData.datetime.timeEndHourOptions.indexOf(this.$dayjs(selectedStartTime).add(minute, 'm').format('HH')) > -1) {
              // 已選起始時間＋時間間距(5/30)，與原本已選時間相同hour
              // 將分鐘自動篩選
              StartTime = new Date(this.$dayjs(selectedStartTime).add(minute, 'm'))
            }
          }
          if (parseInt(selectedHour) === parseInt(this.$dayjs(StartTime).format('HH'))) {
            // 選擇時間與開始時間一樣hour
            startMinute = parseInt(this.$dayjs(StartTime).format('m'))
            startMinute = startMinute % minute > 0 ? (Math.floor(startMinute / minute) + 1) * minute : startMinute
          }
          if (parseInt(selectedHour) === parseInt(this.$dayjs(DueTime).format('HH'))) {
            // 選擇時間與結束時間一樣hour
            endMinute = parseInt(this.$dayjs(DueTime).format('m'))
            endMinute = endMinute % minute > 0 ? Math.floor(endMinute / minute) * minute : endMinute
            endMinute = endMinute + minute
            if ([6, 8].indexOf(serviceTimeTypeId) > -1 && isStart) {
              // 時間範圍
              endMinute = endMinute - minute
            }
            if (serviceTimeTypeId === 6 && time.DueTime === '24:00:00' && parseInt(selectedHour) === 23) {
              // 半小時範圍、結束時間為24:00、選擇時間為23
              if (isStart) {
                endMinute = endMinute + minute
              } else {
                endMinute = 60
              }
            }
            if (serviceTimeTypeId === 8 && time.DueTime === '24:00:00' && parseInt(selectedHour) === 23) {
              // 時間範圍(5分鐘)、結束時間為24:00、選擇時間為2
              if (isStart) {
                endMinute = 60
              } else {
                endMinute = 60
              }
            }
          }
          for (let i = 0; i < (endMinute - startMinute) / minute; i++) {
            let m = startMinute + i * minute
            m = m < 10 ? '0' + m : String(m)
            minuteList.push(m)
          }
          if (parseInt(selectedHour) === 24) {
            minuteList = ['00']
          }
        }
      })
      if (this.$dayjs(selectedDate).isSame(this.$dayjs(startDateTime), 'day') &&
        selectedHour === parseInt(this.$dayjs(startDateTime).format('H'))) {
        // 當天 選了現在的小時
        minuteList = minuteList.filter(minute => {
          return parseInt(minute) > parseInt(this.$dayjs(startDateTime).format('m'))
        })
      }
      return minuteList
    },
    checkServiceTimeValidate () {
      const checkValidate = this.checkDateTime()
      if (!checkValidate.isError) {
        delete this.selectedData.datetime.checkValidate
      }
    },
    checkOptionValidate (option) {
      let checkValidate
      if (option.category_option === 2) checkValidate = this.checkRadio(option) // 單選
      if (option.category_option === 4) checkValidate = this.checkCheckbox(option) // 複選
      if (option.category_option === 5) checkValidate = this.checkAnswer(option) // 問答
      if (!checkValidate.isError) {
        const optionError = _.cloneDeep(this.selectedData.option.error)
        delete optionError[option.category_id]
        this.$set(this.selectedData.option, 'error', optionError)
      }
    },
    getServiceTimeStartHour () {
      const timeStartHourArray = this.getServiceTimeHour(this.$dayjs(), true)
      this.selectedData.datetime.timeStartHourOptions = [...timeStartHourArray]
      this.selectedData.datetime.timeStartHour = timeStartHourArray[0] || null
      this.getServiceTimeStartMinute()
      this.checkServiceTimeValidate()
    },
    getServiceTimeStartMinute () {
      const serviceTimeTypeId = parseInt(this.service.serviceTimeType.id)
      const minuteList = this.getServiceTimeMinute(this.$dayjs(), true)
      this.selectedData.datetime.timeStartMinuteOptions = [...minuteList]
      this.selectedData.datetime.timeStartMinute = minuteList[0] || null
      this.checkServiceTimeValidate()
      if ([4, 6, 8].indexOf(serviceTimeTypeId) > -1) {
        // 範圍
        this.getSetviceTimeEndHour()
      }
      this.checkServiceTimeValidate()
    },
    getSetviceTimeEndHour () {
      const selectedDataDatetime = this.selectedData.datetime.date ? this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' ') : ''
      const selectDate = this.$dayjs(new Date(selectedDataDatetime)).format('YYYY/MM/DD')
      const selectedStartTime = this.$dayjs(new Date(`${selectDate} ${this.selectedData.datetime.timeStartHour}:${this.selectedData.datetime.timeStartMinute}:00`))
      const selectedEndTime = this.$dayjs(new Date(`${selectDate} ${this.selectedData.datetime.timeEndHour}:${this.selectedData.datetime.timeEndMinute}:00`))
      const serviceTimeTypeId = parseInt(this.service.serviceTimeType.id)
      const minute = [5, 6].indexOf(serviceTimeTypeId) > -1 ? 30 : 5
      const timeEndHourArray = this.getServiceTimeHour(selectedStartTime, false)
      this.selectedData.datetime.timeEndHourOptions = [...timeEndHourArray]
      const nextHourIndex = timeEndHourArray.indexOf(this.$dayjs(selectedStartTime).add(minute, 'm').format('HH'))
      let nextHour = timeEndHourArray[0]
      if (nextHourIndex > -1) {
        nextHour = timeEndHourArray[nextHourIndex]
      }
      if (// 選擇日期
        this.selectedData.datetime.timeEndHour === null ||
          // 若 服務時間(迄) <= 服務時間(起) + 時間間距
          // 自動調整 服務時間(迄) 的時間
          this.$dayjs(selectedEndTime).isSameOrBefore(this.$dayjs(selectedStartTime).add(minute, 'm')) ||
          // 服務時間(迄) hour 不在可選時間範圍內
          timeEndHourArray.indexOf(this.selectedData.datetime.timeEndHour) === -1) {
        this.selectedData.datetime.timeEndHour = nextHour || '00'
      }
      this.getServiceTimeEndMinute()
      this.checkServiceTimeValidate()
    },
    getServiceTimeEndMinute () {
      const selectedDataDatetime = this.selectedData.datetime.date ? this.selectedData.datetime.date.replace(/-/g, '/').replace('T', ' ') : ''
      const selectDate = this.$dayjs(new Date(selectedDataDatetime)).format('YYYY/MM/DD')
      const serviceTimeTypeId = parseInt(this.service.serviceTimeType.id)
      const selectedStartTime = this.$dayjs(new Date(`${selectDate} ${this.selectedData.datetime.timeStartHour}:${this.selectedData.datetime.timeStartMinute}:00`))
      const selectedEndTime = this.$dayjs(new Date(`${selectDate} ${this.selectedData.datetime.timeEndHour}:${this.selectedData.datetime.timeEndMinute}:00`))
      const minute = [5, 6].indexOf(serviceTimeTypeId) > -1 ? 30 : 5
      const minuteList = this.getServiceTimeMinute(selectedStartTime, false)
      this.selectedData.datetime.timeEndMinuteOptions = [...minuteList]
      if (// 選擇日期
        this.selectedData.datetime.timeEndMinute === null ||
          // 若 服務時間(迄) <= 服務時間(起) + 時間間距
          // 自動調整 服務時間(迄) 的時間
          this.$dayjs(selectedEndTime).isSameOrBefore(this.$dayjs(selectedStartTime).add(minute, 'm')) ||
          // 服務時間(迄) minute 不在可選時間範圍內
          minuteList.indexOf(this.selectedData.datetime.timeEndMinute) === -1) {
        this.selectedData.datetime.timeEndMinute = minuteList[0] || '00'
      }
      if (this.selectedData.datetime.timeEndHour === '24') {
        this.selectedData.datetime.timeEndMinute = '00'
      }
      this.checkServiceTimeValidate()
    },
    getServiceSelectedTime (id) {
      const weekdayMapping = {
        1: '平日',
        2: '假日',
        3: '平/假日'
      }
      const timeMapping = {
        1: '早上',
        2: '下午',
        4: '晚上',
        7: '皆可'
      }
      let showText = ''
      if (id === 10) {
        showText = `${weekdayMapping[this.selectedData.datetime.weekdayReservation]} ${timeMapping[this.selectedData.datetime.defaultTime]}`
      } else {
        const date = this.$dayjs(new Date(this.selectedData.datetime.date)).format('YYYY/MM/DD ddd')
        if (id === 1) showText = `${date} ${timeMapping[this.selectedData.datetime.defaultTime]}`
        if (id === 2) showText = `${date}`
        if ([3, 5, 7].includes(id)) showText = `${date} ${this.selectedData.datetime.timeStartHour}:${this.selectedData.datetime.timeStartMinute}`
        if ([4, 6, 8].includes(id)) showText = `${date} ${this.selectedData.datetime.timeStartHour}:${this.selectedData.datetime.timeStartMinute} - ${this.selectedData.datetime.timeEndHour}:${this.selectedData.datetime.timeEndMinute}`
      }
      return showText
    },
    getServiceSelectedPrice () {
      const selectedData = []
      this.optionPriceGroup.forEach(option => {
        const selectedList = option.price_option.filter(price => Object.keys(this.selectedData.price.option).indexOf(String(price.price_id)) > -1).map(price => {
          if (this.selectedData.price.ProductInfo && Object.keys(this.selectedData.price.ProductInfo).indexOf(String(price.price_id)) > -1) {
            price.ProductInfo = this.selectedData.price.ProductInfo[String(price.price_id)]
          }
          return price
        })
        if (selectedList.length > 0) {
          selectedData.push({
            title: option.category_name,
            id: option.category_id,
            options: selectedList
          })
        }
      })
      return selectedData
    },
    getServiceSelectedOption () {
      const selectedData = []
      this.optionGroup.forEach(option => {
        if (!this.selectedData.option[option.category_id]) return
        if (Array.isArray(this.selectedData.option[option.category_id]) && this.selectedData.option[option.category_id].length === 0) return
        if (!this.selectedData.option[option.category_id]) return
        const value = []
        if (option.category_option === 2) {
          // 2: 單選
          const answer = option.option.filter(o => String(this.selectedData.option[option.category_id]) === String(o.option_id))
          answer.forEach((a, index) => {
            value.push({
              option_id: a.option_id,
              label: a.option_name
            })
          })
        }
        if (option.category_option === 4) {
          // 4: 複選
          const answer = option.option.filter(o => this.selectedData.option[option.category_id].indexOf(o.option_id) > -1)
          answer.forEach((a, index) => {
            value.push({
              option_id: a.option_id,
              label: a.option_name
            })
          })
        }
        if (option.category_option === 5) {
          // 問答
          value.push({
            category_tips: option.category_tips,
            option_id: option.category_id,
            label: this.selectedData.option[option.category_id]
          })
        }
        selectedData.push({
          title: option.category_name,
          category_option: option.category_option,
          id: option.category_id,
          value
        })
      })
      return selectedData
    },
    getDonateOptionsName () {
      const donate = _.find(this.selectedData.receipt.donateOptions, { NPOBAN: this.selectedData.receipt.donate })
      return donate ? donate.unitName : '捐贈單位'
    },
    clickUpload () {
      if (this.selectedData.photoList.length >= 6) return // 最多六張
      this.$refs.upload?.click()
    },
    async inputFile (file) {
      if (!file) return
      if (file.length === 0) return
      const self = this
      let imageIndex = 0
      const data = await loadImage(file.target.files[0], { meta: true, orientation: true, canvas: true })
      if (data.exif && data.imageHead) {
        await loadImage.writeExifData(data.imageHead, data, 'Orientation', 1)
      }
      data.image.toBlob(async blob => {
        const newBlob = await loadImage.replaceHead(blob, data.imageHead)
        const reader = new FileReader()
        reader.onload = function (e) {
          imageIndex = self.selectedData.photoList.length
          self.selectedData.photoList.push(e.target.result)
        }
        let image
        if (newBlob) {
          reader.readAsDataURL(newBlob)
          image = await self.getImageWaterMark(newBlob)
        } else {
          reader.readAsDataURL(blob)
          image = await self.getImageWaterMark(blob)
        }
        self.selectedData.photoList.splice(imageIndex, 1, image[0].FileUrl)
        if (self.selectedData.photoList.length > 0) this.$set(this.selectedData, 'photoValidate', true)
      }, file.target.files[0].type)
    },
    async getImageWaterMark (file) {
      const compressedImage = await ImageProcess.getCompressedImage(file, { quality: 0.6 }) // 取得壓縮後圖檔
      const formData = new FormData()
      formData.append('file0', compressedImage)
      const { data } = await this.$axios.post('/api/Order/UpdateOrderImgWarterMark', formData)
      return data.Data
    },
    clickPhoto (imageList, index) {
      this.$store.dispatch('imageBrowser', {
        isOpen: true,
        imageList: _.cloneDeep(imageList),
        activeIndex: index
      })
    },
    removeImage (imageList, index) {
      imageList.splice(index, 1)
    },
    async isLogin (prop) {
      // 彈窗登入後
      if (['phoneValidation', 'guestValidation'].includes(prop)) {
        // 手機驗證
        this.$set(this.personalInfo, 'phoneIsSaved', true)
        const userInfo = this.$auth.user
        if (prop === 'phoneValidation') {
          this.$auth.setUser({
            ...userInfo,
            APhone: this.personalInfo.APhone
          })
        } else {
          this.personalInfo.phoneErrorMessage = ''
        }
        this.loginDailog.open = false
        if (this.personalInfo.AName) {
          delete this.personalInfo.checkValidate
        }
        return
      }
      const headerHeight = document.querySelector('#header').offsetHeight + 20
      await this.$vuetify.goTo('#service-item', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
      if (prop === 'register') {
        await this.$store.dispatch('registerSuccess', { isOpen: true, scrollTop: true })
        this.$gtm.push({
          event: 'serviceRegisterSuccess',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
      }
      if (prop === 'googleLogin') {
        this.$gtm.push({
          event: 'serviceGoogleLogined',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
      }
      if (!prop) {
        this.$gtm.push({
          event: 'serviceLogined',
          serviceName: this.service.service_title,
          serviceId: this.serviceId,
          pageTitle: document.title,
          pageType: 'service',
          pageUrl: this.$nuxt.$route.path,
          routeName: this.$nuxt.$route.name
        })
      }
      this.setPersonalInfo()
      this.setReceipt(this.selectedData.receipt)
      if (!this.isCommunity) {
        this.setAddress()
      }
      if (this.pageNow === 1 && this.optionGroup.length === 0) {
        this.pageNow = 3
      } else {
        this.pageNow = this.pageNow + 1
      }
      this.loginDailog.open = false
    },
    loginClose () {
      this.$gtm.push({
        event: 'serviceRegisterLoginClose',
        serviceName: this.service.service_title,
        serviceId: this.serviceId,
        pageTitle: document.title,
        pageType: 'service',
        pageUrl: this.$nuxt.$route.path,
        routeName: this.$nuxt.$route.name
      })
      this.loginDailog.open = false
    },
    async contactDialogOpen () {
      this.contactDialog.open = true
      if (this.contactDialog.contactList.length === 0) {
        const contactList = await this.$store.dispatch('getPersonalContacts')
        const contactWithIdList = contactList.map((item, itemIndex) => {
          item.id = `contact_${itemIndex}`
          return item
        })
        this.$set(this.contactDialog, 'contactList', contactWithIdList)
        this.$set(this.contactDialog, 'originContactList', contactWithIdList)
      }
      this.contactDialog.loading = false
    },
    regionDialogSubmit () {
      const address = this.regionDialog.regionList[this.regionDialog.selectedIndex]
      this.selectedData.region.name = address.Name
      this.selectedData.region.phone = address.Phone
      this.selectedData.region.address = address.Address
      let city = address.City
      if (city.substring(0, 1) === '台') {
        city = '臺' + city.substring(1)
      }
      const selectedCity = _.find(this.cityList, { MainName: city })
      if (!selectedCity) return
      const selectedArea = _.find(selectedCity.AreaList, { ParentName: address.Area })
      if (!selectedArea) return // 預設地址「區域」不符合服務地區
      this.selectedData.region.city = selectedCity
      this.setAreaList(selectedCity.MainID)
      this.selectedData.region.area = selectedArea
      this.regionDialog.open = false
    },
    regionCreate (data) {
      const address = _.cloneDeep(data)
      address.isDisabled = false
      const theCity = _.find(this.cityList, { MainName: address.City })
      if (!theCity) {
        address.isDisabled = true
      } else {
        const theArea = _.find(theCity.AreaList, { ParentName: address.Area })
        if (!theArea) {
          address.isDisabled = true
        }
      }
      this.regionDialog.regionList.push(address)
    },
    async contactDialogSubmit (index) {
      const contact = this.contactDialog.contactList[index]
      this.selectedData.recipient.name = contact.Name
      this.selectedData.recipient.phone = contact.Phone
      this.selectedData.recipient.address = contact.Address
      let city = contact.City
      if (city.substring(0, 1) === '台') {
        city = '臺' + city.substring(1)
      }
      const theCity = _.find(this.allCityList, { region_name: city })
      this.$set(this.selectedData.recipient, 'city', theCity)
      await this.changeAllCity(theCity)
      const theArea = _.find(this.allAreaList, { region_name: contact.Area })
      this.$set(this.selectedData.recipient, 'area', theArea)
      if (this.selectedData.recipient.checkValidate) {
        if (this.$refs.serviceRegionRecipient.validate()) {
          delete this.selectedData.recipient.checkValidate
        }
      }
      this.contactDialogClose()
    },
    contactDialogDelete (index) {
      this.contactDialog.deleteOpen = true
      this.contactDialog.deleteIndex = index
    },
    contactDialogClose () {
      this.contactDialog.open = false
      this.contactDialog.selectedIndex = null
    },
    async deleteContact (index) {
      if (index === null) return
      this.contactDialog.deleteLoading = true
      const contactList = _.cloneDeep(this.contactDialog.contactList)
      const originContactList = _.cloneDeep(this.contactDialog.originContactList)
      const deletedIndex = contactList.findIndex(item => item.id === index)
      const deletedIndexOfOrigin = originContactList.findIndex(item => item.id === index)
      contactList.splice(deletedIndex, 1)
      originContactList.splice(deletedIndexOfOrigin, 1)
      const postData = originContactList.map(item => {
        const { id, ...rest } = item
        return rest
      })
      await this.$store.dispatch('setPersonalContacts', postData)
        .catch(error => {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '刪除收件人失敗',
            type: 'error'
          })
          this.contactDialog.deleteLoading = false
          return Promise.reject(error)
        })
      this.$store.dispatch('toast', {
        isOpen: true,
        text: '刪除收件人成功',
        type: 'success'
      })
      this.contactDialog.contactList = contactList
      this.contactDialog.originContactList = originContactList
      this.contactDialog.deleteLoading = false
      this.contactDialog.deleteOpen = false
    },
    searchContact (value) {
      this.contactDialog.contactList = this.contactDialog.originContactList
      if (!value) return
      this.contactDialog.contactList = this.contactDialog.originContactList.filter(contact => {
        return contact.Name.includes(value) || contact.Phone.includes(value)
      })
    },
    termSubmit () {
      this.term.isRead = true
      this.term.dialogOpen = false
      if (this.term.next) {
        this.term.next()
        delete this.term.next
      }
    },
    termClose () {
      this.term.dialogOpen = false
      delete this.term.next
    },
    clickTicketCheckbox (index) {
      let value = index
      if (this.discount.ticket.index === index) {
        value = ''
      }
      this.$set(this.discount.ticket, 'index', value)
    },
    async closeDialogCoupon (receivedCoupon = false) {
      this.openDialogCoupon = false
      if (receivedCoupon) {
        this.discount.ticket.got = false
        this.discount.bonus.got = false
        await this.openDialogDiscount()
      }
    },
    getSelectedSkuNameJoin (optionV, skuV, delimiter = '/') {
      let joinName = ''
      if (optionV.ProductInfo) {
        joinName = skuV.VariantsAndOptions.map((variantsAndOptionsV) => {
          const id = variantsAndOptionsV.ProductVariantOptionId
          let name = ''
          optionV.ProductInfo.Variants.forEach(variantV => {
            variantV.Options.forEach(optionV => {
              if (optionV.ProductVariantOptionId == id) {
                name = optionV.Name
              }
            })
          })
          return name
        }).join(`${delimiter}`)
      }
      return joinName
    },
    clickSelectProduct (catV, optV, skuV = null) {
      let total = 0
      // 計算目前類別總數量
      catV.price_option.forEach(val => {
        total += parseInt(val.price_count)
      })
      const optionMaxLimit = optV.max_limit === 0 ? 100 : optV.max_limit
      if (((catV.max_limit != 0) && (total >= catV.max_limit)) || (optV.price_count >= optionMaxLimit)) { // 總數量超過最大限制數量 則數字不向上加
        this.$alert({
          title: '系統提示',
          message: '超過品項最大數量',
          btnText: '確認'
        })
        return
      }
      delete this.selectProductDialog.selectedOption
      delete this.selectProductDialog.selectedPrice
      this.$set(this.selectProductDialog, 'selectedOption', _.cloneDeep(catV))
      // 從購物清單更新細項
      if (this.shoppingCartDialog.open) {
        // >>> 有規格
        if (optV.ProductInfo?.VariantCount > 0 && skuV) {
          this.$set(this.selectProductDialog, 'selectedPrice', Object.assign({}, _.cloneDeep(optV), { price_count: skuV.num }))
          this.setSkuMemory(this.selectProductDialog.selectedPrice, skuV)
        } else { // >>> 無規格
          this.$set(this.selectProductDialog, 'selectedPrice', Object.assign({}, _.cloneDeep(optV), { price_count: optV.price_count })) // 品項的總數量
        }
      } else {
        this.$set(this.selectProductDialog, 'selectedPrice', Object.assign({}, _.cloneDeep(optV), { price_count: 1 }))
      }
      this.$set(this.promotion, 'selectingOptionByPromotionId', {})
      this.updateSelectProductPopupAssortionProductInfo()
      this.$nextTick(() => {
        this.changeCount(this.selectProductDialog.selectedPrice, true)
      })
      this.selectProductDialog.open = true
      this.FBConversionAPI('選購品項', {
        content_name: this.selectProductDialog.selectedPrice.price_name,
        content_type: 'product'
      })
      this.$gaLogEvent('品項選擇頁', `click_選購品項_${this.selectProductDialog.selectedPrice.price_name}_${this.service.service_title}_${this.serviceId}`)
      this.$gtm.push({
        event: 'selectProduct',
        serviceName: this.service.service_title,
        serviceId: this.serviceId,
        priceName: this.selectProductDialog.selectedPrice.price_name
      })
    },
    // 點擊有規格 -> 記憶功能，並暫存原選項
    setSkuMemory (optV, skuV) {
      // 取得規格細項
      const selectedSkuList = []
      skuV.VariantsAndOptions.forEach(item => {
        selectedSkuList.push(item.ProductVariantOptionId)
      })
      // 所選品項並將選擇的sku細項設為selected
      optV.ProductInfo.Variants.forEach(variantObj => {
        variantObj.Options.forEach(optionObj => {
          if (selectedSkuList.includes(optionObj.ProductVariantOptionId)) {
            optionObj.selected = true
          } else {
            optionObj.selected = false
          }
        })
      })
      // 同步skuV資料
      optV.ProductInfo.Skus.forEach(skuObj => {
        const variantOptionIds = skuObj.VariantsAndOptions.map(item => item.ProductVariantOptionId)
        if (skuObj.num > 0 && variantOptionIds.every(item => selectedSkuList.includes(item))) {
          skuObj.selected = true
        } else {
          skuObj.selected = false
        }
      })
      // 暫存原本的選項，才能再編輯的時候去做比對
      this.selectProductDialog.originalSelectedData = _.cloneDeep(skuV)
    },
    clickSelectVariant (variant, sku) {
      variant.Options.forEach((optionV) => {
        if (optionV.ProductVariantOptionId != sku.ProductVariantOptionId) {
          this.$set(optionV, 'selected', false)
        } else {
          this.$set(optionV, 'selected', true)
        }
      })
      const selectedProductVariantOptionIdArr = this.selectProductDialog.selectedPrice.ProductInfo.Variants
        .map(variantV => variantV.Options
          .filter(v => v.selected)
          .map(v => v.ProductVariantOptionId))
        .filter(variantV => variantV.length > 0)
        .flat()
      this.selectProductDialog.selectedPrice.ProductInfo.Skus.forEach((skuV) => { // 更新sku資料
        const isAll = skuV.VariantsAndOptions.every((optionV) => { // 此料號的所有規格都有被選
          return selectedProductVariantOptionIdArr.includes(optionV.ProductVariantOptionId)
        })
        if ((skuV.VariantsAndOptions.length === selectedProductVariantOptionIdArr.length) && isAll) {
          this.$set(skuV, 'selected', true)
        } else {
          this.$set(skuV, 'selected', false)
        }
      })
      this.updateSelectProductPopupAssortionProductInfo()
    },
    getSkuNote () {
      return this.isSkuSelected && this.selectProductDialog.selectedPrice.ProductInfo.Skus.find(sku => sku.selected).VariantsAndOptions[0].Note
    },
    clickShoppingCart () {
      this.$gaLogEvent('品項選擇頁', `click_購物清單_${this.service.service_title}_${this.serviceId}`)
      this.FBConversionAPI('點擊購物清單')
      this.shoppingCartDialog.open = true
    },
    updateSelectProductPopupAssortionProductInfo () {
      if (this.selectProductDialog && this.selectProductDialog.selectedPrice && this.selectProductDialog.selectedPrice.ProductInfo && this.selectProductDialog.selectedPrice.ProductInfo.VariantCount >= 1) {
        this.selectProductDialog.selectedPrice.ProductInfo.Variants = this.selectProductDialog.selectedPrice.ProductInfo.Variants.map((variantV, variantI) => {
          const returnVariant = variantV
          returnVariant.AssortionOptions = variantV.Options.filter((optionV) => { // 過濾完全沒有的規格
            return this.selectProductDialog.selectedPrice.ProductInfo.Skus.some((skuV) => {
              return skuV.VariantsAndOptions.some((variantsAndOptionsV) => {
                return (variantsAndOptionsV.ProductVariantOptionId == optionV.ProductVariantOptionId)
              })
            })
          }).filter((optionV, optionI) => {
            const skuList = this.selectProductDialog.selectedPrice.ProductInfo.Skus.filter((skuV, skuI) => {
              let canReturn = true
              const selectedOptionIdList = []
              this.selectProductDialog.selectedPrice.ProductInfo.Variants.forEach((variantVV, variantII) => { // 取出當前規格以外已被選擇的option id
                if (variantII != variantI) {
                  variantVV.Options.forEach((optionVV) => {
                    if (optionVV.selected) {
                      selectedOptionIdList.push(optionVV.ProductVariantOptionId)
                    }
                  })
                }
              })
              if (selectedOptionIdList.length > 0) {
                canReturn = skuV.VariantsAndOptions.some((v) => selectedOptionIdList.includes(v.ProductVariantOptionId))
              }
              return canReturn || (variantI == 0)
            })
            return skuList.some((skuV) => {
              return skuV.VariantsAndOptions.some((variantsAndOptionsV) => {
                return (variantsAndOptionsV.ProductVariantOptionId == optionV.ProductVariantOptionId)
              })
            })
          })
          return returnVariant
        })
        this.$set(this.selectProductDialog.selectedPrice, 'ProductInfo', this.selectProductDialog.selectedPrice.ProductInfo)
      }
    },
    confirmSelectProduct (isUpdate = false) { // isUpdate=是否從購物清單更新商品資訊
      let selectedSkuId = null
      this.optionPriceGroup.forEach((catV) => {
        if (catV.category_id == this.selectProductDialog.selectedOption.category_id) {
          catV.price_option = catV.price_option.map((optV) => {
            if (optV.price_id == this.selectProductDialog.selectedPrice.price_id) {
              if (this.selectProductDialog.selectedPrice.ProductInfo) { // 有商品資訊
                const selectedSku = this.selectProductDialog.selectedPrice.ProductInfo.VariantCount > 0
                  ? this.selectProductDialog.selectedPrice.ProductInfo.Skus.filter(v => v.selected)[0] // >>> 有規格
                  : this.selectProductDialog.selectedPrice.ProductInfo.Skus[0] // >>> 無規格
                selectedSkuId = selectedSku.SkuId
                optV.ProductInfo.Skus = optV.ProductInfo.Skus.map(skuV => {
                  if (isUpdate) { // 編輯購物車資料
                    // >>> 有規格
                    if (this.selectProductDialog.originalSelectedData && this.selectProductDialog.selectedPrice.ProductInfo.VariantCount > 0) {
                      const originalSkuId = this.selectProductDialog.originalSelectedData.SkuId
                      const currentSkuId = skuV.SkuId
                      // 規格變更，原數量歸零
                      if (selectedSkuId !== currentSkuId) {
                        if (currentSkuId === originalSkuId) {
                          skuV.num = 0
                        }
                      } else if (selectedSkuId === originalSkuId) { // 規格未變動，更新數量
                        skuV.num = this.selectProductDialog.selectedPrice.price_count
                      } else if (selectedSkuId === currentSkuId) { // 規格變動，原數量加上去
                        skuV.num = (skuV.num || 0) + this.selectProductDialog.selectedPrice.price_count
                      }
                    } else { // >>> 無規格
                      skuV.num = this.selectProductDialog.selectedPrice.price_count
                    }
                  } else {
                    // 非從購物車進入
                    if (selectedSku.SkuId == skuV.SkuId) {
                      skuV.num = (skuV.num || 0) + this.selectProductDialog.selectedPrice.price_count
                    }
                  }

                  return skuV
                })
                optV.price_count = optV.ProductInfo.Skus.reduce((a, b) => { return (a + (b.num || 0)) }, 0)
              } else { // 項目
                if (isUpdate) {
                  optV.price_count = this.selectProductDialog.selectedPrice.price_count
                } else {
                  optV.price_count += this.selectProductDialog.selectedPrice.price_count
                }
                selectedSkuId = this.selectProductDialog.selectedPrice.price_id
              }
              this.changeCount(optV)
            }
            return optV
          })
        }
      })
      this.selectProductDialog.open = false
      this.$gaLogEvent('品項選擇頁', `click_新增至購物清單_${this.service.service_title}_${this.serviceId}`)
      this.$gtm.push({
        event: 'addToCart',
        serviceName: this.service.service_title,
        serviceId: this.serviceId,
        priceName: this.selectProductDialog.selectedPrice.price_name
      })
      this.$infobipTrackEvent('addedToCart', {
        serviceName: this.service.service_title,
        serviceId: this.serviceId.toString(),
        itemName: this.selectProductDialog.selectedPrice.price_name,
        price: Number(this.selectProductDialog.selectedPrice.price)
      })
      const selectedProductTotalPrice = this.getSelectedProductTotalPrice().split(',').join('')
      this.FBConversionAPI('AddToCart', {
        contents: [
          {
            id: selectedSkuId,
            quantity: this.selectProductDialog.selectedPrice.price_count,
            item_price: selectedProductTotalPrice
          }
        ],
        content_name: this.selectProductDialog.selectedPrice.price_name,
        value: selectedProductTotalPrice,
        content_ids: [selectedSkuId],
        content_type: 'product'
      })
    },
    handleToggleMask () {
      this.isToggleMaskOpen = !this.isToggleMaskOpen
      const lastSection = this.$refs.promotionSection[this.$refs.promotionSection.length - 1]
      const lastSectionHeight = lastSection.clientHeight
      if (this.isToggleMaskOpen) {
        lastSection.style.height = lastSectionHeight + 30 + 'px'
      } else {
        lastSection.style.height = lastSectionHeight - 30 + 'px'
      }
    },
    async getPackageType () {
      if (!this.isTCatLogistic && !this.isKTJLogistic) return
      const apiPath = this.isTCatLogistic ? 'GetTCatItemCode' : 'GetKTJItemCode'
      const { data } = await this.$axios.post(`/api/v2/Order/${apiPath}`)
        .catch(error => {
          return Promise.reject(error)
        })
      this.packageTypeOptions = data.Data.filter(item => item.IsValid)
    },
    async removeItemFromCart (price, sku) {
      const removeItem = () => {
        price.price_count = 0
        this.changeCount(price)
      }
      const removeWithSku = () => {
        sku.num = 0
        this.changeCount(price)
        this.updateSkuPriceCount(price)
      }
      this.$alert({
        title: '系統提示',
        message: '確定要移除當前品項嗎？',
        persistent: true,
        btn: [
          {
            btnText: '取消',
            btnClick: () => {
              this.$alert.close()
            }
          },
          {
            btnText: '確定',
            btnColor: 'primary',
            btnClick: async () => {
              if (price.ProductInfo) {
                removeWithSku()
              } else {
                removeItem()
              }
              this.$alert.close()
            }
          }
        ]
      })
    },
    setSelectedCard (card) {
      this.creditCardSelectorDialog.selectedCard = card
      this.payment.checkValidate = null
    },
    setCardList (cardList) {
      this.creditCardSelectorDialog.cardList = cardList
    },
    submitCreditCardSelectorDialog (card) {
      this.creditCardSelectorDialog.open = false
      this.setSelectedCard(card)
    },
    async matchOrderSendJob (order) {
      try {
        const reservationHourMapping = {
          1: [9, 13], // 早上 9:00-13:00
          2: [13, 18], // 下午 13:00-18:00
          4: [18, 22], // 晚上 18:00-22:00
          7: [9, 22] // 皆可 9:00-22:00
        }
        const requestData = {
          OrderId: order.order_id,
          SendJobInSpecifyRange: false,
          SupplierId: order.supplier_id
        }
        if (this.service.serviceTimeType.id === 10) {
          requestData.SpecifyTime = []
          const getSpecifyTime = (status) => {
            requestData.SpecifyTime.push({
              IsWeekend: status,
              StartHour: reservationHourMapping[order.reservation][0],
              EndHour: reservationHourMapping[order.reservation][1]
            })
          }
          if (this.selectedData.datetime.weekdayReservation === 1) {
            getSpecifyTime(false)
          } else if (this.selectedData.datetime.weekdayReservation === 2) {
            getSpecifyTime(true)
          } else if (order.reservation !== 7) {
            getSpecifyTime(false)
            getSpecifyTime(true)
          } else { // 平假日與時段皆可
            requestData.SpecifyTime = null
          }
        } else {
          requestData.SpecifyDate = []
          const date = this.$dayjs(order.reservation_datetime).format('YYYY/MM/DD')
          switch (this.service.serviceTimeType.id) {
            case 1:
              requestData.SpecifyDate.push({
                Date: date,
                StartTime: `${date} ${reservationHourMapping[order.reservation][0].toString()}:00`,
                EndTime: `${date} ${reservationHourMapping[order.reservation][1].toString()}:00`
              })
              break
            case 2:
              requestData.SpecifyDate.push({
                Date: date,
                StartTime: `${date} 00:00`,
                EndTime: `${date} 23:30`
              })
              break
            case 3:
            case 5:
            case 7:
              requestData.SpecifyDate.push({
                Date: date,
                StartTime: `${date} ${this.$dayjs(order.order_reservation.start_time).format('HH:mm')}`,
                EndTime: `${date} 23:30` // 無結束時間，自動帶 23:30
              })
              break
            case 4:
            case 6:
            case 8:
              requestData.SpecifyDate.push({
                Date: date,
                StartTime: `${date} ${this.$dayjs(order.order_reservation.start_time).format('HH:mm')}`,
                EndTime: `${date} ${this.$dayjs(order.order_reservation.due_time).format('HH:mm')}`
              })
              break
            default:
              break
          }
        }
        await this.$axios.post('/api/v2/OrderSendJob/OrderSendJobMatch', requestData)
      } catch (error) {
        console.log('自動媒合失敗', error)
        return Promise.reject(error)
      }
    },
    handleScroll (e) {
      if (!this.isReviewDeep) {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        const offsetHeight = document.documentElement.clientHeight || document.body.clientHeight
        const scrollRatio = Math.round(scrollTop / (scrollHeight - offsetHeight) * 100)
        this.isReviewDeep = scrollRatio > 50
      }
    },
    changeAlertDialog (value) {
      switch (value) {
        case 2:
          if (this.firebaseMatchResult.matchType === 1) {
            this.alertDialog.title = '已找到您專屬的服務人員！'
            this.alertDialog.message = ''
            this.alertDialog.btnText = '選擇服務人員'
            this.alertDialog.image = 'success-quokka-1'
          } else if (this.firebaseMatchResult.matchType === 2) {
            this.alertDialog.title = '服務人員有點忙碌，不過我們幫您找到了其他可服務時間！'
            this.alertDialog.message = ''
            this.alertDialog.btnText = '查看詳情'
            this.alertDialog.image = 'success-quokka-2'
          }
          break
        case 6:
          this.alertDialog.title = '很抱歉，目前暫無適合的人員'
          this.alertDialog.message = `我們將於 ${this.serviceResponseDays} 個工作天內與您電話聯繫`
          this.alertDialog.btnText = '查看訂單'
          this.alertDialog.image = 'fail-quokka'
          break
        case 7:
          this.alertDialog.title = '系統忙碌中，搜尋已暫停'
          this.alertDialog.message = `我們將於 ${this.serviceResponseDays} 個工作天內與您電話聯繫`
          this.alertDialog.btnText = '查看訂單'
          this.alertDialog.image = 'fail-quokka'
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$inputHeight: 40px;

#service-item {
  > :not(.login-register) {
    ::v-deep {
      .v-text-field.v-input,
      div[class*=" v-text-field-"],
      div[class^="v-text-field-"] {
        .v-input__slot {
          min-height: $inputHeight;
          .v-label {
            top: 0;
            height: $inputHeight;
            line-height: $inputHeight;
          }
        }
      }
      .v-select__selections {
        padding: 0;
        .v-select__selection--comma {
          margin: 0;
        }
      }
      .v-input__append-inner {
        margin: 0;
        .v-input__icon {
          height: $inputHeight;
        }
        .v-btn {
          $verticalPaddiing: 5px;
          height: calc(#{$inputHeight} - #{$verticalPaddiing} * 2);
          margin-top: $verticalPaddiing;
        }
      }
    }
  }
}

.title {
  padding-bottom: 12px;
  font-size: pxTorem(17px);
  line-height: pxTorem(24px);
  font-weight: bold;
  text-align: center;
  border-bottom: 3px solid $mainColor;
}
/** 優惠活動 */
.page.page-promotion {
  $borderRadius: 2px;
  padding-top: 24px;
  + .page.page-promotion {
    margin-top: 50px;
    border-top: 3px solid $mainColor;
  }
  .promotion-list {
    padding: 20px 12px 23px 0;
    font-size: 0;
    border-top: 1px solid #D2D2D2;
    .promotion-option {
      display: inline-flex;
      background-color: $grayColor;
      border-radius: $borderRadius;
      p {
        margin-bottom: 0;
      }
      .tag {
        display: flex;
        flex: none;
        justify-content: center;
        align-items: center;
        color: #fff;
        background-color: $mainColor;
        border-radius: $borderRadius;
        span {
          font-weight: bold;
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
      }
      .price {
        flex: 1;
        display: inline-block;
        padding: 3px 8px 3px 6px;
        font-weight: bold;
        color: #0066E8;
      }
    }
  }
  .promotion-description {
    &-title {
      margin-bottom: 16px;
      font-weight: bold;
      font-size: pxTorem(17px);
      line-height: pxTorem(24px);
    }
    p {
      font-size: pxTorem(15px);
      line-height: pxTorem(21px);
    }
    &-content {
      margin-bottom: 8px;
    }
    &-time {
      font-weight: bold;
      margin-bottom: 20px;
    }
    &-note {
      font-size: pxTorem(13px);
      line-height: pxTorem(18px);
    }
  }
}
.toggle-mask {
  position: relative;
  height: 180px;
  margin-bottom: 24px;
  overflow: hidden;
  &::after {
    content: '';
    display: block;
    height: 60px;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
    opacity: 1;
    background-image: linear-gradient(180deg, transparent 0, #fff 90%);
    transition: opacity .1s ease-in-out;
  }
  &.open {
    height: auto;
    &::after {
      opacity: 0;
      transition: opacity .1s ease-in-out;
    }
  }
  .toggle-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
    font-size: pxTorem(15px);
    font-weight: bold;
    z-index: 2;
    color: $mainColor;
    &:hover {
      cursor: pointer;
    }
    i {
      margin-left: 12px;
      font-size: pxTorem(16px);
      font-weight: bold;
      transform: rotate(0);
      transition: transform .1s ease-in-out;
      &.rotate {
        transform: rotate(180deg);
        transition: transform .1s ease-in-out;
      }
    }
  }
}
/** 訂購說明 */
.page.page-limit {
  padding: 15px 0 24px;
  .rule-wrap {
    .rule {
      padding: 6px 0 6px 12px;
      display: flex;
      align-items: center;
      background-color: #fff3e8;
      font-size: pxTorem(15px);
      img {
        margin-right: 6px;
      }
      span {
        font-weight: bold;
      }
    }
  }
}

.required {
  &:after {
    content: '*';
    color: $errorColor;
    vertical-align: text-top;
    margin-left: 2px;
  }
}
.option {
  padding-bottom: 0px;
  padding-top: 25px;
  &:last-of-type {
    padding-bottom: 40px;
  }
  &.code-discount {
    .v-form {
      display: flex;
      align-items: baseline;
      gap: 0 10px;
    }
    .discount-list {
      margin-top: 14px;
    }
  }
  .subtitle.label, .section-item-title {
    display: flex;
    margin-bottom: 16px;
    color: $mainColor;
    font-weight: bold;
    font-size: pxTorem(19px);
    line-height: pxTorem(19px);
    &.has-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .btn {
      margin: 0;
    }
    > span {
      display: flex;
      align-items: center;
      .error-message {
        flex: none;
      }
    }
  }
  .text.desc, .section-item-desc {
    display: block;
    color: #999999;
    font-weight: 400;
    font-size: pxTorem(16px);
    line-height: pxTorem(18px);
    margin-bottom: 10px;
    &.login-tips {
      color: $fontColor;
      margin-bottom: 16px;
    }
  }
  .item {
    $imageSize: 150px;
    &:first-of-type {
      padding-top: 0px;
    }
    &:not(:last-child):not(.item-half-start:nth-last-child(2)) {
      margin-bottom: 20px;
      &.title {
        margin-bottom: 5px;
      }
      &.removeMarginBottom{
        margin-bottom: 0px;
      }
    }
    &.bonus {
      display: block !important;
      .basic {
        display: flex;
        justify-content: space-between;
      }
      .enterprise-bonus {
        display: flex;
        justify-content: flex-end;
        color: #fd2d55;
        font-weight: normal;
      }
    }

    .has-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }
    .content {
      display: flex;
      // padding-bottom: 15px;
      padding-right: 8px;
      // padding-bottom: 5px;
      padding-left: 10px;
      width: 100%;
      &.has-image {
        align-items: flex-start;
        section {
          p.desc {
            margin-top: 10px;
            &.summary {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow-wrap: break-word;
              word-break: break-all;
              overflow: hidden;
            }
          }
        }
      }
      .image-carousel {
        position: relative;
        flex: none;
        margin-right: 18px;
        width: $imageSize;
        .carousel {
          background-color: #eee;
          img {
            width: 100%;
          }
        }
        ::v-deep {
          .tns-nav {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            text-align: center;
            padding: 5px;
            button {
              $size: 10px;
              height: $size;
              width: $size;
              border-radius: 50%;
              background-color: rgba(#000, .2);
              + button {
                margin-left: 5px;
              }
              &.tns-nav-active {
                background-color: rgba(#000, .4);
              }
            }
          }
        }
      }
      section {
        flex: 1;
        word-break: break-all;
        overflow-wrap: anywhere;
        h6, .font-h6, .label {
          display: block;
          font-weight: bold;
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
        p.desc {
          margin-top: 5px;
          font-weight: 400;
          font-size: pxTorem(15px);
          line-height: pxTorem(20px);
          margin-bottom: 0;
        }
        span.promotion {
          display: inline-block;
          padding: 2px 4px;
          margin-top: 8px;
          margin-bottom: 16px;
          font-size: pxTorem(13px);
          line-height: pxTorem(18px);
          color: #fff;
          background-color: #FF8900;
          border-radius: 2px;
        }
        .price {
          @include price;
          flex: 1;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          align-items: baseline;
          color: $priceColor;
          line-height: pxTorem(31px);
          font-size: pxTorem(28px);
          text-align: right;
          font-variant-numeric: tabular-nums;
          word-break: break-word;
          span {
            display: inline-block;
            & + .price-origin{
              margin-left: 12px;
            }
          }
          span.price-origin {
            color: $fontColor;
            font-weight: 400;
            font-family: initial;
            line-height: pxTorem(25px);
            font-size: pxTorem(18px);
            text-decoration: line-through;
          }
        }
        .selected-num{
          color: $mainColor;
          font-size: pxTorem(15px);
          font-weight: 600;
        }
      }
    }
    footer {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      .price-controls {
        flex: none;
        width: $imageSize;
      }
    }
  }
  .error-message {
    color: $errorColor;
    font-weight: 400;
    margin-bottom: 0;
    font-size: pxTorem(15px);
    line-height: pxTorem(15px);
    display: flex;
    align-items: center;
    margin-left: 10px;
    &.center {
      text-align: center;
    }
    i {
      margin-right: 2px;
    }
  }
  &.is-error {
    .subtitle.label, .section-item-title {
      color: $errorColor;
    }
  }
}
.option.price {
  .item {
    .content {
      padding-left: 0;
      padding-bottom: 5px;
    }
  }
}
.select-group {
  display: flex;
  flex-wrap: wrap;
  .select {
    flex: 1;
    width: 50%;
    &:first-of-type {
      margin-right: 7px;
    }
  }
  .input {
    width: 100%;
    flex: none;
  }
}
.option.region {
  .item-wrapper {
    display: flex;
    align-items: flex-start;
  }
  .select-group {
    .select {
      margin-bottom: 10px;
    }
    .input {
      width: 100%;
      flex: none;
      border-color: #D2D2D2;
    }
    .input-group {
      display: flex;
      width: 100%;
      flex: none;
      .input {
        flex: 1;
        width: 50%;
        &:first-of-type {
          margin-right: 7px;
        }
      }
    }
  }
}
.option.datetime {
  .default-time-mode {
    width: 100%;
    display: flex;
    margin-top: 20px;
    ::v-deep {
      .v-btn--active {
        background-color: $mainColor;
        color: #fff;
      }
    }
    .time-mode-btn {
      flex: 1;
    }
  }
  .time-select {
    display: flex;
    margin-top: 20px;
    align-items: center;
    flex-wrap: wrap;
    &.time-end {
      margin-top: 10px;
    }
    .select {
      flex: 1;
    }
    span {
      flex: none;
      padding: 0 15px;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
      &:last-of-type {
        padding-right: 0;
      }
    }
    p {
      flex: none;
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }
  }
  .time-note {
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: pxTorem(15px);
    line-height: pxTorem(22px);
    color: #999999;
    font-weight: 400;
    p {
      margin-bottom: pxTorem(10px);
    }
  }
  ::v-deep {
    .v-select__selection--comma {
      color: initial;
    }
  }
}
.option.radio {
  .group-radio {
    margin-top: 0;
  }
  .item {
    padding-top: 0;
  }
}
.option.checkbox {
  padding-bottom: 20px;
  .item {
    padding-top: 0;
  }
}
.page.page-3 {
  $paddingInline: 8px;
  .subtitle, .text {
    margin-right: -$paddingInline;
  }
  .option {
    padding-inline: $paddingInline;
  }
  .subtitle {
    > span {
      font-size: inherit;
    }
  }
  .option.has-item-half {
    font-size: 0;
    p.notice {
      text-align: left;
      margin-bottom: 25px;
      font-size: pxTorem(15px);
      line-height: pxTorem(20px);
      color: $errorColor;
    }
    p.checkbox-notice {
      margin: 5px 0 0 32px;
    }
  }
  .option.recipient {
    .recipient-title {
      flex: none;
      width: 100%;
      margin-bottom: 10px;
      text-align: left;
      font-size: pxTorem(16px);
      line-height: pxTorem(24px);
      font-weight: bold;
    }
    .input {
      + .input {
        margin-top: 10px;
      }
      + .select-group {
        margin-top: 10px;
      }
    }
    .select-group {
      .select {
        margin-top: 0;
      }
      .input {
        ::v-deep {
          .v-label {
            font-size: pxTorem(16px);
            line-height: pxTorem(22px);
          }
        }
      }
    }
    p.notice {
      text-align: left;

      margin-bottom: 25px;
      font-size: pxTorem(15px);
      line-height: pxTorem(20px);
      color: $errorColor;
      &.addressNotice {
        padding: 5px;
        color: #484848;
      }
    }
    .error-message {
      text-align: left;
    }
  }
  .item {
    $halfItemPadding: 7px;
    &.item-half {
      width: calc(50% - #{$halfItemPadding} / 2);
      display: inline-block;
      padding: 0;
      vertical-align: bottom;
    }
    &.item-half-end {
      margin-left: $halfItemPadding;
    }
    p {
      margin-bottom: 0;
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
    }
    p.label {
      margin-bottom: 8px;
      font-weight: bold;
      font-size: pxTorem(17px);
      line-height: pxTorem(18px);
      &.mb-0 {
        margin-bottom: 0;
      }
    }
  }
}
.option.region-community {
  .item {
    margin-top: 10px;
    p {
      margin-bottom: 0;
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
    }
    p.label {
      margin-bottom: 9px;
      font-weight: bold;
    }
    ::v-deep {
      .v-input__append-inner {
        margin-top: 0;
        align-self: center;
      }
    }
  }
  ::v-deep {
    .checkbox.v-input--hide-details > .v-input__control > .v-input__slot {
      align-items: start;
    }
  }
  ::v-deep {
    .v-select {
      margin-bottom: 10px;
    }
  }
  p.notice {
    text-align: left;
    margin-bottom: 25px;
    font-size: pxTorem(15px);
    line-height: pxTorem(20px);
    color: $errorColor;
  }
  p.checkbox-notice {
    margin: 5px 0 0 32px;
  }
}
.option.item-detail {
  .item {
    padding-top: 15px;
    padding-bottom: 0;
    margin-bottom: 0;
    p {
      margin-bottom: 0;
    }
    .label {
      margin-bottom: 10px;
      font-weight: bold;
      font-size: pxTorem(16px);
      line-height: pxTorem(24px);
    }
    .subLabel{
      color: $midGrayColor;
    }
    .content {
      padding: 0;
    }
  }
  .item.title {
    padding-top: 5px;
    border-bottom: 2px dashed #d2d2d2;
    text-align: left;
  }
  .item.price {
    &.discountBlock{
      padding-top: 0px;
    }
    p.label {
      display: flex;
      justify-content: space-between;
      span.price {
        @include price;
        font-size: pxTorem(17px);
        line-height: pxTorem(19px);
      }
    }
    .content {
      display: block;
      p, .info-wrap {
        display: flex;
        justify-content: space-between;
        &__bonus {
          display: flex;
          flex-direction: column;
          &__enterprise {
            color: #999999;
          }
        }
        + p {
          margin-top: 7px;
        }
        span {
          font-size: pxTorem(16px);
          line-height: pxTorem(26px);
          font-weight: 400;
          &.price {
            font-weight: bold;
            flex: none;
          }
        }
      }
    }
  }
  .item.total-price {
    padding-top: 17px;
    border-top: 2px dashed #d2d2d2;
    // margin-top: 15px;
    p {
      margin-bottom: 0;
    }
  }
  .item.send-day {
    // padding-top: 10px;
    .content {
      p {
        span {
          font-weight: bold;
        }
      }
    }
  }
  .removePaddingTop {
    padding-top: 0;
    &:not(:first-of-type) {
      margin-top: -15px;
    }
  }
}
.option.order-option {
  .subtitle.label, .section-item-title {
    margin-bottom: 17px;
  }
  .item {
    padding-top: 0;
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    p {
      margin-bottom: 5px;
      font-weight: 400;
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
    }
    p.label {
      font-weight: bold;
    }
  }
}
.option.payment {
  .label.is-error {
    color: $errorColor;
  }
  ::v-deep {
    .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
    .v-radio {
      padding: 10px 0;
      border-bottom: 2px dashed $lineColor;
      &:last-of-type {
        border-bottom: 0;
      }
      .label {
        flex-wrap: wrap;
        .btn {
          font-size: pxTorem(16px);
          font-weight: normal;
          color: $fontColor;
          letter-spacing: normal;
          padding: 0;
          height: auto;
          max-width: 100%;
          padding-right: 4px;
          .v-btn__content {
            opacity: 1;
            width: 100%;
            >div {
              display: flex;
              align-items: center;
            }
          }
          p {
            display: inline-block;
            max-width: 100%;
            word-break: break-all;
            white-space: initial;
            text-align: left;
            color: $fontColor;
            .number {
              color: $midGrayColor;
            }
          }
        }
        i {
          font-size: 24px;
          color: $midGrayColor;
        }
      }
    }
  }
}
.option.receipt {
  .select {
    margin-bottom: 10px;
  }
  .item {
    margin-bottom: 10px;
    padding-top: 0;
    p.label {
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
      font-weight: bold;
    }
  }
  .item.address {
    p.label {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      .checkbox {
        margin-top: 0;
        font-weight: normal;
      }
    }
  }
  p.desc {
    color: #999999;
    font-size: pxTorem(15px);
    line-height: pxTorem(22px);
    margin-bottom: 0;
    span {
      color: $mainColor;
    }
  }
}
.option.other {
  .text.desc {
    margin-inline: 0;
  }
  .photo-list {
    $size: 80px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 14px;
    .photo {
      position: relative;
      height: $size;
      width: $size;
      margin-bottom: 13px;
      background-size: cover;
      background-position: center;
      border: 1px dashed #999999;
      margin-left: 7px;
      margin-right: 7px;
      cursor: pointer;
      &:first-of-type {
        margin-left: 0;
      }
      &.add {
        border: 2px dashed #999999;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
          color: #707070;
          font-size: pxTorem(28px);
        }
      }
      &.is-error {
        border-color: $errorColor;
        span {
          color: $errorColor;
        }
      }
      i.remove {
        $removeSize: 25px;
        position: absolute;
        right: 0;
        top: 0;
        width: $removeSize;
        height: $removeSize;
        line-height: $removeSize;
        text-align: center;
        font-size: $removeSize * .5;
        color: #fff;
        background-color: rgba(#000, .4);
        transition: background-color .3s;
        cursor: pointer;
        &:hover {
          background-color: rgba(#000, .6);
        }
      }
      .load-circle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .hidden {
    display: none;
    opacity: 0;
    visibility: hidden;
  }
}
.option.channel-type {
  .input {
    margin-top: 10px;
  }
}
.option.discount {
  text-align: center;
  .item {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-weight: bold;
    p {
      margin-bottom: 5px;
    }
    .price {
      position: relative;
      .notice {
        position: absolute;
        top: calc(100%);
        right: 0;
        color: $errorColor;
        font-size: pxTorem(15px);
        font-weight: normal;
        white-space: nowrap;
      }
    }
  }
  .btn-rounded {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 14px;
    height: auto;
    padding: 6px 23px;
    ::v-deep {
      span {
        font-size: pxTorem(15px);
        line-height: pxTorem(20px);
      }
    }
  }
}
.option-subtotal{
  width: 100%;
  padding: 0 10px;
  margin: 10px 0;
  border-top: 1px solid #999;
  .price{
    color: $priceColor;
    font-weight: 600;
    font-family: Helvetica;
  }
  .price-subtotal{
    font-size: pxTorem(16px);
    padding: 10px 3px;
    div{
      display: flex;
      justify-content: space-between;
      padding: 3px 0
    }
    .subtotal-title{
      font-size: pxTorem(18px);
      font-weight: 600;
    }
    .price-origin{
      font-family: Helvetica;
      font-weight: 600;
    }
  }
  .price-total{
    display: flex;
    justify-content: space-between;
    font-size: pxTorem(25px);
    font-weight: 600;
    padding: 10px 3px;
    .total-title{
      font-size: pxTorem(20px);
    }
  }
}
.option.total {
  padding-bottom: 0;
  text-align: center;
  border-top: 1px solid #999999;
  .price-total {
    vertical-align: middle;
    img.price-tag {
      $imgSize: 40px;
      height: $imgSize;
      width: $imgSize;
      padding: 10px;
      margin-right: 15px;
      background-color: $mainColor;
      border-radius: 50%;
      vertical-align: middle;
    }
    > span {
      color: #484848;
      vertical-align: middle;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
    }
    .price {
      @include price;
      margin-left: 12px;
      vertical-align: baseline;
    }
  }
  .check-term {
    padding: 0 20px;
    margin-bottom: 5px;
    ::v-deep {
      .v-label {
        font-size: pxTorem(18px);
        line-height: pxTorem(22px);
        color: $mainColor;
        text-decoration: underline;
      }
    }
  }
  .btn-group {
    display: flex;
    padding: 0 20px;
    .btn {
      flex: 1;
      margin-top: 10px;
      padding: 10px 20px;
      margin-bottom: 40px;
      height: auto;
      + .btn {
        margin-left: 30px;
      }
    }
  }
  .term {
    margin-bottom: 0;
    font-size: pxTorem(16px);
    line-height: pxTorem(22px);
    vertical-align: middle;
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .btn-term {
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      font-weight: bold;
      height: auto;
      min-width: auto;
      padding: 0;
      ::v-deep {
        span {
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
      }
    }
  }
}
.dialog {
  position: fixed;
  left: 50%;
  top: 50%;
  height: 0;
  width: 0;
  transform: translate(-50%, -50%);
  overflow: hidden;
  z-index: 200;
  transition: height .3s, width .3s;
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100%;
    width: 100%;
    transform: translate(-50%, -50%);
    background-color: #707070;
    opacity: 0.6;
    z-index: 0;
  }
  &.is-open {
    height: 100vh;
    width: 100vw;
  }
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 530px;
    padding: 30px 15px 40px;
    background-color: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.3);
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
#dialog-terms {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: var(--safe-area-inset-top);
  padding-right: var(--safe-area-inset-right);
  padding-bottom: calc(10px + var(--safe-area-inset-bottom));
  padding-left: var(--safe-area-inset-left);
  .dialog-header {
    position: relative;
    color: $mainColor;
    justify-content: center;
    flex: none;
    padding-top: calc(15px + var(--safe-area-inset-top));
    .close {
      position: absolute;
      padding: 10px;
      right: 5px;
      right: calc(5px + var(--safe-area-inset-right));
      top: 5px;
      top: calc(5px + var(--safe-area-inset-top));
      color: $fontColor;
      cursor: pointer;
      display: inline-block;
      z-index: 100;
    }
  }
  .dialog-content {
    flex: 1;
    height: 100%;
    padding: 20px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 20px * 2);
    width: calc(100% - 20px * 2 - var(--safe-area-inset-left) - var(--safe-area-inset-right));
    overflow-y: auto;
    border: 1px solid #d2d2d2;
  }
  .dialog-footer {
    flex: none;
    padding-bottom: calc(10px + var(--safe-area-inset-bottom));
    .btn {
      height: auto;
      padding: 10px 75px;
      ::v-deep {
        span {
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
  }
}
#service-item .btn-select-address, .btn-login {
  height: auto;
  padding: 6px 23px;
  ::v-deep {
    span {
      font-size: pxTorem(15px);
      line-height: pxTorem(20px);
    }
  }
}
$btnHeight: 70px;
.dialog-region-select {
  flex-direction: column;
  i.close {
    $size: 20px;
    line-height: $size;
    font-size: $size * .8;
    background-color: #fff;
    border-radius: 50%;
    color: #888;
    z-index: 1;
    cursor: pointer;
  }
  .dialog-title {
    text-align: center;
    justify-content: center;
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
    padding-top: calc(15px + var(--safe-area-inset-top));
  }
  .dialog-subtitle {
    color: #999999;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    font-size: pxTorem(16px);
    line-height: pxTorem(20px);
  }
  .dialog-content {
    border-top: 2px solid $mainColor;
    width: calc(100% - 30px * 2);
    width: calc(100% - 20px * 2 - var(--safe-area-inset-left) - var(--safe-area-inset-right));
    margin-left: auto;
    margin-right: auto;
  }
  .dialog-actions {
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
    .btn {
      padding: 10px 75px;
      height: auto;
      ::v-deep {
        span {
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
  }
}
.dialog-card {
  i.close {
    $size: 20px;
    flex: none;
    position: absolute;
    right: 20px;
    right: calc(20px + var(--safe-area-inset-right));
    top: 25px;
    top: calc(20px + var(--safe-area-inset-top));
    height: $size;
    line-height: $size;
    width: $size;
    font-size: $size * .8;
    text-align: center;
    background-color: #fff;
    border-radius: 50%;
    color: #888;
    z-index: 1;
    cursor: pointer;
  }
  .dialog-header {
    padding-top: 32px;
    padding-bottom: 16px;
    text-align: center;
    justify-content: center;
    font-size: pxTorem(17px);
    line-height: pxTorem(24px);
  }
  .dialog-content {
    margin-left: auto;
    margin-right: auto;
  }
  .dialog-footer {
  }
}
#dialog-region-select {
  .dialog-content {
    position: relative;
    text-align: center;
    padding-top: $btnHeight;
    padding-bottom: 0;
    .btn-select-address {
      position: absolute;
      left: 50%;
      top: $btnHeight / 2;
      transform: translate(-50%, -50%);
      min-width: auto;
      padding: 6px 23px;
    }
    .radio-group {
      margin-top: 0;
    }
  }
  .radio {
    padding: 10px;
    border: 1px solid #D2D2D2;
  }
  .item {
    display: table;
    p {
      display: table-row;
    }
    span {
      display: table-cell;
      padding-bottom: 5px;
    }
    span.label {
      font-weight: bold;
      padding-right: 20px;
    }
  }
}
#dialog-region-select {
  i.close {
    position: absolute;
    right: 20px;
    right: calc(20px + var(--safe-area-inset-right));
    top: 30px;
    top: calc(30px + var(--safe-area-inset-top));
    padding: 10px;
    font-size: pxTorem(20px);
    transform: translateY(-50%);
  }
}
.dialog-discount {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  .dialog-header {
    flex: none;
  }
  .dialog-content {
    > .item {
      display: flex;
      align-items: flex-start;
      padding: 25px 5px 0;
      img {
        flex: none;
        width: 27px;
        height: auto;
        margin-right: 10px;
      }
      .content {
        flex: 1;
        > p.label {
          font-weight: bold;
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
          margin-bottom: 8px;
          span.desc {
            color: #999999;
            font-size: pxTorem(13px);
            line-height: pxTorem(18px);
          }
          span.tag {
            padding: 2px 12px;
            margin-left: 8px;
            color: #ffffff;
            background-color: $mainColor;
            border-radius: 2px;
            font-size: pxTorem(13px);
            line-height: pxTorem(18px);
            &.disabled {
              color: $fontColor;
              color: rgba(0,0,0,.26);
              background-color: rgba(0,0,0,.12);
            }
          }
        }
        .hidden {
          opacity: 0;
        }
        p {
          margin-bottom: 0;
        }
        .checkbox {
          margin-top: 0;
          padding-top: 0;
          ::v-deep {
            .v-input__slot {
              align-items: center;
            }
          }
          p.label {
            margin-bottom: 0;
            color: #999999;
            font-size: pxTorem(14px);
            line-height: pxTorem(20px);
            span {
              @include price;
              margin-left: 5px;
              font-size: pxTorem(17px);
              line-height: pxTorem(24px);
            }
          }
        }
        .price {
          @include price;
          margin-left: 5px;
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
        .enterprise-bonus-dialog {
          color: #388cbb;
          margin-left: 31px;
        }
      }
    }
    .ticket-list {
      position: relative;
      margin-top: 0;
      min-height: 60px;
      .loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
      }
      .radio-group {
        &.radio-loading {
          opacity: .4;
          transition: opacity .3s;
        }
      }
      .radio-item {
        border: 1px solid #d2d2d2;
        border-radius: 4px;
        ::v-deep {
          .v-input--selection-controls__input {
            width: 60px;
            margin-right: 0;
          }
          .v-input--selection-controls__ripple {
            left: 50%;
            transform: translateX(-50%);
            margin-left: 0;
            margin-right: 0;
          }
        }
      }
      .content {
        position: relative;
        padding: 12px;
        min-height: 115px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &::before {
          content: '';
          position: absolute;
          display: block;
          top: 50%;
          left: 0;
          height: 80%;
          width: 0;
          transform: translateY(-50%);
          border-left: 3px dotted #d2d2d2;
        }
        p {
          margin-bottom: 0;
        }
        .name {
          font-weight: bold;
          font-size: pxTorem(16px);
          line-height: pxTorem(22px);
        }
        .date {
          font-weight: 400;
          color: #999999;
          font-size: pxTorem(13px);
          line-height: pxTorem(18px);
        }
      }
    }
  }
  .dialog-footer {
    padding: 20px;
    flex: none;
    display: flex;
    justify-content: space-around;
    .btn {
      padding: 10px 20px;
      border-radius: 4px;
      height: auto;
    }
  }
}
// 新增常用地址
#dialog-region-create {
  i.close {
    top: 15px;
    top: calc(15px + var(--safe-area-inset-top));
  }
  .content {
    padding: 30px 5px;
    .item {
      & + .item {
        margin-top: 17px;
      }
      p.label {
        margin-bottom: 8px;
      }
    }
    .item.region {
      .item-content {
        display: flex;
        flex-wrap: wrap;
      }
      .select {
        flex: 1;
        width: 50%;
        & + .select {
          margin-left: 10px;
        }
      }
      .input {
        flex: none;
        width: 100%;
        margin-top: 10px;
      }
    }
    ::v-deep {
      .v-input__slot {
        border-color: #D2D2D2;
      }
    }
  }
}
#dialog-far {
  .dialog-content {

  }
  h4 {
    font-weight: bold;
    font-size: pxTorem(16px);
    line-height: pxTorem(22px);
    margin-bottom: 10px;
    padding-top: 10px;
    color: $mainColor;
    &:first-of-type {
      padding-top: 20px;
    }
  }
  .item {
    // padding-left: 20px;
    + .item:not(.user-info) {
      margin-top: 5px;
      padding-top: 5px;
      border-top: 2px dashed #d2d2d2;
    }
    &.user-info {
      display: flex;
      h4 {
        margin-bottom: 10px;
      }
      p.label {
        width: 60px;
      }
    }
    &.price {
    }
    &.total-price {
      p {
        span.price {
          // font-weight: bold;
        }
      }
      .total-price {
        @include price;
        color: $priceColor;
        font-size: pxTorem(18px);
        line-height: pxTorem(22px);
      }
    }
    .content {
      p {
        display: flex;
        justify-content: space-between;
      }
    }
    p {
      margin-bottom: 5px;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
    }
    p.label {
      flex: none;
      width: 100%;
      font-weight: bold;
    }
    span.price {
      white-space: nowrap;
      margin-left: 15px;
    }
    span.label {
      font-weight: bold;
    }
  }
  .dialog-footer {
    padding-top: 20px;
    padding-bottom: 30px;
    padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
    .btn {
      padding: 10px 75px;
      height: auto;
    }
  }
}
#dialog-selecet-product {
  .product-info-wrap{
    flex: 1;
    word-break: break-all;
    overflow-wrap: anywhere;
    border-bottom: none;
    padding: 10px 0;
    .name {
      display: block;
      font-weight: bold;
      font-size: pxTorem(22px);
      font-family: Helvetica;
      line-height: pxTorem(22px);
      padding: 10px 0 15px;
    }
    p.desc {
      margin-top: 5px;
      font-weight: 400;
      font-size: pxTorem(15px);
      line-height: pxTorem(20px);
      margin-bottom: 0;
    }
    span.promotion {
      display: inline-block;
      padding: 2px 4px;
      margin-top: 8px;
      margin-bottom: 16px;
      font-size: pxTorem(13px);
      line-height: pxTorem(18px);
      color: #fff;
      background-color: #FF8900;
      border-radius: 2px;
    }
    .price {
      @include price;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: baseline;
      color: $priceColor;
      line-height: pxTorem(31px);
      font-size: pxTorem(28px);
      text-align: right;
      font-variant-numeric: tabular-nums;
      span {
        display: inline-block;
      }
      span.price-origin {
        color: $fontColor;
        font-weight: 400;
        font-family: initial;
        line-height: pxTorem(25px);
        font-size: pxTorem(18px);
        text-decoration: line-through;
        margin-left: 12px;
      }
    }
    .selected-num{
      color: $mainColor;
      font-size: pxTorem(15px);
      font-weight: 600;
    }
  }
  .sku-info-wrap{
    padding: 20px 0;
    .sku-wrap{
      .variant-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        .variant-title{
          font-size: pxTorem(15px);
          font-weight: 600;
        }
        .variant-content{
          flex: 1;
          padding-left: 36px;
          .sku-item{
            display: inline-block;
            border-radius: 2px;
            border: solid 1px #999;
            color: #999;
            margin: 5px 10px 5px 0;
            padding: 3px 18px;
            cursor: pointer;
            position: relative;
            &.active{
              border: solid 1px $mainColor;
              color: $mainColor;
            }
            i {
              position: absolute;
              right: -1px;
              bottom: -1px;
              font-size: pxTorem(20px);
            }
          }
          .input-number{
            width: fit-content;
          }
        }
      }
      .note-block {
        padding: 16px 20px;
        margin: 14px 0;
        border: solid 1px #eaeaea;
        border-radius: 4px;
        .note-title {
          margin-bottom: 8px;
          color: $mainColor;
          font-weight: bold;
        }
      }
    }
  }
  .dialog-footer {
    padding: 20px;
    flex: none;
    display: flex;
    justify-content: space-around;
    .btn {
      padding: 10px 20px;
      border-radius: 4px;
      height: auto;
    }
  }
  .image-carousel {
    position: relative;
    flex: none;
    .carousel {
      background-color: #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    ::v-deep {
      .tns-nav {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        padding: 5px;
        button {
          $size: 10px;
          height: $size;
          width: $size;
          border-radius: 50%;
          background-color: rgba(#000, .2);
          + button {
            margin-left: 5px;
          }
          &.tns-nav-active {
            background-color: rgba(#000, .4);
          }
        }
      }
    }
  }
}
#dialog-shopping-cart{
  .empty-wrap{
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    padding-top: 10%;
    img{
      padding: 20px;
    }
  }
  section:not(:last-child){
    border-bottom: dashed 1px #999;
  }
  .price-option-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    word-break: break-all;
    overflow-wrap: anywhere;
    padding: 15px 10px;
    &:not(:last-child){
      border-bottom: dashed 1px #999;
    }
    .itemWrap{
      width: 60%;
    }
    .itemWrap2 {
      width: 35%;
      padding-left: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .itemWrap2Mobile {
      flex-direction: column;
      align-items: flex-end;
      gap: 15px;
    }
    .price-name {
      display: block;
      font-weight: bold;
      font-size: pxTorem(16px);
      line-height: pxTorem(25px);
    }
    p.desc {
      margin-top: 5px;
      font-weight: 400;
      font-size: pxTorem(15px);
      line-height: pxTorem(20px);
      margin-bottom: 0;
    }
    .price {
      @include price;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: baseline;
      color: $priceColor;
      line-height: pxTorem(29px);
      font-size: pxTorem(26px);
      text-align: right;
      font-variant-numeric: tabular-nums;
      margin: 0;
      span {
        display: inline-block;
      }
      span.price-origin {
        color: $fontColor;
        font-weight: 400;
        font-family: initial;
        line-height: pxTorem(25px);
        font-size: pxTorem(18px);
        text-decoration: line-through;
        margin-left: 12px;
      }
    }
    .selected-num{
      color: $mainColor;
      font-size: pxTorem(15px);
      font-weight: 600;
    }
  }
  .dialog-footer {
    padding: 20px 50px;
    flex: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #484848;
    .btn {
      padding: 10px 20px;
      border-radius: 4px;
      height: auto;
    }
    .price-option-subtotal{
      width: 100%;
      padding: 0 10px;
      margin: 10px 0 30px;
      border: solid 1px #999;
      border-radius: 4px;
      .price{
        color: $priceColor;
        font-weight: 600;
        font-family: Helvetica;
      }
      .price-subtotal{
        font-size: pxTorem(16px);
        border-bottom: dashed 1px #999;
        padding: 10px 3px;
        div{
          display: flex;
          justify-content: space-between;
          padding: 3px 0
        }
        .subtotal-title{
          font-size: pxTorem(18px);
          font-weight: 600;
        }
        .borderBottom {
          border-bottom: 1px solid #999;
          margin-bottom: 5px;
        }
        .price-origin{
          font-family: Helvetica;
          font-weight: 600;
        }
      }
      .price-total{
        display: flex;
        justify-content: space-between;
        font-size: pxTorem(25px);
        font-weight: 600;
        padding: 10px 3px;
        .total-title{
          font-size: pxTorem(20px);
        }
      }
    }
  }
}
// 下訂單 loading
#setorder-loading-dialog {
  .dialog-header {
    text-align: center;
    justify-content: center;
    padding-inline: 40px;
  }
  .dialog-content {
    text-align: center;
    padding: 20px;
  }
  .loading-circle {
  }
}
.shopping-cart-btn{
  position: fixed;
  top: 20%;
  right: 12px;
  background: linear-gradient(131deg, #5BA1C6 5%, #61D5B3 111%);
  color: #fff;
  .text-wrap{
    font-weight: 600;
    padding: 5px 3px;
    .btn-title{
      font-size: pxTorem(17px);
    }
    .btn-desc{
      font-size: pxTorem(13px);
    }
  }
  i{
    font-size: pxTorem(25px);
    &.arrow{
      font-size: pxTorem(20px);
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .page.page-promotion {
    $marginWidth: 14px;
    padding-top: 20px;
    .promotion-option {
      width: calc((100% - #{$marginWidth}) / 2);
      &:nth-child(2n) {
        margin-left: $marginWidth;
      }
      &:nth-child(n+3) {
        margin-top: 12px;
      }
    }
    .tag {
      width: 56px;
      padding: 2px;
      font-size: pxTorem(16px);
      line-height: pxTorem(22px);
    }
    .price {
      font-size: pxTorem(15px);
      line-height: pxTorem(21px);
    }
    .promotion-description {
      padding-top: 20px;
    }
  }
  .dialog {
    .content {
      width: 100%;
      border-radius: 0;
    }
  }
  #dialog-terms {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }
  #dialog-region-select {
    .dialog-content {
      width: 100%;
    }
  }
  .dialog-discount {
    .dialog-content {
      > .item {
        padding-top: 35px;
      }
    }
  }
  .dialog-card {
    i.close {
    }
    .dialog-header {
    }
    .dialog-content {
      width: calc(100% - 10px * 2);
      padding: 0 5px;
    }
    .dialog-footer {
      padding: 0;
      .btn {
        padding: 14px;
        border-radius: 0;
        ::v-deep {
          span {
            font-size: pxTorem(16px);
            line-height: pxTorem(22px);
          }
        }
      }
    }
  }
  .dialog-discount {
    .dialog-footer {
      flex-direction: column-reverse;
      .btn {
        width: 80%;
        margin-left: 0;
        margin-bottom: 10px;
      }
    }
  }
  #dialog-shopping-cart{
    .empty-wrap{
      display: flex;
      flex-direction: column;
    }
    .dialog-footer{
      padding: 20px 0;
      .price-option-subtotal{
        padding: 0 20px;
        border: none;
        border-top: solid 1px #999;
        border-bottom: solid 1px #999;
        border-radius: 0;
      }
    }
  }
  #dialog-selecet-product{
    section {
      padding: 0 5px;
      margin: 0 10px;
    }
    .dialog-content{
      width: 100%;
      padding: 0;
    }
    .productWithImage {
      grid-template-columns: 35% auto;
      grid-template-rows: auto auto;
      column-gap: 10px;
      grid-template-areas:
        "image info"
        "desc desc"
        "sku sku";
      .image-carousel {
        margin-left: 15px;
      }
      .mobile-desc{
        grid-area: desc;
        p{
          padding-top: 20px;
        }
      }
    }
  }
  .alertDialogStyle {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 30px;
    > *:not(:last-child) {
      margin-bottom: 10px;
    }
    img {
      width: 180px;
      height: 180px;
    }
    .headline {
      font-size: 16px !important;
      font-weight: 600;
      padding-top: 15px;
    }
    .message{
      font-size: 15px;
      font-weight: normal;
      padding:12px 0 15px;
    }
    .loading-animation {
      width: 64px;
      height: 64px;
    }
  }
}

/** 手機以上 */
@media screen and (min-width: $mobileWidth) {
  .page.page-promotion {
    $marginWidth: 24px;
    .promotion-option {
      width: calc((100% - #{$marginWidth}) / 2);
      &:nth-child(2n) {
        margin-left: $marginWidth;
      }
      &:nth-child(n+3) {
        margin-top: 16px;
      }
    }
    .tag {
      width: 72px;
      padding: 0 8px;
      font-size: pxTorem(15px);
      line-height: pxTorem(21px);
    }
    .price {
      font-size: pxTorem(14px);
      line-height: pxTorem(20px);
    }
  }
  #dialog-terms {
    height: 90vh;
    height: calc(var(--vh, 1vh) * 90);
  }
  #dialog-region-create {
    .content {
      .item {
        p.label {
          font-weight: bold;
          font-size: pxTorem(17px);
          line-height: pxTorem(24px);
        }
      }
    }
  }
  .dialog-card {
    i.close {
    }
    .dialog-header {
    }
    .dialog-content {
      border-top: none;
      width: calc(100% - 30px * 2);
    }
    .dialog-footer {
      .btn {
        ::v-deep {
          span {
          }
        }
      }
    }
  }
  .dialog-discount {
    .dialog-header {
      flex: none;
    }
    .dialog-content {
      flex: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;
      > .item {
        flex: none;
      }
      .ticket-list {
        flex: 1;
        overflow-y: auto;
      }
    }
    .dialog-footer {
      justify-content: center;
      padding-top: 20px;
      padding-bottom: 30px;
      padding-bottom: max(30px, calc(10px + var(--safe-area-inset-bottom)));
      .btn {
        width: 40%;
        margin-right: 8px;
        ::v-deep {
          span {
            font-size: pxTorem(17px);
            line-height: pxTorem(24px);
          }
        }
      }
    }
  }
  .alertDialogStyle {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 30px 50px;
    > *:not(:last-child) {
      margin-bottom: 10px;
    }
    img {
      width: 200px;
      height: 200px;
    }
    .headline {
      font-size: 17px !important;
      font-weight: 600;
      padding-top: 15px;
    }
    .message{
      font-size: 16px;
      font-weight: normal;
      padding: 12px 0 15px;
    }
    .loading-animation {
      width: 90px;
      height: 90px;
    }
  }
}

/** 其他 */
.dialog-selecet-product{
  .dialog-content{
    padding: 15px 0 40px;
  }
  .btn {
    width: 100%;
  }
  .productWithImage {
    display: grid;
    grid-template-columns: 40% auto;
    grid-auto-rows: min-content auto;
    column-gap: 24px;
    grid-template-areas:
      "image info"
      "image sku"
      "image button";
    .image-carousel {
      grid-area: image;
      align-self: start;
      padding-top: 10px;
    }
    .product-info-wrap {
      grid-area: info;
    }
    .sku-info-wrap {
      grid-area: sku;
    }
    .btnAddToCart-wrap {
      grid-area: button;
      .webAddToCartBtn {
        width: 100%;
      }
    }
  }
  .btnAddToCart {
    flex: 1;
    font-size: pxTorem(18px);
    margin: 0 10px 10px;
  }
}
.dialogPriceColor {
  color: #db2959;
}

.mobileVersionCount {
  display: flex;
  justify-content: space-between;
  padding: 25px 16px;
  border-top: 1px solid $lineColor;
  border-bottom: 1px solid $lineColor;
  &__title {
    font-size: pxTorem(16px);
    font-weight: 600;
  }
}
.underlineText {
  text-decoration: underline;
  cursor: pointer;
}
.syncBuyerInfoCheckbox {
  margin-top: -10px;
  padding-bottom: 10px;
}
.cursorPointer {
  &:hover {
    cursor: pointer;
  }
}
</style>
